
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $a7693d6ebc438a4c$export$de27182ff8187d6c() {
    // 開始頁面效果實現
    try {
        window.effect = VANTA.WAVES({
            el: "#bg",
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            minHeight: 200.0,
            minWidth: 200.0,
            scale: 1.0,
            scaleMobile: 1.0,
            color: 0x932626
        });
    } catch (error) {
    // do nothing
    }
    // 處理開始按鈕的事件
    $("#start-btn").click(function() {
        // 1. 隱藏開始頁面
        $("#start-modal").hide();
        $("#intro").hide();
        // 2. 銷毀背景效果
        window.effect.destroy();
        // 3. 背景音樂處理，必須在按按鈕時才能播放
        window.audio.play();
        if (!window.targetFound) window.audio.pause();
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            $("#start-modal").show();
            $("#warning-text").html(`\u{8ACB}\u{95DC}\u{9589}\u{4E26}\u{91CD}\u{958B}\u{700F}\u{89BD}\u{5668}\u{FF0C}\u{4E26}\u{5141}\u{8A31}\u{6B64}\u{7DB2}\u{9801}\u{4F7F}\u{7528}\u{651D}\u{50CF}\u{982D}\u{6B0A}\u{9650}\u{3002}`);
            $("#warning-camera").hide();
            $("#warning").show();
            return;
        }
        const timer = setTimeout(()=>{
            $("#start-modal").show();
            $("#warning-text").html("");
            $("#warning-camera").show();
            $("#warning").show();
            $("#scene-wrapper").hide();
            $(".mindar-ui-overlay").hide();
        }, 6000);
        const video = document.createElement("video");
        navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
                facingMode: "environment",
                width: {
                    ideal: 640
                },
                height: {
                    ideal: 480
                }
            }
        }).then((stream)=>{
            video.addEventListener("loadedmetadata", ()=>{
                clearTimeout(timer);
                $("#start-modal").hide();
                $("#warning").hide();
                $("#warning-camera").hide();
                $(".mindar-ui-overlay").show();
                console.log("video ready...", video);
                console.log("width", video.videoWidth);
                console.log("height", video.videoHeight);
                // 移除 video
                // 測試完畢後，立即關閉流
                stream.getTracks().forEach((track)=>track.stop());
                // 移除 video 元素
                video.remove();
                // 顯示 ar 頁面
                $("#scene-wrapper").show();
                // 把 ar 頁面加回去
                $("#scene-wrapper").append(window.$scene);
                // 更新进度函数
                // 绑定进度事件到所有的 asset-item 上
                var assets = document.querySelectorAll("a-asset-item");
                const totalArray = [];
                const loadedArray = [];
                for(var i = 0; i < assets.length; i++){
                    let index = i;
                    assets[index].addEventListener("progress", (evt)=>{
                        totalArray[index] = evt.detail.totalBytes;
                        loadedArray[index] = evt.detail.loadedBytes;
                        // console.log(evt.detail, totalArray, loadedArray);
                        const total = 1772336;
                        const loaded = loadedArray.reduce((a, b)=>a + b, 0);
                        // 计算加载的百分比
                        var percentage = loaded / total * 100;
                        // 更新你的自定义加载屏幕上的进度显示
                        $("#progress").text(parseInt(percentage) + "%");
                        $("#progress").css("width", parseInt(percentage) + "%");
                    });
                }
            }, {
                once: true
            });
            video.srcObject = stream;
        }).catch((err)=>{
            console.log("getUserMedia error", err);
            $("#start-modal").show();
            $("#warning-text").html(`\u{8ACB}\u{95DC}\u{9589}\u{4E26}\u{91CD}\u{958B}\u{700F}\u{89BD}\u{5668}\u{FF0C}\u{4E26}\u{5141}\u{8A31}\u{6B64}\u{7DB2}\u{9801}\u{4F7F}\u{7528}\u{651D}\u{50CF}\u{982D}\u{6B0A}\u{9650}\u{3002}`);
            $("#warning-camera").hide();
            $("#warning").show();
        });
    });
    // 參數初始化
    window.score = 0;
    window.place = "unknown";
    window.initialized = false;
    // 處理用戶
    window.userId = localStorage.getItem("userId") || "";
    // 先暫時存一個
    if (!window.userId) localStorage.setItem("userId", "");
    // 無論有沒有用戶都要先 fetch 一次
    fetch("/api/user?id=" + window.userId, {
        method: "POST"
    }).then((response)=>response.json()).then((result)=>{
        const user = result?.data?.user;
        if (user) {
            window.userId = user.id;
            window.score = user.score;
            window.place = user.place || "unknown";
            localStorage.setItem("userId", user.id);
            // $("#score").html(window.score);
            window.initialized = true;
        }
    });
}


var $8ad91e1230fac71f$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $8ad91e1230fac71f$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $8ad91e1230fac71f$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $8ad91e1230fac71f$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $8ad91e1230fac71f$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $8ad91e1230fac71f$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8ad91e1230fac71f$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8ad91e1230fac71f$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8ad91e1230fac71f$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $8ad91e1230fac71f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $8ad91e1230fac71f$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8ad91e1230fac71f$var$root = $8ad91e1230fac71f$var$freeGlobal || $8ad91e1230fac71f$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $8ad91e1230fac71f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8ad91e1230fac71f$var$objectToString = $8ad91e1230fac71f$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8ad91e1230fac71f$var$nativeMax = Math.max, $8ad91e1230fac71f$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $8ad91e1230fac71f$var$now = function() {
    return $8ad91e1230fac71f$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8ad91e1230fac71f$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($8ad91e1230fac71f$var$FUNC_ERROR_TEXT);
    wait = $8ad91e1230fac71f$var$toNumber(wait) || 0;
    if ($8ad91e1230fac71f$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $8ad91e1230fac71f$var$nativeMax($8ad91e1230fac71f$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $8ad91e1230fac71f$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $8ad91e1230fac71f$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($8ad91e1230fac71f$var$now());
    }
    function debounced() {
        var time = $8ad91e1230fac71f$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $8ad91e1230fac71f$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8ad91e1230fac71f$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8ad91e1230fac71f$var$isSymbol(value) {
    return typeof value == "symbol" || $8ad91e1230fac71f$var$isObjectLike(value) && $8ad91e1230fac71f$var$objectToString.call(value) == $8ad91e1230fac71f$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8ad91e1230fac71f$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($8ad91e1230fac71f$var$isSymbol(value)) return $8ad91e1230fac71f$var$NAN;
    if ($8ad91e1230fac71f$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $8ad91e1230fac71f$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($8ad91e1230fac71f$var$reTrim, "");
    var isBinary = $8ad91e1230fac71f$var$reIsBinary.test(value);
    return isBinary || $8ad91e1230fac71f$var$reIsOctal.test(value) ? $8ad91e1230fac71f$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8ad91e1230fac71f$var$reIsBadHex.test(value) ? $8ad91e1230fac71f$var$NAN : +value;
}
$8ad91e1230fac71f$exports = $8ad91e1230fac71f$var$debounce;


function $d25d7ab7a7801bef$export$482310739c8f9d71() {
    if (!window.initialized) return;
    return fetch(`/api/score?userId=${window.userId}&score=${window.score}`, {
        method: "POST"
    }).then((response)=>response.json()).then((result)=>{
        const user = result?.data?.user;
        if (user) {
            if (window.userId !== user.id) {
                window.userId = user.id;
                window.score = user.score;
                window.place = user.place || "unknown";
                localStorage.setItem("userId", user.id);
                $("#score").html(window.score);
            }
        }
    });
}
const $d25d7ab7a7801bef$var$updateScoreDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($8ad91e1230fac71f$exports)))($d25d7ab7a7801bef$export$482310739c8f9d71, 1000);
function $d25d7ab7a7801bef$export$de27182ff8187d6c() {
    window.targetFound = false;
    // AR 場景點擊事件
    AFRAME.registerComponent("cursor-listener", {
        canPlay: true,
        dragonFirstClicked: false,
        init: function() {
            this.el.addEventListener("loaded", ()=>{
                console.log("aframe loaded");
                // 為了讓三維模型先載入
                // 若不加這段，target found 才載入，會有等待的時間
                const root = $("#target")[0]?.object3D;
                if (root && root.visible === false) root.visible = true;
                // 隱藏 custom loading
                var customLoadingScreen = document.getElementById("customLoadingScreen");
                customLoadingScreen.style.display = "none";
            });
            this.el.addEventListener("arReady", ()=>{
                console.log("arReady");
                // 為了讓三維模型先載入
                // 若不加這段，target found 才載入，會有等待的時間
                // 隱藏是為了 target found, 不隱藏的話，target found 會沒有效果
                const root = $("#target")[0]?.object3D;
                if (root && root.visible === true) root.visible = false;
                // 隱藏金幣
                for(let i = 1; i <= 10; i++){
                    const coinEl = document.getElementById("gold" + i);
                    coinEl.setAttribute("visible", "false");
                }
                // 調整攝像頭 video, 加上 styles.css
                // 這是為了解決 ios 低電量模式下，攝像頭會有 play button 出現的問題
                // https://stackoverflow.com/questions/73695619/hide-ios-safari-native-low-power-play-button
                $("#scene-wrapper > video")[0].autoplay = false;
                $("#scene-wrapper > video")[0].pause();
                $("#scene-wrapper > video")[0].play();
                $("#scene-wrapper > video").show();
            });
            // 處理攝像頭權限問題
            this.el.addEventListener("arError", (event)=>{
                if (event && event.detail && event.detail.error === "VIDEO_FAIL") {
                    $("#start-modal").show();
                    $("#warning-text").html(`\u{8ACB}\u{95DC}\u{9589}\u{4E26}\u{91CD}\u{958B}\u{700F}\u{89BD}\u{5668}\u{FF0C}\u{4E26}\u{5141}\u{8A31}\u{6B64}\u{7DB2}\u{9801}\u{4F7F}\u{7528}\u{651D}\u{50CF}\u{982D}\u{6B0A}\u{9650}\u{3002}`);
                    $("#warning-camera").hide();
                    $("#warning").show();
                    // 隱藏 mind-ar loading 畫面
                    $(".mindar-ui-overlay").hide();
                }
            });
            for(let i = 1; i <= 10; i++){
                const coinEl = document.getElementById("gold" + i);
                let index = i;
                coinEl.addEventListener("click", ()=>{
                    if (!window.firstClicked) {
                        window.firstClicked = true;
                        $("#score-wrapper").fadeIn();
                    }
                    // play sound
                    window.clickSound.play();
                    window.score += 1;
                    $("#score").html(window.score);
                    coinEl.setAttribute("visible", "false");
                    $("#gold" + index + "-box").removeClass("clickable");
                    $d25d7ab7a7801bef$var$updateScoreDebounced();
                });
            }
            const boxEl = document.getElementById("dragon-box");
            boxEl.addEventListener("click", ()=>{
                if (this.dragonFirstClicked === false) {
                    this.dragonFirstClicked = true;
                    $("#click-tips").fadeOut();
                }
                if (this.canPlay === false) return;
                this.canPlay = false;
                $("#dragon-box").removeClass("clickable");
                // play sound
                window.coins.play();
                // dragon animation
                const dragonEl = document.getElementById("dragon");
                dragonEl.setAttribute("animation__scaleup", {
                    property: "scale",
                    to: `0.035 0.035 0.035`,
                    dur: 250,
                    easing: "easeInQuad"
                });
                dragonEl.setAttribute("animation__scaledown", {
                    property: "scale",
                    from: "0.035 0.035 0.035",
                    to: `0.04 0.04 0.04`,
                    delay: 250,
                    dur: 250,
                    easing: "easeOutQuad"
                });
                dragonEl.setAttribute("animation__scaleorigin", {
                    property: "scale-origin",
                    to: "center"
                });
                setTimeout(()=>{
                    dragonEl.removeAttribute("animation__scaleup");
                    dragonEl.removeAttribute("animation__scaledown");
                }, 3000);
                const position = {
                    x: 0,
                    y: -0.7,
                    z: 0
                };
                for(let i = 1; i <= 10; i++){
                    const coinEl = document.getElementById("gold" + i);
                    $("#gold" + i + "-box").addClass("clickable");
                    coinEl.setAttribute("visible", "true");
                    coinEl.setAttribute("position", `${position.x} ${position.y} ${position.z}`);
                    // Randomize the direction and strength of the "pop" effect
                    const x = (Math.random() - 0.5) * 2.2;
                    const y = Math.random() * 1 + 1;
                    const z = (Math.random() - 0.5) * 1;
                    // Randomize rotation for a more natural effect
                    const rx = Math.random() * 360;
                    const ry = Math.random() * 360;
                    const rz = Math.random() * 360;
                    coinEl.setAttribute("rotation", `${rx} ${ry} ${rz}`);
                    const scale = Math.random() * 0.1 + 0.15;
                    coinEl.setAttribute("scale", `${scale} ${scale} ${scale}`);
                    // Create the animation for the coin to move up and then down
                    coinEl.setAttribute("animation__up", {
                        property: "position",
                        to: `${position.x + x} ${position.y + y + 0.2} ${position.z + z + 1}`,
                        dur: 1500,
                        easing: "easeOutQuad"
                    });
                    coinEl.setAttribute("animation__down", {
                        property: "position",
                        from: `${position.x + x} ${position.y + y + 0.2} ${position.z + z + 1}`,
                        to: `${position.x + x} ${position.y} ${position.z + z + 1}`,
                        delay: 1500,
                        dur: 1500,
                        easing: "easeInQuad"
                    });
                    setTimeout(()=>{
                        coinEl.setAttribute("visible", "false");
                        $("#dragon-box").addClass("clickable");
                        for(let i = 1; i <= 10; i++)$("#gold" + i + "-box").removeClass("clickable");
                        this.canPlay = true;
                    }, 3000);
                }
            });
            // targetFound and lost 事件, 處理背景音樂
            const target = document.getElementById("target");
            target.addEventListener("targetFound", ()=>{
                window.audio.play();
                window.targetFound = true;
                console.log("targetFound!!!");
                if (!window.isModalOpen && window.firstClicked) $("#score-wrapper").fadeIn();
                $("#rank-btn").fadeIn();
                $("#place-btn").fadeIn();
                $("#photo-btn").fadeIn();
                if (this.dragonFirstClicked === false) $("#click-tips").fadeIn();
            });
            // detect target lost
            target.addEventListener("targetLost", ()=>{
                window.audio.currentTime = 0;
                window.audio.pause();
                window.targetFound = false;
                console.log("targetLost!!!");
                $("#score-wrapper").fadeOut();
                $("#rank-btn").fadeOut();
                $("#place-btn").fadeOut();
                $("#photo-btn").fadeOut();
                if (this.dragonFirstClicked === false) $("#click-tips").hide();
            });
        }
    });
}


// 添加輝哥的瀏覽器提示
// https://github.com/withcloud/mindar-congratulations-picture-demo/blob/browser/src/index.html
const $92dc8dbec6af1b1e$var$browser = {
    // 版本信息
    versions: function() {
        var u = navigator.userAgent;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1,
            presto: u.indexOf("Presto") > -1,
            webKit: u.indexOf("AppleWebKit") > -1,
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
            mobile: !!u.match(/AppleWebKit.*Mobile.*/),
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1,
            iPhone: u.indexOf("iPhone") > -1,
            iPad: u.indexOf("iPad") > -1,
            webApp: u.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
        };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    // 打開對象
    openObject: function() {
        var ua = navigator.userAgent;
        var u = navigator.userAgent.toLowerCase(); //获取判断用的对象
        return {
            weixin: u.match(/MicroMessenger/i) == "micromessenger",
            qq: u.match(/QQ/i) == "qq",
            weibo: u.match(/WeiBo/i) == "weibo",
            alipay: /alipay/gi.test(u),
            dingtalk: u.indexOf("dingtalk") !== -1,
            chrome: u.indexOf("Chrome") > -1,
            isChrome: /(?:Chrome|CriOS)/.test(ua),
            isSafari: /Safari/.test(ua),
            baidui: u.indexOf("baidu") > 0,
            ios: /iphone|ipod|ipad/.test(u)
        };
    }()
};
function $92dc8dbec6af1b1e$var$checkWebGLSupport() {
    var canvas = document.createElement("canvas");
    var webgl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
    if (webgl && webgl instanceof WebGLRenderingContext) {
        // 瀏覽器支持 WebGL，Three.js 應該也能運行
        console.log("WebGL is supported, Three.js should also be supported.");
        return true;
    } else {
        // 瀏覽器不支持 WebGL，Three.js 將無法運行
        console.log("WebGL is not supported, Three.js will not be able to run.");
        return false;
    }
}
function $92dc8dbec6af1b1e$export$de27182ff8187d6c() {
    // 不斷顯示三維模型
    // setInterval(() => {
    //   const root = $("#target")[0]?.object3D;
    //   if (root && root.visible === false) {
    //     root.visible = true;
    //   }
    // }, 1000);
    // disable mobile browser 的 pinch zoom 和 double tap zoom
    // https://stackoverflow.com/a/66798697
    let drags = new Set(); //set of all active drags
    document.addEventListener("touchmove", function(event) {
        if (!event.isTrusted) return; //don't react to fake touches
        Array.from(event.changedTouches).forEach(function(touch) {
            drags.add(touch.identifier); //mark this touch as a drag
        });
    });
    document.addEventListener("touchend", function(event) {
        if (!event.isTrusted) return;
        let isDrag = false;
        Array.from(event.changedTouches).forEach(function(touch) {
            if (drags.has(touch.identifier)) isDrag = true;
            drags.delete(touch.identifier); //touch ended, so delete it
        });
        if (!isDrag && document.activeElement == document.body) {
            //note that double-tap only happens when the body is active
            event.preventDefault(); //don't zoom
            event.stopPropagation(); //don't relay event
            event.target.focus(); //in case it's an input element
            event.target.click(); //in case it has a click handler
            event.target.dispatchEvent(new TouchEvent("touchend", event));
        //dispatch a copy of this event (for other touch handlers)
        }
    });
    // 添加屏幕轉向監控
    const screenDirection = window.innerHeight > window.innerWidth;
    setInterval(()=>{
        if (screenDirection !== window.innerHeight > window.innerWidth) window.location.reload();
    }, 1000);
    window.hasWarning = false;
    // checkout browser
    // 微信檢查
    // 移動端
    if (!window.hasWarning) {
        if (/Android|Adr|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) //非ios處理  chrome  safari weixin
        {
            if ($92dc8dbec6af1b1e$var$browser.versions.mobile) {
                if ($92dc8dbec6af1b1e$var$browser.openObject.weixin) {
                    window.hasWarning = true;
                    $("#warning-text").html(`\u{9EDE}\u{64CA}\u{53F3}\u{4E0A}\u{89D2} \u{201C}\u{4E09}\u{500B}\u{9EDE} \u{2026} \u{201D} \u{6309}\u{9215}\u{FF0C}
          <br />
          \u{4E26}\u{9078}\u{64C7} \u{201C}\u{5728}\u{9810}\u{8A2D}\u{700F}\u{89BD}\u{5668}\u{4E2D}\u{6253}\u{958B}\u{201D}\u{3002}`);
                } else $92dc8dbec6af1b1e$var$browser.openObject.dingtalk || $92dc8dbec6af1b1e$var$browser.openObject.qq || $92dc8dbec6af1b1e$var$browser.openObject.baidui;
            }
        }
    }
    // check webgl
    if (!window.hasWarning) {
        if ($92dc8dbec6af1b1e$var$checkWebGLSupport() === false) {
            window.hasWarning = true;
            $("#warning-text").html(`\u{62B1}\u{6B49}\u{FF0C}\u{60A8}\u{7684}\u{700F}\u{89BD}\u{5668}\u{4E0D}\u{652F}\u{6301} WebGL\u{3002}<br />\u{8ACB}\u{5617}\u{8A66}\u{4F7F}\u{7528}\u{5176}\u{4ED6}\u{700F}\u{89BD}\u{5668}\u{6AA2}\u{8996}\u{6B64}\u{7DB2}\u{9801}\u{3002}<br />(\u{4F8B}\u{5982} Google Chrome \u{700F}\u{89BD}\u{5668})`);
        }
    }
    if (window.hasWarning) {
        $("#intro").hide();
        $("#warning-camera").hide();
        $("#warning").show();
    } else $("#intro").fadeIn();
    // 為了解決手機瀏覽器上一頁下一頁的 bf cache 問題
    window.addEventListener("pageshow", function(event) {
        if (event.persisted) window.location.reload();
    });
}


var $d360de08f15b493a$export$c9d39ca3bcd93abb;
var $d360de08f15b493a$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = "canplaythrough";
            self._navigator = typeof window !== "undefined" && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== "undefined") {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, "")];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || "suspended" : "suspended";
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== "undefined") try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === "undefined") self._canPlayEvent = "canplay";
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== "undefined" ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== "function") return self;
            var mpegTest = audioTest.canPlayType("audio/mpeg;").replace(/^no$/, "");
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : "";
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split("/")[1], 10) < 33;
            var checkSafari = ua.indexOf("Safari") !== -1 && ua.indexOf("Chrome") === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType("audio/wav")).replace(/^no$/, ""),
                aac: !!audioTest.canPlayType("audio/aac;").replace(/^no$/, ""),
                caf: !!audioTest.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                m4a: !!(audioTest.canPlayType("audio/x-m4a;") || audioTest.canPlayType("audio/m4a;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                m4b: !!(audioTest.canPlayType("audio/x-m4b;") || audioTest.canPlayType("audio/m4b;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                mp4: !!(audioTest.canPlayType("audio/x-mp4;") || audioTest.canPlayType("audio/mp4;") || audioTest.canPlayType("audio/aac;")).replace(/^no$/, ""),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                flac: !!(audioTest.canPlayType("audio/x-flac;") || audioTest.canPlayType("audio/flac;")).replace(/^no$/, "")
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === "undefined") source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === "function") self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener("touchstart", unlock, true);
                    document.removeEventListener("touchend", unlock, true);
                    document.removeEventListener("click", unlock, true);
                    document.removeEventListener("keydown", unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("unlock");
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener("touchstart", unlock, true);
            document.addEventListener("touchend", unlock, true);
            document.addEventListener("click", unlock, true);
            document.addEventListener("keydown", unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== "undefined" && (testPlay instanceof Promise || typeof testPlay.then === "function")) testPlay.catch(function() {
                console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === "undefined" || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = "suspending";
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = "suspended";
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === "undefined" || !Howler1.usingWebAudio) return;
            if (self.state === "running" && self.ctx.state !== "interrupted" && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === "suspended" || self.state === "running" && self.ctx.state === "interrupted") {
                self.ctx.resume().then(function() {
                    self.state = "running";
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit("resume");
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === "suspending") self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error("An array of source files must be passed with any new Howl.");
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== "string" ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === "boolean" || o.preload === "metadata" ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== "string" ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : "GET",
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = "unloaded";
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== "undefined" && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: "play",
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== "none") self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit("loaderror", null, "No audio support.");
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === "string") self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== "string") {
                        self._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split("?", 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit("loaderror", null, "No codec support for selected audio sources.");
                return;
            }
            self._src = url;
            self._state = "loading";
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === "https:" && url.slice(0, 5) === "http:") {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === "number") {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === "string" && self._state === "loaded" && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === "undefined") {
                // Use the default sound sprite (plays the full audio length).
                sprite = "__default";
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || "__default";
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== "loaded") {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: "play",
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue("play");
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === "undefined") sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit("play", sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === "running" && Howler1.ctx.state !== "interrupted") playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once("resume", playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== "undefined" && (play instanceof Promise || typeof play.then === "function")) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit("play", sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit("play", sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit("playerror", sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== "__default" || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener("ended", self._endTimers[sound._id], false);
                            };
                            node.addEventListener("ended", self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit("playerror", sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA") {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = "loading";
                    var listener = function() {
                        self._state = "loaded";
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "pause",
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit("pause", sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "stop",
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === "undefined") sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit("stop", sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "mute",
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === "undefined") {
                if (typeof muted === "boolean") self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit("mute", sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === "undefined") {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== "undefined" && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "volume",
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === "undefined") self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit("volume", sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== "loaded" || self._playLock) {
                self._queue.push({
                    event: "fade",
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === "undefined");
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit("fade", sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit("fade", id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === "boolean") {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === "number") {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== "loaded" || self._playLock) {
                    self._queue.push({
                        event: "rate",
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === "undefined") self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit("rate", sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === "undefined") return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === "number" && (self._state !== "loaded" || self._playLock)) {
                self._queue.push({
                    event: "seek",
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === "number" && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit("seek", id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === "number") {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener("error", sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener("ended", sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = "unloaded";
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self["_on" + event];
            if (typeof fn === "function") events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self["_on" + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === "number") {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self["_on" + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf("_on") === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self["_on" + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === "load") {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit("end", sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit("play", sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== "function") clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener("ended", self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === "undefined") {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf("Apple") >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA";
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener("error", self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener("ended", self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? "auto" : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = "__default";
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit("loaderror", self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener("error", self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== "loaded") {
                parent._state = "loaded";
                parent._emit("load");
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener("ended", self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(",")[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = "arraybuffer";
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + "")[0];
                if (code !== "0" && code !== "2" && code !== "3") {
                    self._emit("loaderror", null, "Failed loading audio file with status: " + xhr.status + ".");
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit("loaderror", null, "Decoding audio data failed.");
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== "undefined" && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== "loaded") {
            self._state = "loaded";
            self._emit("load");
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== "undefined") Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== "undefined") Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === "undefined" ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === "function" && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $d360de08f15b493a$export$c9d39ca3bcd93abb = Howler1;
    $d360de08f15b493a$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== "undefined") {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== "undefined") {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    "use strict";
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._pos[1] : y;
        z = typeof z !== "number" ? self._pos[2] : z;
        if (typeof x === "number") {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== "undefined") {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== "number" ? or[1] : y;
        z = typeof z !== "number" ? or[2] : z;
        xUp = typeof xUp !== "number" ? or[3] : xUp;
        yUp = typeof yUp !== "number" ? or[4] : yUp;
        zUp = typeof zUp !== "number" ? or[5] : zUp;
        if (typeof x === "number") {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== "undefined") {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : "inverse",
                maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : "HRTF",
                refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "stereo",
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === "undefined" ? "spatial" : "stereo";
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === "number") {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === "number") {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = "equalpower";
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === "spatial") {
                            if (typeof sound._panner.positionX !== "undefined") {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit("stereo", sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "pos",
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? 0 : y;
        z = typeof z !== "number" ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === "number") self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, "spatial");
                        if (typeof sound._panner.positionX !== "undefined") {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit("pos", sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== "loaded") {
            self._queue.push({
                event: "orientation",
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== "number" ? self._orientation[1] : y;
        z = typeof z !== "number" ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === "undefined") {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === "number") self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === "number") {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, "spatial");
                        }
                        if (typeof sound._panner.orientationX !== "undefined") {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit("orientation", sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === "object") {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === "undefined") {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== "undefined" ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== "undefined" ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== "undefined" ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== "undefined" ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== "undefined" ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== "undefined" ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== "undefined" ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== "undefined" ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== "undefined" ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== "undefined" ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== "undefined" ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== "undefined" ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== "undefined" ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== "undefined" ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== "undefined" ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== "undefined" ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, "spatial");
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || "spatial";
        // Create the new panner node.
        if (type === "spatial") {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== "undefined") {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== "undefined") {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();


function $c80f86bf07cd69c6$export$de27182ff8187d6c() {
    window.audio = new Audio("bg.mp3");
    window.audio.loop = true;
    window.coins = new (0, $d360de08f15b493a$export$b791fe48eec8032a)({
        src: [
            "coins.mp3"
        ]
    });
    window.clickSound = new (0, $d360de08f15b493a$export$b791fe48eec8032a)({
        src: [
            "click.mp3"
        ]
    });
}


/*!
 * DiceBear (@dicebear/core)
 *
 * Code licensed under MIT (https://github.com/dicebear/dicebear/blob/main/LICENSE)
 * Copyright (c) 2023 Florian Körner
 */ var $6e22c4c7d2dfb703$exports = {};

$parcel$export($6e22c4c7d2dfb703$exports, "xml", function () { return $6e22c4c7d2dfb703$export$f2913fe8983302e; });
function $6e22c4c7d2dfb703$export$f2913fe8983302e(content) {
    return content.replace(/&/g, "&amp;").replace(/'/g, "&apos;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


function $149b2aa935ea78d3$export$f2913fe8983302e(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const title = (_b = (_a = style.meta) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : "Unnamed";
    const creator = (_d = (_c = style.meta) === null || _c === void 0 ? void 0 : _c.creator) !== null && _d !== void 0 ? _d : "Unknown";
    let description = `"${title}" by "${creator}"`;
    if ((_f = (_e = style.meta) === null || _e === void 0 ? void 0 : _e.license) === null || _f === void 0 ? void 0 : _f.name) description += `, licensed under "${style.meta.license.name}".`;
    description += " / Remix of the original. - Created with dicebear.com";
    const xmlTitle = `<dc:title>${$6e22c4c7d2dfb703$export$f2913fe8983302e(title)}</dc:title>`;
    const xmlCreator = "<dc:creator>" + `<cc:Agent rdf:about="${$6e22c4c7d2dfb703$export$f2913fe8983302e((_h = (_g = style.meta) === null || _g === void 0 ? void 0 : _g.homepage) !== null && _h !== void 0 ? _h : "")}">` + `<dc:title>${$6e22c4c7d2dfb703$export$f2913fe8983302e(creator)}</dc:title>` + "</cc:Agent>" + "</dc:creator>";
    const xmlSource = ((_j = style.meta) === null || _j === void 0 ? void 0 : _j.source) ? `<dc:source>${$6e22c4c7d2dfb703$export$f2913fe8983302e(style.meta.source)}</dc:source>` : "";
    const xmlLicense = ((_l = (_k = style.meta) === null || _k === void 0 ? void 0 : _k.license) === null || _l === void 0 ? void 0 : _l.url) ? `<cc:license rdf:resource="${$6e22c4c7d2dfb703$export$f2913fe8983302e(style.meta.license.url)}" />` : "";
    return `<desc>${description}</desc>` + "<metadata" + ' xmlns:dc="http://purl.org/dc/elements/1.1/"' + ' xmlns:cc="http://creativecommons.org/ns#"' + ' xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">' + "<rdf:RDF>" + "<cc:Work>" + xmlTitle + xmlCreator + xmlSource + xmlLicense + "</cc:Work>" + "</rdf:RDF>" + "</metadata>";
}
function $149b2aa935ea78d3$export$b93978211a9eff5f(style) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const title = (_b = (_a = style.meta) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : "Unnamed";
    const creator = (_d = (_c = style.meta) === null || _c === void 0 ? void 0 : _c.creator) !== null && _d !== void 0 ? _d : "Unknown";
    let copyright = `"${title}" by "${creator}"`;
    if ((_f = (_e = style.meta) === null || _e === void 0 ? void 0 : _e.license) === null || _f === void 0 ? void 0 : _f.name) copyright += `, licensed under "${style.meta.license.name}".`;
    copyright += " / Remix of the original.";
    const exif = {
        ImageDescription: `${copyright} - Created with dicebear.com`,
        Copyright: copyright,
        "XMP-dc:Title": title,
        "XMP-dc:Creator": creator
    };
    if ((_g = style.meta) === null || _g === void 0 ? void 0 : _g.source) exif["XMP-dc:Source"] = style.meta.source;
    if ((_j = (_h = style.meta) === null || _h === void 0 ? void 0 : _h.license) === null || _j === void 0 ? void 0 : _j.url) exif["XMP-cc:License"] = style.meta.license.url;
    return exif;
}




const $ed96386980c45b26$var$MIN = -2147483648;
const $ed96386980c45b26$var$MAX = 2147483647;
function $ed96386980c45b26$var$xorshift(value) {
    value ^= value << 13;
    value ^= value >> 17;
    value ^= value << 5;
    return value;
}
function $ed96386980c45b26$var$hashSeed(seed) {
    let hash = 0;
    for(let i = 0; i < seed.length; i++){
        hash = (hash << 5) - hash + seed.charCodeAt(i) | 0;
        hash = $ed96386980c45b26$var$xorshift(hash);
    }
    return hash;
}
function $ed96386980c45b26$export$185802fd694ee1f5(seed = "") {
    // Ensure that seed is a string
    seed = seed.toString();
    let value = $ed96386980c45b26$var$hashSeed(seed) || 1;
    const next = ()=>value = $ed96386980c45b26$var$xorshift(value);
    const integer = (min, max)=>{
        return Math.floor((next() - $ed96386980c45b26$var$MIN) / ($ed96386980c45b26$var$MAX - $ed96386980c45b26$var$MIN) * (max + 1 - min) + min);
    };
    return {
        seed: seed,
        next: next,
        bool (likelihood = 50) {
            return integer(0, 100) <= likelihood;
        },
        integer (min, max) {
            return integer(min, max);
        },
        pick (arr, fallback) {
            var _a;
            if (arr.length === 0) {
                next();
                return fallback;
            }
            return (_a = arr[integer(0, arr.length - 1)]) !== null && _a !== void 0 ? _a : fallback;
        },
        shuffle (arr) {
            // Each method call should call the `next` function only once.
            // Therefore, we use a separate instance of the PRNG here.
            const internalPrng = $ed96386980c45b26$export$185802fd694ee1f5(next().toString());
            return arr.sort(()=>internalPrng.integer(-1, 1));
        },
        string (length, characters = "abcdefghijklmnopqrstuvwxyz1234567890") {
            // Each method call should call the `next` function only once.
            // Therefore, we use a separate instance of the PRNG here.
            const internalPrng = $ed96386980c45b26$export$185802fd694ee1f5(next().toString());
            let str = "";
            for(let i = 0; i < length; i++)str += characters[internalPrng.integer(0, characters.length - 1)];
            return str;
        }
    };
}


function $1ee8f7521f7b63a8$export$d2a32b662cec697e(result) {
    let viewBox = result.attributes["viewBox"].split(" ");
    let x = parseInt(viewBox[0]);
    let y = parseInt(viewBox[1]);
    let width = parseInt(viewBox[2]);
    let height = parseInt(viewBox[3]);
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $1ee8f7521f7b63a8$export$96009b6564b80064(result, primaryColor, secondaryColor, type, rotation) {
    let { width: width, height: height, x: x, y: y } = $1ee8f7521f7b63a8$export$d2a32b662cec697e(result);
    const solidBackground = `<rect fill="${primaryColor}" width="${width}" height="${height}" x="${x}" y="${y}" />`;
    switch(type){
        case "solid":
            return solidBackground + result.body;
        case "gradientLinear":
            return `<rect fill="url(#backgroundLinear)" width="${width}" height="${height}" x="${x}" y="${y}" />` + `<defs>` + `<linearGradient id="backgroundLinear" gradientTransform="rotate(${rotation} 0.5 0.5)">` + `<stop stop-color="${primaryColor}"/>` + `<stop offset="1" stop-color="${secondaryColor}"/>` + `</linearGradient>` + `</defs>` + result.body;
    }
}
function $1ee8f7521f7b63a8$export$c834547aca49957b(result, scale) {
    let { width: width, height: height, x: x, y: y } = $1ee8f7521f7b63a8$export$d2a32b662cec697e(result);
    let percent = scale ? (scale - 100) / 100 : 0;
    let translateX = (width / 2 + x) * percent * -1;
    let translateY = (height / 2 + y) * percent * -1;
    return `<g transform="translate(${translateX} ${translateY}) scale(${scale / 100})">${result.body}</g>`;
}
function $1ee8f7521f7b63a8$export$d6f5f87d27cbbe0f(result, x, y) {
    let viewBox = $1ee8f7521f7b63a8$export$d2a32b662cec697e(result);
    let translateX = (viewBox.width + viewBox.x * 2) * ((x !== null && x !== void 0 ? x : 0) / 100);
    let translateY = (viewBox.height + viewBox.y * 2) * ((y !== null && y !== void 0 ? y : 0) / 100);
    return `<g transform="translate(${translateX} ${translateY})">${result.body}</g>`;
}
function $1ee8f7521f7b63a8$export$38df2acdbfbce309(result, rotate) {
    let { width: width, height: height, x: x, y: y } = $1ee8f7521f7b63a8$export$d2a32b662cec697e(result);
    return `<g transform="rotate(${rotate}, ${width / 2 + x}, ${height / 2 + y})">${result.body}</g>`;
}
function $1ee8f7521f7b63a8$export$90015ee4a3937667(result) {
    let { width: width, x: x } = $1ee8f7521f7b63a8$export$d2a32b662cec697e(result);
    return `<g transform="scale(-1 1) translate(${width * -1 - x * 2} 0)">${result.body}</g>`;
}
function $1ee8f7521f7b63a8$export$e3f2409025136fe9(result, radius) {
    let { width: width, height: height, x: x, y: y } = $1ee8f7521f7b63a8$export$d2a32b662cec697e(result);
    let rx = radius ? width * radius / 100 : 0;
    let ry = radius ? height * radius / 100 : 0;
    return `<mask id="viewboxMask">` + `<rect width="${width}" height="${height}" rx="${rx}" ry="${ry}" x="${x}" y="${y}" fill="#fff" />` + `</mask>` + `<g mask="url(#viewboxMask)">${result.body}</g>`;
}
function $1ee8f7521f7b63a8$export$d29d121524f3ec8b(result) {
    const attributes = {
        xmlns: "http://www.w3.org/2000/svg",
        ...result.attributes
    };
    return Object.keys(attributes).map((attr)=>`${$6e22c4c7d2dfb703$export$f2913fe8983302e(attr)}="${$6e22c4c7d2dfb703$export$f2913fe8983302e(attributes[attr])}"`).join(" ");
}
function $1ee8f7521f7b63a8$export$2ba3a9bda0f98b60(result) {
    const prng = (0, $ed96386980c45b26$export$185802fd694ee1f5)();
    const ids = {};
    return result.body.replace(/(id="|url\(#)([a-z0-9-_]+)([")])/gi, (match, m1, m2, m3)=>{
        ids[m2] = ids[m2] || prng.string(8);
        return `${m1}${ids[m2]}${m3}`;
    });
}


const $b85c71b8bbbf148f$export$4902baddc787debb = {
    type: "object",
    $schema: "http://json-schema.org/draft-07/schema#",
    properties: {
        seed: {
            type: "string"
        },
        flip: {
            type: "boolean",
            default: false
        },
        rotate: {
            type: "integer",
            minimum: 0,
            maximum: 360,
            default: 0
        },
        scale: {
            type: "integer",
            minimum: 0,
            maximum: 200,
            default: 100
        },
        radius: {
            type: "integer",
            minimum: 0,
            maximum: 50,
            default: 0
        },
        size: {
            type: "integer",
            minimum: 1
        },
        backgroundColor: {
            type: "array",
            items: {
                type: "string",
                pattern: "^(transparent|[a-fA-F0-9]{6})$"
            }
        },
        backgroundType: {
            type: "array",
            items: {
                type: "string",
                enum: [
                    "solid",
                    "gradientLinear"
                ]
            },
            default: [
                "solid"
            ]
        },
        backgroundRotation: {
            type: "array",
            items: {
                type: "integer",
                minimum: -360,
                maximum: 360
            },
            default: [
                0,
                360
            ]
        },
        translateX: {
            type: "integer",
            minimum: -100,
            maximum: 100,
            default: 0
        },
        translateY: {
            type: "integer",
            minimum: -100,
            maximum: 100,
            default: 0
        },
        clip: {
            type: "boolean",
            default: true
        },
        randomizeIds: {
            type: "boolean",
            default: false,
            examples: [
                true,
                false
            ]
        }
    }
};


function $13e609f3a6f81825$export$ebe90cb607ad99e(schema) {
    var _a;
    let result = {};
    let props = (_a = schema.properties) !== null && _a !== void 0 ? _a : {};
    Object.keys(props).forEach((key)=>{
        let val = props[key];
        if (typeof val === "object" && undefined !== val.default) {
            if (Array.isArray(val.default)) result[key] = [
                ...val.default
            ];
            else if (typeof val.default === "object") result[key] = {
                ...val.default
            };
            else result[key] = val.default;
        }
    });
    return result;
}
function $13e609f3a6f81825$export$4950aa0f605343fb(style, options) {
    var _a;
    let result = {
        ...$13e609f3a6f81825$export$ebe90cb607ad99e((0, $b85c71b8bbbf148f$export$4902baddc787debb)),
        ...$13e609f3a6f81825$export$ebe90cb607ad99e((_a = style.schema) !== null && _a !== void 0 ? _a : {}),
        ...options
    };
    // Return a complete copy because the styles could partially customize the
    // options and thus modify nested objects and arrays.
    return JSON.parse(JSON.stringify(result));
}




/*!
 * DiceBear Converter (@dicebear/converter)
 *
 * Code licensed under MIT (https://github.com/dicebear/dicebear/blob/main/LICENSE)
 * Copyright (c) 2023 Florian Körner
 */ function $8e1c3e6d0a6e0200$export$200548c990602f61(format) {
    switch(format){
        case "svg":
            return "image/svg+xml";
        case "png":
        case "jpeg":
            return `image/${format}`;
        default:
            throw new Error(`Unsupported format: ${format}`);
    }
}


function $2d40d2325045c5eb$export$b8443e9e8396a588(svg, defaultSize = 512) {
    let size = defaultSize;
    svg = svg.replace(/<svg([^>]*)/, (match, g1)=>{
        const found = g1.match(/width="([^"]+)"/);
        if (found) size = parseInt(found[1]);
        if (g1.match(/width="([^"]+)"/)) g1 = g1.replace(/width="([^"]+)"/, `width="${size}"`);
        else g1 += ` width="${size}"`;
        if (g1.match(/height="([^"]+)"/)) g1 = g1.replace(/height="([^"]+)"/, `height="${size}"`);
        else g1 += ` height="${size}"`;
        return `<svg${g1}`;
    });
    return {
        svg: svg,
        size: size
    };
}


let $d1e54ac561190bf6$var$encoder;
function $d1e54ac561190bf6$export$7f461c6e7363c832() {
    if (!$d1e54ac561190bf6$var$encoder) $d1e54ac561190bf6$var$encoder = new TextEncoder();
    return $d1e54ac561190bf6$var$encoder;
}


const $d9edf3f87c434303$export$67da4c19e99f01f3 = function(svg, format, exif) {
    return {
        toDataUri: ()=>$d9edf3f87c434303$var$toDataUri(svg, format, exif),
        toFile: (name)=>$d9edf3f87c434303$var$toFile(name, svg, format, exif),
        toArrayBuffer: ()=>$d9edf3f87c434303$var$toArrayBuffer(svg, format, exif)
    };
};
async function $d9edf3f87c434303$var$toDataUri(svg, format, exif) {
    if ("svg" === format) return `data:${(0, $8e1c3e6d0a6e0200$export$200548c990602f61)(format)};utf8,${encodeURIComponent(svg)}`;
    const canvas = await $d9edf3f87c434303$var$toCanvas(svg, format, exif);
    return canvas.toDataURL((0, $8e1c3e6d0a6e0200$export$200548c990602f61)(format));
}
async function $d9edf3f87c434303$var$toArrayBuffer(rawSvg, format, exif) {
    if ("svg" === format) return (0, $d1e54ac561190bf6$export$7f461c6e7363c832)().encode(rawSvg);
    const canvas = await $d9edf3f87c434303$var$toCanvas(rawSvg, format, exif);
    return await new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            blob ? resolve(blob.arrayBuffer()) : reject(new Error("Could not create blob"));
        }, (0, $8e1c3e6d0a6e0200$export$200548c990602f61)(format));
    });
}
async function $d9edf3f87c434303$var$toFile(name, svg, format, exif) {
    const link = document.createElement("a");
    link.href = await $d9edf3f87c434303$var$toDataUri(svg, format, exif);
    link.download = name;
    link.click();
    link.remove();
}
async function $d9edf3f87c434303$var$toCanvas(rawSvg, format, exif) {
    if (exif) console.warn("The `exif` option is not supported in the browser version of `@dicebear/converter`. \nPlease use the node version of `@dicebear/converter` to generate images with exif data.");
    let { svg: svg, size: size } = (0, $2d40d2325045c5eb$export$b8443e9e8396a588)(rawSvg);
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const context = canvas.getContext("2d");
    if (null === context) throw new Error("Could not get canvas context");
    if (format === "jpeg") {
        context.fillStyle = "white";
        context.fillRect(0, 0, size, size);
    }
    var img = document.createElement("img");
    img.width = size;
    img.height = size;
    img.setAttribute("src", await $d9edf3f87c434303$var$toDataUri(svg, "svg"));
    return new Promise((resolve, reject)=>{
        img.onload = ()=>{
            context.drawImage(img, 0, 0, size, size);
            resolve(canvas);
        };
        img.onerror = (e)=>reject(e);
    });
}






function $673866ec6a102e6a$export$6d1b0a04fee90d44(color) {
    return "transparent" === color ? color : `#${color}`;
}
function $673866ec6a102e6a$export$4fb0a19bb1541fbc(prng, backgroundColor) {
    var _a;
    let shuffledBackgroundColors;
    if (backgroundColor.length <= 2) {
        // A function call should in any case make an identical number of calls to the PRNG.
        prng.next();
        shuffledBackgroundColors = backgroundColor;
    } else shuffledBackgroundColors = prng.shuffle(backgroundColor);
    if (shuffledBackgroundColors.length === 0) shuffledBackgroundColors = [
        "transparent"
    ];
    const primary = shuffledBackgroundColors[0];
    const secondary = (_a = shuffledBackgroundColors[1]) !== null && _a !== void 0 ? _a : shuffledBackgroundColors[0];
    return {
        primary: $673866ec6a102e6a$export$6d1b0a04fee90d44(primary),
        secondary: $673866ec6a102e6a$export$6d1b0a04fee90d44(secondary)
    };
}


function $544551a0c4b27db7$export$b595133eef38c254(style, options = {}) {
    var _a, _b, _c, _d, _e;
    options = (0, $13e609f3a6f81825$export$4950aa0f605343fb)(style, options);
    const prng = (0, $ed96386980c45b26$export$185802fd694ee1f5)(options.seed);
    const result = style.create({
        prng: prng,
        options: options
    });
    const { primary: primaryBackgroundColor, secondary: secondaryBackgroundColor } = (0, $673866ec6a102e6a$export$4fb0a19bb1541fbc)(prng, (_a = options.backgroundColor) !== null && _a !== void 0 ? _a : []);
    const backgroundType = prng.pick((_b = options.backgroundType) !== null && _b !== void 0 ? _b : [], "solid");
    const backgroundRotation = prng.integer(((_c = options.backgroundRotation) === null || _c === void 0 ? void 0 : _c.length) ? Math.min(...options.backgroundRotation) : 0, ((_d = options.backgroundRotation) === null || _d === void 0 ? void 0 : _d.length) ? Math.max(...options.backgroundRotation) : 0);
    if (options.size) {
        result.attributes.width = options.size.toString();
        result.attributes.height = options.size.toString();
    }
    if (options.scale !== undefined && options.scale !== 100) result.body = $1ee8f7521f7b63a8$export$c834547aca49957b(result, options.scale);
    if (options.flip) result.body = $1ee8f7521f7b63a8$export$90015ee4a3937667(result);
    if (options.rotate) result.body = $1ee8f7521f7b63a8$export$38df2acdbfbce309(result, options.rotate);
    if (options.translateX || options.translateY) result.body = $1ee8f7521f7b63a8$export$d6f5f87d27cbbe0f(result, options.translateX, options.translateY);
    if (primaryBackgroundColor !== "transparent" && secondaryBackgroundColor !== "transparent") result.body = $1ee8f7521f7b63a8$export$96009b6564b80064(result, primaryBackgroundColor, secondaryBackgroundColor, backgroundType, backgroundRotation);
    if (options.radius || options.clip) result.body = $1ee8f7521f7b63a8$export$e3f2409025136fe9(result, (_e = options.radius) !== null && _e !== void 0 ? _e : 0);
    if (options.randomizeIds) // Reduces the occurrence of ID collisions when rendering multiple avatars on one HTML page.
    result.body = $1ee8f7521f7b63a8$export$2ba3a9bda0f98b60(result);
    const attributes = $1ee8f7521f7b63a8$export$d29d121524f3ec8b(result);
    const metadata = $149b2aa935ea78d3$export$f2913fe8983302e(style);
    const exif = $149b2aa935ea78d3$export$b93978211a9eff5f(style);
    const svg = `<svg ${attributes}>${metadata}${result.body}</svg>`;
    return {
        toString: ()=>svg,
        toJson: ()=>{
            var _a;
            return {
                svg: svg,
                extra: {
                    primaryBackgroundColor: primaryBackgroundColor,
                    secondaryBackgroundColor: secondaryBackgroundColor,
                    backgroundType: backgroundType,
                    backgroundRotation: backgroundRotation,
                    ...(_a = result.extra) === null || _a === void 0 ? void 0 : _a.call(result)
                }
            };
        },
        toDataUriSync: ()=>{
            return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
        },
        ...(0, $d9edf3f87c434303$export$67da4c19e99f01f3)(svg, "svg"),
        png: ({ includeExif: includeExif = false } = {})=>{
            return (0, $d9edf3f87c434303$export$67da4c19e99f01f3)(svg, "png", includeExif ? exif : undefined);
        },
        jpeg: ({ includeExif: includeExif = false } = {})=>{
            return (0, $d9edf3f87c434303$export$67da4c19e99f01f3)(svg, "jpeg", includeExif ? exif : undefined);
        }
    };
}







var $4e56733ca8b21c4f$exports = {};

$parcel$export($4e56733ca8b21c4f$exports, "meta", function () { return $4e56733ca8b21c4f$export$6990040ee07315; });
$parcel$export($4e56733ca8b21c4f$exports, "create", function () { return $4e56733ca8b21c4f$export$185802fd694ee1f5; });
$parcel$export($4e56733ca8b21c4f$exports, "schema", function () { return $b02ee546ce7bb6c8$export$4902baddc787debb; });
/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ /**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ /**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ var $dfcc38a2d5892cab$exports = {};

$parcel$export($dfcc38a2d5892cab$exports, "eyes", function () { return $0bdea08108ddee2c$export$60b896fd2e3e4b2; });
$parcel$export($dfcc38a2d5892cab$exports, "eyebrows", function () { return $045609d5db6f2745$export$aebaafc0a0095705; });
$parcel$export($dfcc38a2d5892cab$exports, "mouth", function () { return $58a6e2cfc8556f88$export$4ec1914b3efc3f9a; });
$parcel$export($dfcc38a2d5892cab$exports, "glasses", function () { return $5abf718d8cdcb6ec$export$98222f1ebbc36891; });
/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ /**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ const $0bdea08108ddee2c$export$60b896fd2e3e4b2 = {
    "variant26": (components, colors)=>`<path d="M550.3 424.38c22.91-2.4 46.2 8 59.5 26.8A65.77 65.77 0 0 1 622.16 491c-.45 10.96-3.32 21.75-8.93 31.21-8.53 14.65-23.03 25.87-39.46 30.13a65.5 65.5 0 0 1-41.5-2.57 65.32 65.32 0 0 1-32.38-28.67c-7.4-12.95-9.7-28.21-7.34-42.87a64.87 64.87 0 0 1 17.9-34.8 65.14 65.14 0 0 1 39.86-19.06Z" fill="#000"/><path d="M549.26 430.26a59.65 59.65 0 0 1 42.62 10.89c15.43 11.05 25 29.84 24.48 48.85.05 22.7-14.12 44.35-34.86 53.52-10.79 4.85-22.8 6.65-34.5 4.52a59.62 59.62 0 0 1-40.35-26.67 61.5 61.5 0 0 1-9.37-29.32 60.42 60.42 0 0 1 13.41-40.36 59.52 59.52 0 0 1 38.57-21.43Z" fill="#fff"/><path d="M381.24 447.1a54.92 54.92 0 0 1 59.96 45.86c1.17 8.18.85 16.9-1.66 24.82A54.86 54.86 0 0 1 380 556.3c-15.8-1.8-30.35-11-39.02-24.28-5.54-8.32-8.46-18.03-9.11-27.97-.3-12.31 3.26-24.64 10.57-34.6a55.1 55.1 0 0 1 38.8-22.35Z" fill="#000"/><path d="M376.5 453.67c18.86-4.33 39.25 3.64 50.42 19.36 7.92 11.03 11.42 25.76 8.17 39.05a48.81 48.81 0 0 1-14.45 25.58 49.5 49.5 0 0 1-29.64 13.28c-19.88 1.83-39.68-9.53-48.32-27.5a49.23 49.23 0 0 1 33.81-69.78Z" fill="#fff"/><path d="M576.41 464.4a24.73 24.73 0 0 1 17.67 1.5c9.98 4.69 16.69 17.38 12.92 28.13a24.34 24.34 0 0 1-17.18 17.45c-6.55 1.67-13.68.8-19.44-2.84-8.89-5.5-13.54-16.73-10.71-26.86a24.59 24.59 0 0 1 16.74-17.38ZM408.46 478.49c12.74-1.61 25.04 8.55 25.32 21.5 1.08 12.37-9.26 24.21-21.78 24.28-12.48.61-23.88-9.65-23.87-22.26-.7-11.8 8.69-22.33 20.33-23.52Z" fill="#000"/>`,
    "variant25": (components, colors)=>`<path d="M550.3 424.38a65.71 65.71 0 0 1 39.66 8.67 65.75 65.75 0 0 1 28.5 34.66c3.4 10.1 4.72 21.28 2.82 31.8-2.34 15.83-10.89 30.39-23.28 40.46-16.89 13.94-40.48 18.23-61.27 11.45a65.46 65.46 0 0 1-36.85-30.3c-7.4-12.95-9.69-28.2-7.34-42.87a64.98 64.98 0 0 1 18.4-35.3 65.16 65.16 0 0 1 39.36-18.57Z" fill="#000"/><path d="M549.26 430.26a59.64 59.64 0 0 1 42.62 10.89c15.42 11.05 25 29.85 24.47 48.85.07 22.7-14.11 44.36-34.86 53.52-10.79 4.85-22.8 6.65-34.5 4.5a59.52 59.52 0 0 1-40.34-26.66 61.43 61.43 0 0 1-9.37-29.31 60.42 60.42 0 0 1 13.41-40.36 59.5 59.5 0 0 1 38.57-21.43Z" fill="#fff"/><path d="M381.25 447.09a55.31 55.31 0 0 1 36.48 9.14 55.11 55.11 0 0 1 23.31 35.66c1.43 9.16 1.07 18.48-1.94 27.3a54.94 54.94 0 0 1-23.42 29.5 54.73 54.73 0 0 1-35.67 7.62c-15.79-1.82-30.36-11-39.03-24.29-5.54-8.32-8.46-18.03-9.11-27.98-.3-12.3 3.26-24.63 10.57-34.6a55.15 55.15 0 0 1 38.81-22.35Z" fill="#000"/><path d="M378.25 453.29a49.13 49.13 0 0 1 32.86 5.6c17.98 9.93 28.44 31.6 24.26 51.82a49.36 49.36 0 0 1-22.02 32.64 50.2 50.2 0 0 1-23.36 7.67c-19.83 1.35-39.3-10.23-47.63-28.27a49.26 49.26 0 0 1 5.04-50.33 49.4 49.4 0 0 1 30.85-19.14Z" fill="#fff"/><path d="M527.25 466.2c10.29-1.32 20.55 4.37 24.64 13.95 4.98 10.77.62 24.2-9.63 30.1-6.84 4.14-16 4.3-23.06.58-8.27-4.24-13.57-13.53-12.73-22.85.68-11.13 9.72-20.52 20.78-21.78ZM358.53 480.85c5.9-2.02 12.38-1.11 17.75 1.94a21.93 21.93 0 0 1 10.3 14.56c2.55 11.6-5.77 23.8-17.55 25.6-10.32 2.12-21.3-4.15-24.64-14.13-3.92-11.13 2.73-24.59 14.14-27.97Z" fill="#000"/>`,
    "variant24": (components, colors)=>`<path d="M551.26 424.28c22.14-1.95 44.44 7.9 57.71 25.75a66.1 66.1 0 0 1 13.2 39.97c-.27 12.75-4.02 25.34-11.26 35.89-8.84 13.1-22.73 23-38.11 26.7a65.2 65.2 0 0 1-73.29-32.14c-7.12-12.81-9.26-27.78-6.96-42.2a65.29 65.29 0 0 1 58.72-53.98Z" fill="#000"/><path d="M549.27 430.26a59.62 59.62 0 0 1 44.29 12.15c14.44 11.16 23.28 29.33 22.8 47.6.05 22.95-14.44 44.84-35.55 53.82-10.6 4.63-22.39 6.3-33.8 4.22a59.6 59.6 0 0 1-40.36-26.68 61.43 61.43 0 0 1-9.37-29.31 60.42 60.42 0 0 1 13.41-40.36 59.52 59.52 0 0 1 38.58-21.43Z" fill="#fff"/><path d="M381.25 447.09a54.98 54.98 0 0 1 58.67 39.98 55 55 0 0 1-26.76 63.08 54.6 54.6 0 0 1-33.18 6.15c-15.78-1.82-30.34-11-39-24.28-5.54-8.32-8.46-18.03-9.11-27.97-.31-12.55 3.4-25.11 11-35.17a55.12 55.12 0 0 1 38.38-21.8Z" fill="#000"/><path d="M378.26 453.29a49.1 49.1 0 0 1 32.85 5.6c17.73 9.8 28.17 31.01 24.42 51.02A49.54 49.54 0 0 1 391 550.94c-20.15 1.85-40.17-9.84-48.64-28.18a49.26 49.26 0 0 1 5.04-50.33 49.4 49.4 0 0 1 30.86-19.14Z" fill="#fff"/><path d="M526.47 467.49c12.02-2.86 24.89 4.24 29.36 15.65 2.2 6 2.32 12.7-.08 18.66a25.56 25.56 0 0 1-19.7 15.97 25.68 25.68 0 0 1-22.47-7.35 25.7 25.7 0 0 1-5.46-27.34 25.5 25.5 0 0 1 18.35-15.59ZM398.26 478.35c12.27-2.56 24.75 5.81 27.12 18.08.66 5.63.55 11.35-2.68 16.22-4.79 8-14.36 12.76-23.63 11.14-10.66-1.7-19-10.97-19.33-21.79a23.04 23.04 0 0 1 18.52-23.65Z" fill="#000"/>`,
    "variant23": (components, colors)=>`<path d="M547.51 424.76a65.19 65.19 0 0 1 74.24 57.74 65.15 65.15 0 0 1-11.25 43.98 65.94 65.94 0 0 1-31.67 24.34 65.9 65.9 0 0 1-37.82 1.79 65.13 65.13 0 0 1-40.76-30.86c-13-22.14-11.12-51.53 4.58-71.84 10.24-13.5 25.83-22.89 42.68-25.14Z" fill="#000"/><path d="M549.22 430.26c14.42-1.74 28.8 1.48 40.84 9.62a59.14 59.14 0 0 1 23.84 32.34 59.2 59.2 0 0 1-2.84 41.72c-6.1 13.63-17.66 24.89-31.56 30.42a58.2 58.2 0 0 1-32.5 3.68 59.7 59.7 0 0 1-36.17-20.89A60.9 60.9 0 0 1 497.24 491a60.5 60.5 0 0 1 13.45-39.31 59.49 59.49 0 0 1 38.53-21.43Z" fill="#fff"/><path d="M381.2 447.1a55.25 55.25 0 0 1 38.86 10.79 55.08 55.08 0 0 1 21.08 34.58c1.23 8.34.97 17.27-1.61 25.34a54.87 54.87 0 0 1-29.73 33.99 55.02 55.02 0 0 1-72.45-26.19c-4.7-10-6.75-21.7-4.67-32.61a54.52 54.52 0 0 1 16.82-31.5 55.1 55.1 0 0 1 31.7-14.4Z" fill="#000"/><path d="M378.22 453.3a49.36 49.36 0 0 1 56.15 35.19c5.15 17-.4 36.5-13.2 48.68-12.66 12.44-32.08 17.22-49 11.63a49.5 49.5 0 0 1-32.71-33.83 49.37 49.37 0 0 1 12.57-47.94 49.68 49.68 0 0 1 26.2-13.73Z" fill="#fff"/><path d="M558.77 456.74c-3.87 4-6.69 8.52-6.65 14.27a20.66 20.66 0 0 0 12.5 20.42c5.98 2.45 12.26 1.32 17.64-2-.16 9.43-2.85 18.5-9.28 25.57-9.4 10.74-24.98 15.07-38.53 10.43-14.35-4.54-24.66-18.38-24.98-33.42-.48-13.95 7.47-27.39 20.04-33.53 9.2-4.73 19.5-4.72 29.26-1.73ZM391.97 467.88c8-1.43 15.68.54 22.74 4.28-3.02 3.08-5.46 6.31-5.5 10.82-.67 7.23 4.56 14.26 11.75 15.48 3.41.68 6.2-.46 9.41-1.4 1.12 12.26-4.48 24.68-14.77 31.54-11.64 7.9-28.4 7-39.25-1.9-9.69-7.6-14.38-20.75-11.76-32.75 2.7-13.31 13.83-24.22 27.37-26.07Z" fill="#000"/><path d="M527.44 489.51c2.29-1 4.8-1.33 6.96.16 3.54 2.29 3.45 7.56.77 10.5-2.67 3.02-7.74 3.2-10.32-.07-2.84-3.42-1.31-8.7 2.6-10.6ZM379.44 495.55c4.76-1.63 9.31 3.59 7.07 8-1.61 3.63-6.93 4.38-9.39 1.31-2.61-2.97-1.48-8 2.32-9.31ZM536.5 504.69c2.48-.77 5.29-.59 7.77.12 6.15 2.42 8.05 11.23 3.58 16.06-3.97 4.75-11.78 4.84-15.7-.02-4.44-5.37-2.44-13.92 4.35-16.16ZM386.51 512.74c3.42-1.11 7.14-.63 9.61 2.16 3.5 3.38 3.36 9.65-.57 12.65-4.05 3.44-10.78 1.72-13.23-2.86-2.58-4.3-.61-10.32 4.19-11.95Z" fill="#fff"/>`,
    "variant22": (components, colors)=>`<path d="M550.27 424.38a65.85 65.85 0 0 1 34.46 5.92 65.02 65.02 0 0 1 27.52 24.52 64.86 64.86 0 0 1 8.78 46.18c-2.62 15.25-11.05 29.23-23.03 38.97-16.48 13.6-39.38 18.04-59.8 11.9a65.42 65.42 0 0 1-38.32-30.76c-7.42-12.96-9.7-28.23-7.33-42.9a64.9 64.9 0 0 1 18.4-35.26 65.17 65.17 0 0 1 39.32-18.57Z" fill="#000"/><path d="M549.23 430.27c9.32-.98 18.71-.35 27.55 2.92a59.66 59.66 0 0 1 33.08 28.93c5.89 11.3 7.76 24.3 5.8 36.86a60.18 60.18 0 0 1-17.48 33.21c-9.48 9.35-22.52 15.1-35.7 16.47a59.94 59.94 0 0 1-43.07-13.03c-9.46-7.5-15.92-17.77-19.8-29.11-5.25-18.02-1.63-38.17 9.75-53.13a59.47 59.47 0 0 1 39.88-23.12Z" fill="#fff"/><path d="M521.23 467.28c7.3-1.89 15.52.27 20.87 5.62a22 22 0 0 1 5.6 22.95c-3.5 11.19-16.53 17.96-27.64 14.08-11.45-3.35-18.17-16.1-14.6-27.48a22.37 22.37 0 0 1 15.77-15.17ZM332.97 478.46c14.43.75 28.78 1.53 43.05 3.91 21.13 3.42 42.86 8.97 62.12 18.47 2.85 1.6 2.45 3.3 1.6 6.06-2.42.05-4.41-.24-6.71-1-11.15-3.39-22.56-5.26-34.03-7.17-10.45-1.44-20.56-3.19-31-3.72-10.97-1.1-21.89-.72-32.98-.66-1.97-.1-5.02.62-6.6-.75-.76-2.14.78-4.69 1.32-6.78-.94-1.57-3.08-3.45-2.4-5.43.87-2.4 3.35-2.93 5.63-2.93Z" fill="#000"/>`,
    "variant21": (components, colors)=>`<path d="M380.24 447.22a55.22 55.22 0 0 1 38.11 9.43 55.05 55.05 0 0 1 22.82 36.06c1.19 8.28.93 17.07-1.63 25.08a54.93 54.93 0 0 1-25.11 31.65 54.67 54.67 0 0 1-33.47 6.98c-16.14-1.57-31.14-10.83-39.98-24.4-5.54-8.33-8.46-18.04-9.11-27.98-.3-12.3 3.26-24.62 10.56-34.57a55.01 55.01 0 0 1 37.81-22.25Z" fill="#000"/><path d="M378.24 453.29c19.42-3.65 39.86 5.43 50.31 22.16 6.62 10.5 9.5 23.85 6.67 36.03a49.3 49.3 0 0 1-22.5 32.27 50.26 50.26 0 0 1-22.73 7.28c-19.82 1.35-39.3-10.22-47.62-28.26a49.26 49.26 0 0 1 35.87-69.48Z" fill="#fff"/><path d="M589.99 474.91c13.08-.6 26.98-1.27 39.85 1.48 2.15.57 2.9 1.32 2.29 3.67-2.1 1.76-6.1 3.3-6.83 6.12-.03 6 9.05 5.9 9.7 10.8-.3 2.95-2.43 3.33-4.98 3.14a384.71 384.71 0 0 0-23.02-1.4c-16.02-.1-32.02-.24-48 .87-7.57.7-15.22.63-22.78 1.17-11.11 1.03-22.13 1.31-33.14 3.36-2.67.5-5.5 1.11-8.23 1.06-2.01-1.24-3.05-5.54-.56-6.86 5.33-3.02 11.33-5.1 17.18-6.87 15.08-4.97 30.76-8.25 46.26-11.64 10.64-2.42 21.43-3.76 32.26-4.9ZM405.43 479.68c3.46-.9 6.9-1 10.4-.2 8.85 2.08 15.44 10.42 15.31 19.54.24 11.12-10.03 21.17-21.19 20.13-9.28-.52-17.48-7.87-18.76-17.12-1.7-9.8 4.73-19.67 14.24-22.35Z" fill="#000"/>`,
    "variant20": (components, colors)=>`<path d="m619.86 481.79 2.63 1.13c-.12 1-.28 2-.47 2.98-2.21 3.85-5.93 6.93-9 10.11a93.33 93.33 0 0 1-19.16 12.88 85.49 85.49 0 0 1-45.84 8.4c-19.45-1.64-38.43-9.82-54.2-21.1-1.4-1.13-2.88-1.98-2.47-4.04.53-2.48 3.96-3.31 6.1-2.45 21.22 6.28 42.64 6.72 64.56 5.45 16.26-1.55 32.06-4.27 47.52-9.68 3.54-1.21 6.78-2.8 10.33-3.68ZM440.55 492.43c2.8 1.36 2.2 4.42.14 6.19-10.83 9.97-25.3 16.29-39.72 18.8-7.78 1-15.1 2.3-22.95 1.12-13.82-1.06-27.27-5.1-39-12.53-2.16-1.4-4.68-2.9-6.2-5-.62-2.53.72-3.88 3.14-4.18 2.71.28 5.43 1.35 8.08 2.03 7.56 2.13 15.22 3.03 23 3.79 21.45 1.58 43.69-.86 64.16-7.53 2.94-.78 6.3-2.97 9.35-2.69Z" fill="#000"/>`,
    "variant19": (components, colors)=>`<path d="M619.37 468.64c3.87 2.6 8.11 5.27 11.16 8.82.3 1.66.07 3.43.04 5.12-1.93.6-3.41 1.04-5.4.26-29.1-10.45-62.1-9.7-91.32-.07-12.55 4.26-25.01 10.37-35.3 18.8-1.32 1.05-3.89 2.91-5.3 1.13-1.7-1.56-.63-3.53.2-5.23 7.13-12.76 18-23.13 30.66-30.34 29.02-16.58 66.88-16.42 95.26 1.5ZM405.49 480.39c11.64 2.56 23.55 8.63 31.2 17.94 2.8 3.9 6.47 8.06 5.88 13.18-1.58-.03-3.27.7-4.53-.5a50.83 50.83 0 0 0-13.92-8.1c-15.2-5.92-32.5-7.15-48.6-5.03-12.43 1.78-26.06 5.7-36 13.69-1.9 1.3-3.17 2.8-5.67 1.81a5.46 5.46 0 0 1 .33-6.17c16-21.77 45.05-31.82 71.31-26.81Z" fill="#000"/>`,
    "variant18": (components, colors)=>`<path d="M617.23 468.82c1.16 1.34 2.37 2.36 2.84 4.14a65.5 65.5 0 0 1-7.98 51.11 65.74 65.74 0 0 1-34.83 27.28 65.88 65.88 0 0 1-36.24 1.27 65.18 65.18 0 0 1-40.77-30.86c-7.18-12.23-9.85-26.73-8.06-40.75.53-3.4 1.75-7.26 5.57-8.09 8.61-1.53 17.56-1.34 26.27-2.27 24.31-1.49 48.65-2.37 73-2.08 6.76-.37 13.46.4 20.2.25Z" fill="#000"/><path d="m607.09 474.28 7.45.37c3.8 14.15 1.78 29.85-5.17 42.73a59.07 59.07 0 0 1-32.1 27.84c-14.68 5.57-31.38 4.73-45.56-1.92a59.34 59.34 0 0 1-29.82-31.09c-4.2-10.22-5.99-22.1-3.63-32.98a17.6 17.6 0 0 1 5.7-1.4c16.9-1.37 33.84-2.38 50.78-3.11-.4 5.34-.18 10.53 2.1 15.47a26.66 26.66 0 0 0 18.61 15.04c4.89.87 9.94.6 14.61-1.13 8.19-2.82 14.36-9.95 16.48-18.27.92-3.9.66-7.59.54-11.55Z" fill="#fff"/><path d="M432.03 480.67c2.01-.23 3.8.3 5.74.68 4.2 9.05 4.82 19.93 3.38 29.69a55.08 55.08 0 0 1-23.63 36.48 54.76 54.76 0 0 1-37.5 8.79 54.68 54.68 0 0 1-38.26-23.14c-6.82-9.7-10.02-21.43-10-33.24 6.52-3.27 13.17-3.72 20.48-5.47 20.5-4.17 41.07-8.1 61.75-11.22 6-1 11.97-2.04 18.04-2.57Z" fill="#000"/><path d="M433.71 486.06c1.44 5.27 2.74 10.43 2.6 15.94-.2 9.5-3 19.08-8.31 27-9.89 15.06-28.07 23.77-46 21.87a49.72 49.72 0 0 1-32.18-16.71c-7.5-8.47-11.57-19.33-12.24-30.58 14.45-3.54 29.14-6.22 43.76-9 1.32 6.48 4.55 12.27 10.11 16.02 9.04 6.32 21.92 5.38 29.9-2.26 6.12-5.72 8.04-13.57 7.2-21.73l5.16-.54Z" fill="#fff"/>`,
    "variant17": (components, colors)=>`<path d="M562.01 467.8c1.68 0 3.23.31 4.88.58-.28 2.28.34 4.36-2.64 4.8-9.4.76-18.83 1.45-28.25 2.06-4.32.2-8.78 1.16-13.1.84-1.94-.79-2.62-2-2.03-4.1 1.45-1.38 3.19-1.54 5.1-1.69 12.02-.64 24-1.86 36.04-2.5ZM396.33 481.31c1.23 1.24 2.2 1.91 2.08 3.85-1.42 2.52-4.9 2.05-7.38 2.36-8.05.21-16.06 1.68-24.09 1.71-2.7-.36-2.11-2.53-2.53-4.58 10.33-2.64 21.37-1.79 31.93-3.34ZM618.89 483.07c1.04.75 2.08 1.48 3.13 2.22a65.59 65.59 0 0 1-9.93 38.78 65.45 65.45 0 0 1-24.32 22.73c-14.52 7.96-32.32 9.86-48.26 5.44a65.36 65.36 0 0 1-35.32-24.4 63.91 63.91 0 0 1-12.38-33.97c2.1-3.32 5.74-3 9.17-3.26 30.68-2.1 61.35-4.13 92.02-6.22 8.7-.2 17.2-1.64 25.89-1.32Z" fill="#000"/><path d="M616.28 488.65c.74 20.78-11.03 41.27-28.85 51.8-11.82 6.93-25.88 9.98-39.46 7.75a59.72 59.72 0 0 1-35.27-18.9c-8.02-8.88-13.6-20.53-14.76-32.49 11.17-1.23 22.38-1.67 33.58-2.63.38 8.47 1.87 17.19 5.2 25.03 1.89 4.28 5.29 10.07 10.23 11.13 4.79.85 7.97-2.58 9.97-6.45 4.58-9.28 4-21.5 3.22-31.56 18.7-1.25 37.42-2.66 56.14-3.67Z" fill="#fff"/><path d="M415.01 499.71c8.1-.69 16.13-1.44 24.27-1.05.87.83 1.75 1.67 2.64 2.49.19 16-6.7 31.57-18.78 42.06a54.81 54.81 0 0 1-42.17 13.2 54.34 54.34 0 0 1-30.73-13.64 55.18 55.18 0 0 1-17.98-34.89c1.04-.88 2.19-2.68 3.63-2.82 13.04-1.6 26.05-1.69 39.11-2.95 13.35-.64 26.66-1.71 40-2.4Z" fill="#000"/><path d="M436.36 504.29c-.69 5.07-1.44 9.93-3.28 14.74a49.5 49.5 0 0 1-22.2 25.81 51 51 0 0 1-23.88 6.33 49.93 49.93 0 0 1-35.25-14.93 49.66 49.66 0 0 1-13.37-25.88 1021.4 1021.4 0 0 1 34.1-2.24c-.06 7.18.95 14.37 4.79 20.58 1.69 2.6 4.35 5.19 7.69 5 3.57-.14 6.11-3.3 7.5-6.28 2.85-6.64 2.88-13.67 2.25-20.74 13.86-.8 27.77-2.18 41.65-2.39Z" fill="#fff"/>`,
    "variant16": (components, colors)=>`<path d="M494.83 474.61c2.5.17 5.02 1.39 7.38 2.24 9.33 3.65 18.8 6.05 28.52 8.37 20.93 5.06 42.75 8.76 64.32 6.83a372.7 372.7 0 0 0 22-3.8c2.52-.69 5.44.75 5.16 3.64-.55 6.56-1.62 13.23-3.9 19.44a65.49 65.49 0 0 1-29.88 35.11 64.13 64.13 0 0 1-32.42 8.09c-17.65-.05-34.84-7.8-46.86-20.68-7.23-7.66-11.98-16.88-15.38-26.78 1.24 7.98 2.5 15.76 6.26 23.03 3.03 6 7.26 10.92 11.61 16-1.15 1.32-2.54 3.25-4.48 1.97-3.6-2.64-6.29-6.76-8.86-10.36-6.2-8.96-8.75-19.54-10-30.22-1-7.27.07-15.03 1.27-22.23.76-3.53 1.94-8.67 5.27-10.65ZM436.11 479.84c2.2.74 3.17 3.02 4.14 4.93 5.57 12.06 7.7 26.28 4.75 39.31-1.56 8.46-5.54 17.15-12.02 22.96-1.6 1.63-3.44 1.53-5.55 1.47a14.54 14.54 0 0 1-.05-3.16c2.13-2.57 4.8-4.5 6.55-7.43 5.1-7.77 6.2-16.2 7.05-25.25-2.4 10.15-6.94 19.55-14.24 27.08a54.72 54.72 0 0 1-31.5 16.39 54.98 54.98 0 0 1-40.6-9.82 55.32 55.32 0 0 1-19.69-26.46c-.62-1.89-1.23-4.36-.54-6.29 1.61-1.44 3.53-1.87 5.62-2.03 8.8-.6 17.33-2.62 26.08-4.44 7.47-1.54 14.64-3.9 21.94-6.06 9.57-3.12 18.95-7.7 28.15-11.8 5.2-2.33 10.2-5.07 15.18-7.86 1.4-.7 3.12-1.76 4.74-1.54Z" fill="#000"/><path d="M497.89 481.07c4.93 1.84 9.74 3.81 14.84 5.15 13.85 3.68 28.08 7.8 42.3 9.62 2.57.4 5.13.95 7.7 1.46.65 7.27 3.79 13.87 9.83 18.14 9.45 6.94 23.73 5.49 31.27-3.61 4.15-4.66 5.55-10.31 5.95-16.4l6.5-1.1c-1.89 21.43-15.6 41.02-35.47 49.48a58.92 58.92 0 0 1-38.05 3.38 59.69 59.69 0 0 1-36.88-27.07c-6.4-10.7-9.56-23.58-8.4-36.02.12-1.01.26-2.02.4-3.03ZM433.78 486.25c2.2 7.46 3.34 15.04 1.9 22.78a49.42 49.42 0 0 1-17.13 30.52 50.1 50.1 0 0 1-32.57 11.61 50.55 50.55 0 0 1-27.2-8.94A50.26 50.26 0 0 1 340.01 517c14.82-1.83 29.68-4.5 44-8.81 2.74 9.7 10.66 17.13 20.9 17.95 10.2 1.12 20.02-4.88 24-14.24a24.5 24.5 0 0 0-1.86-22.3c2.23-1.14 4.46-2.34 6.74-3.35Z" fill="#fff"/>`,
    "variant15": (components, colors)=>`<path d="M506.03 461.12c5.5-1.16 11.66 2.44 16.92 3.98 22.15 7.08 45.9 9.46 69.06 7.74 6.23-.6 12.8-2.4 19.04-2 6.2.65 10.4 6.06 10.95 12.05.76 10.8-.8 22-5.08 32a65.62 65.62 0 0 1-30.44 32.6c-21.35 11.07-48.35 9-67.75-5.22-14.69-10.5-24.7-27.34-26.67-45.3-.85-8.7-.38-17.4 2.09-25.8 1.4-5.24 6.78-9 11.88-10.05ZM428.25 466.75c3.63 2.23 5.82 6.6 7.78 10.25 5.54 10.8 7 23.18 4.95 35.07a55.32 55.32 0 0 1-14.73 28.2 55.06 55.06 0 0 1-72.17 5.63 54.77 54.77 0 0 1-21.34-34.89c-.57-3.68-1.52-7.6.15-11.13a12.41 12.41 0 0 1 10.11-7.6c4.94-.59 9.87-1.18 14.78-2 18.38-3.3 35.26-11.25 50.36-22.12 5.88-5.11 13.54-5.46 20.11-1.41Z" fill="#000"/><path d="M513.41 467.65c12.21 5.03 25.5 7.97 38.57 9.71 15.64 2.02 31.39 2.59 47.04.31 3.87-.56 8.11-1.82 12-1.53 2.42.08 4.34 2.67 4.81 4.87a59.18 59.18 0 0 1-5.45 34.37 59.08 59.08 0 0 1-31.6 29.27 58.37 58.37 0 0 1-33.76 3.03 59.62 59.62 0 0 1-40.59-30.1c-6.9-12.96-9.37-29-5.07-43.17 1.67-6.19 8-9.93 14.05-6.76ZM427.77 474.23a51.2 51.2 0 0 1 8.4 23.72c1.23 16.4-6.14 32.97-19.26 42.91a50.17 50.17 0 0 1-30.92 10.3 50.1 50.1 0 0 1-31.68-12.48 49.18 49.18 0 0 1-16.54-33.7c-.47-3.2 2.13-6.47 5.26-6.96 3.24-.67 6.63-.78 9.92-1.18 18.5-2.26 36.6-9.6 52.19-19.69 3.1-1.92 5.86-4.31 8.97-6.18 4.4-2.3 10.95-1.13 13.66 3.26Z" fill="#fff"/><path d="M533.54 496.92c12.3-1.1 23.89 8.53 24.08 21.08.84 11.05-7.56 21.22-18.45 22.83-11.9 2.14-23.93-6.81-25.4-18.8-1.93-12.29 7.5-23.97 19.77-25.1ZM400.49 505.5c5.96-1.31 12.63.86 17.06 4.96a19.5 19.5 0 0 1 3.72 23.81c-4.15 7.79-13.62 11.6-22.08 9.37-8.34-2.18-14.54-9.95-14.42-18.64-.3-9.44 6.57-17.6 15.72-19.5Z" fill="#000"/>`,
    "variant14": (components, colors)=>`<path d="M559.03 444.54c11.35-.74 22.5-.03 33.16 4.25 11.38 4.42 21.3 12.4 26.22 23.8 1.35 3.28 3.11 7.55 2.23 11.1-3.07 3.25-8.56 1.02-12.56 1.03-12.66-.6-25.44-.46-38.07.6-13.92 1-28.4 1.71-41.93 5.23-8.57 1.76-17 4.47-25.23 7.41-3.69 1.26-6.8 2.95-10.86 2.2 1.31-16.82 12.96-31.4 26.26-40.94a87.3 87.3 0 0 1 40.78-14.69Z" fill="#000"/><path d="M572.98 450.16c11.61 1.09 23.19 4.98 31.87 13a36.2 36.2 0 0 1 10.19 16.72c-16.72-2.17-34.3-.87-51.09.1-7.64.88-15.37.98-22.94 2.25 1.15-9.27 2.15-18.43 1.05-27.77 10.01-3.52 20.28-5.48 30.92-4.3Z" fill="#fff"/><path d="M369.22 468.68c17.1-2.83 35.63-.23 50.88 8.19 8.69 4.83 16.86 12.07 20.6 21.48.74 2.06 1.6 4.59-.72 5.96-2.65.08-5.37-.59-8-1-9.4-1.82-19.4-2.12-28.98-2.58-10.7-.45-21.3.47-32 .59-12.48.84-24.76 2.93-37.09 5-2.44.58-3.13-2.39-3.06-4.24.15-12.37 9.08-22.32 19.76-27.45 6-2.54 12.23-4.67 18.62-5.95Z" fill="#000"/><path d="M516.85 467.34c-.57 6.96-.53 13.45.13 20.4-6.16 1.8-12.2 3.88-18.22 6.1 3.2-10.63 9.88-19.24 18.1-26.5ZM374.58 473.35c9.9-.51 19.68.03 29.2 2.93 12.4 3.71 23.8 10.16 30.58 21.56-20.19-3.58-39.98-2.6-60.31-2.46.88-7.35.67-14.65.53-22.03ZM350.49 480.58c-.28 5.86-.25 11.64 0 17.5-4.7.28-9.4.74-14.03 1.68 1.62-7 5.15-12.07 10.65-16.56 1.13-.89 2.26-1.76 3.39-2.62Z" fill="#fff"/>`,
    "variant13": (components, colors)=>`<path d="M554.99 424.09a65.3 65.3 0 0 1 43.19 14.7c9.2 7.44 16.2 17.65 20.32 28.7 2.1 5.57 2.58 11.14 3.64 16.93-1.32 1.48-1.69 3.34-4.05 3.02-7.04-.31-13.96-2.04-21.03-2.22-8.77-.1-17.38-.37-26.1.95-9.83 1.63-19.5 2.64-29.06 5.72a175.1 175.1 0 0 0-32.49 12.44c-3.35 1.62-6.46 3.76-9.88 5.22-2.08.77-4.42.35-5.29-1.92-2.28-7.19-2.82-15.19-2.45-22.69.94-16 8.12-31.4 19.67-42.5a65.08 65.08 0 0 1 43.54-18.36Z" fill="#000"/><path d="M557 429.85c15.33-.23 30.4 6.15 41.39 16.75 9.87 9.5 15.83 22.19 17.7 35.7-14.9-2.86-30-3.76-45.12-2.5-6 .7-11.93 1.88-17.87 2.89-.9-3.26-1.74-6.35-3.55-9.25-5.97-9.96-19.33-15.24-30.34-11.14a25.88 25.88 0 0 0-15.95 14.9c-3.08 7.38-2.28 15.5 1.22 22.6l-5.74 2.9c-5.12-21.7 3.1-45.52 20.44-59.52 10.54-8.6 24.2-13.57 37.83-13.33Z" fill="#fff"/><path d="M411.45 452.57a55 55 0 0 1 27.77 32.17c3.17 9.5 3.14 19.25 1.59 29.04l-2.88 1.57a151.25 151.25 0 0 0-29.91-5.44c-17.9-1.13-36.17-1.69-54.05.02-6.9.17-13.47 2.03-20.42 1.58-.89-2.44-1.7-4.84-1.7-7.47-.18-10.31 2.22-20.81 7.45-29.76a55.03 55.03 0 0 1 72.15-21.7Z" fill="#000"/><path d="M397.24 453.61a49.57 49.57 0 0 1 27.52 16.64 49.91 49.91 0 0 1 11.07 38.62 83.07 83.07 0 0 0-12.33-3.02 232.53 232.53 0 0 0-37.65-2.38c-.06-3.82.07-7.4-1.47-10.98a23.17 23.17 0 0 0-18.35-14.5c-10.08-1.52-20.42 4.34-24.35 13.74-2.23 4.9-1.78 9.64-1.96 14.85-1.73-1.26-1.94-1.37-2-3.52-.53-12.06 4.07-24.34 11.93-33.45 11.5-13.5 30.27-19.84 47.6-16Z" fill="#fff"/>`,
    "variant12": (components, colors)=>`<path d="M589.31 432.68c12.94 7.4 23.4 19.43 28.46 33.5 5.72 14.35 5.72 30.61.54 45.12-1.04 2.9-2.88 5.22-6.28 4.77-15.08-.73-29.98.14-45.06.56-10.03 1.1-20.04 2.15-30 3.79-10.45 1.82-20.62 4.13-30.98 6.08-4.32-.12-5.27-4.23-7.16-7.33-12.06-22.95-8.72-52.48 8.27-72.08 9.79-11.52 23.84-19.77 38.83-22.06a65.12 65.12 0 0 1 43.38 7.65Z" fill="#000"/><path d="M558 429.86c14.45 0 28.8 6.03 39.38 15.78a60.1 60.1 0 0 1 18.5 35.34c1.21 10 .36 20.16-3.44 29.56l-3.28-.37c1.67-5.12 2.73-10.04 1.39-15.4-1.92-10.81-10.74-19.63-21.59-21.4-5.35-.62-10.64-.41-15.57 1.95a26.64 26.64 0 0 0-15.32 19.72c-1.1 5.72-.02 11.42 2.43 16.64a286.92 286.92 0 0 0-34 5.18c-6.73 1.22-13.35 3.24-20.15 4.12-7.35-12.03-10.84-27.07-8.3-41.03a59.67 59.67 0 0 1 18.97-34.92c11.08-9.99 26.04-15.66 40.98-15.17Z" fill="#fff"/><path d="M392.02 447.07a54.82 54.82 0 0 1 33.45 15.5c9.47 9.26 15.55 22.16 16.25 35.43.8 10.74-1.6 21.5-6.91 30.87-1.13 1.88-2.87 4.02-5 4.71-3.03.8-6.6-.16-9.61-.83a304.26 304.26 0 0 0-26.28-5.18c-12.88-.84-26.08-.9-38.96.07-4.8.32-9.78 1.33-14.56 1-2.32-1.1-3.7-4.21-4.57-6.48-3.37-8.83-4.98-18.73-3.32-28.12a54.87 54.87 0 0 1 59.5-46.97Z" fill="#000"/><path d="M401.48 454.74a49.3 49.3 0 0 1 29.58 25.18c4.64 9.38 6.55 20.52 4.31 30.82-1.3 6.2-3.31 12.86-7.13 18l-4.14-.7c4.13-4.48 6.9-9.84 6.82-16.07.38-10.5-7.04-19.98-17.18-22.44-10.75-2.93-22.53 3.32-26.5 13.64-2.56 5.93-1.93 12.1.32 17.99-7.6.3-15.02-.37-22.59.38-7.31.65-14.63 1.12-21.93 1.8-.66-1.14-1.33-2.25-1.9-3.45-7.24-17.69-2.92-38.73 10.39-52.36 12.64-13.18 32.51-18.39 49.95-12.79Z" fill="#fff"/>`,
    "variant11": (components, colors)=>`<path d="M556 424.07a65.28 65.28 0 0 1 38.21 11.72 66.38 66.38 0 0 1 25.55 35.69c2.03 8.44 3.26 17.76 1.73 26.36-.34 2.67-3.16 3.58-5.48 3.72-22.92 1.12-45.4 3.72-68.02 6.37-13.15.92-26.15 2.81-39.22 4.54-4.57.55-8.58 1.7-13.07-.02-4.7-13.26-5.45-27.76-1.52-41.31a65.08 65.08 0 0 1 25.49-35.44A64.79 64.79 0 0 1 556 424.07Z" fill="#000"/><path d="M566.19 430.48a59.9 59.9 0 0 1 38.69 23.59c7.72 10.54 11.98 23.86 11.5 36.93-.17 1.36.17 3.47-.68 4.57-4.17.7-8.5.77-12.7 1.15-18.38 1.14-36.61 3.35-54.88 5.53 1.29-3.37 2.5-6.57 2.63-10.23.4-9.56-5.03-18.9-13.67-23.1-7.93-4.11-18.77-3.17-25.87 2.29-6.37 4.73-10.35 12.82-9.79 20.8 0 6 2.59 11.22 6.37 15.73-2.44.23-4.87.5-7.3.75a58.83 58.83 0 0 1 1.85-43.11 59.17 59.17 0 0 1 32.69-31.45c9.91-4.07 20.61-4.84 31.16-3.45Z" fill="#fff"/><path d="M415.92 455.07a54.98 54.98 0 0 1 22.55 27.5 55.8 55.8 0 0 1 1.3 34.35c-3.95 1.23-7.7.76-11.77.75-25.4-.28-50.64-.3-76 1.43-5.57-.31-13 1.8-17.82-1.36-1.63-6.9-2.98-13.6-2.05-20.72a55.18 55.18 0 0 1 14.86-33.04 55.09 55.09 0 0 1 32-16.6 55.24 55.24 0 0 1 36.93 7.69Z" fill="#000"/><path d="M410.45 458.52c18.96 10.1 29.6 32.88 24.63 53.87-1.89.03-3.78.06-5.67.13 2.51-4.85 3.8-10.1 2.83-15.56-1.25-8.23-7.5-15.16-15.4-17.62a23.63 23.63 0 0 0-14.04.47c-8.31 3.06-14.47 11.22-14.46 20.19-.29 4.37 1.04 8.24 2.82 12.14-15.4.07-30.77 1.03-46.16 1.93-1.75-.18-5.82.57-6.13-1.9-4.43-18.7 3.54-39.04 19.11-50.2 15.1-11.13 36.05-12.56 52.48-3.45Z" fill="#fff"/>`,
    "variant10": (components, colors)=>`<path d="M556 424.07a65.21 65.21 0 0 1 41.05 13.82c18.48 14.28 28.2 38.6 24.23 61.66-.97 7.55-3.9 14.28-6.79 21.23-1.4.65-2.88 1.52-4.42 1.77-2.33.07-4.8-.9-7.04-1.55a178.7 178.7 0 0 0-49.03-7.62c-15.06.4-29.61 2.56-43.09 9.64-3.05 1.28-5.82 4.03-8.96 1.26-8.58-12.42-11.56-28.46-9.81-43.32a65.03 65.03 0 0 1 19.83-39A65.11 65.11 0 0 1 556 424.07Z" fill="#000"/><path d="M557 429.85c13.7-.2 27.1 4.84 37.68 13.45a59.16 59.16 0 0 1 19.44 29.7 59.28 59.28 0 0 1-4.3 43.5c-5.35-.6-10.17-2.64-15.46-3.77-16.05-3.75-32.92-5.8-49.39-4.47a92 92 0 0 0-39.3 11.6c-7.05-12.13-10.2-27-7.45-40.83a59.55 59.55 0 0 1 23.8-38.03c10.11-7.24 22.5-11.37 34.98-11.15Z" fill="#fff"/><path d="M381.31 447.08a55.36 55.36 0 0 1 37.02 9.56 55.02 55.02 0 0 1 22.82 35.91c1.2 8.25.97 17.09-1.57 25.09a54.9 54.9 0 0 1-30.47 34.5 55.24 55.24 0 0 1-41.44 1.17 54.92 54.92 0 0 1-27.48-22.52c-5.05-8.05-7.68-17.27-8.31-26.7-.33-12.57 3.39-25.15 11-35.22a55.1 55.1 0 0 1 38.43-21.8Z" fill="#000"/><path d="M376.49 453.67c18.14-4.16 37.8 3.04 49.17 17.7 8.7 11.04 12.73 26.33 9.55 40.13a48.84 48.84 0 0 1-14.55 26.16 49.53 49.53 0 0 1-29.63 13.27c-19.64 1.82-39.23-9.24-48.03-26.86a49.25 49.25 0 0 1 33.5-70.4Z" fill="#fff"/><path d="M519.39 474.75c8.57-2.25 17.85 3.55 19.35 12.31 1.85 8.26-3.88 16.87-12.14 18.52-9.15 2.3-18.91-5.05-19.05-14.53-.72-7.5 4.64-14.5 11.84-16.3ZM403.4 485.62c6.37-2.18 13.28.5 17.27 5.7 4.54 5.94 4.18 14.91-1.03 20.32-5.02 5.79-14.5 6.76-20.65 2.39a15.82 15.82 0 0 1-6.92-13c-.26-6.95 4.69-13.5 11.33-15.4Z" fill="#000"/>`,
    "variant09": (components, colors)=>`<path d="M555 424.09a65.26 65.26 0 0 1 42.06 13.81c18.47 14.28 28.15 38.55 24.23 61.62-1 7.61-3.96 14.36-6.83 21.38-1.43.6-2.9 1.25-4.4 1.62-3.14-.02-6.34-1.4-9.37-2.2a176.16 176.16 0 0 0-47.7-6.93c-13.29.44-27.28 2.39-39.33 8.3-2.83 1.28-5.6 3-8.59 3.86-3.52-.25-4.36-3.15-5.94-5.74-7.02-13.13-9.05-28.5-6.31-43.08a64.94 64.94 0 0 1 19.15-34.8A65.1 65.1 0 0 1 555 424.1Z" fill="#000"/><path d="M557 429.85c13.47-.19 26.63 4.66 37.13 13a59.2 59.2 0 0 1 20 30.16c4.23 14.46 2.5 30.12-4.26 43.54-6.14-.92-11.86-3.14-17.94-4.39-16.73-3.67-34.37-5.5-51.43-3.48a91.33 91.33 0 0 0-34.84 11.18c-6.86-11.98-10.07-26.23-7.6-39.92 2-12.66 8.2-24.57 17.41-33.47 10.95-10.62 26.24-16.88 41.53-16.62Z" fill="#fff"/><path d="M381.25 447.09a55.37 55.37 0 0 1 36.48 9.14 55.05 55.05 0 0 1 23.4 36.2c1.25 8.36.98 17.28-1.59 25.37a54.9 54.9 0 0 1-23.86 30.9 54.63 54.63 0 0 1-34.72 7.72 54.72 54.72 0 0 1-39.57-23.79c-5.78-8.44-8.88-18.4-9.5-28.58-.36-12.78 3.55-25.6 11.4-35.73a55.12 55.12 0 0 1 37.96-21.23Z" fill="#000"/><path d="M376.5 453.66a48.91 48.91 0 0 1 33.29 4.5c17.34 8.92 28.1 28.43 26.3 47.84-1.14 11.3-5.91 22.08-13.92 30.17A49.58 49.58 0 0 1 391 550.94c-19.4 1.77-38.75-9-47.7-26.26a49.34 49.34 0 0 1 2.47-49.94 49.32 49.32 0 0 1 30.73-21.08Z" fill="#fff"/><path d="M519.43 474.74c8.56-2.21 17.77 3.55 19.3 12.29 1.86 8.33-3.88 16.92-12.2 18.57-9.2 2.17-18.82-5.06-18.99-14.6-.68-7.5 4.66-14.47 11.9-16.26ZM403.43 485.61c9.52-3.24 20.05 4.4 20.34 14.34.81 8.84-6.85 17.06-15.74 16.75-8.62.39-16.04-7.14-15.96-15.68-.25-6.97 4.7-13.5 11.36-15.4ZM598.82 532.68c1.05.34 2.1.7 3.16 1.06-.43 1.65-.27 3.3-1.72 4.43-6.9 5.73-16.13 10.13-25.25 9.91-3.84-.08-8.61-1-11.46-3.78-.26-1.17-.33-2.4-.44-3.59l2.82-.93c4.52 2.16 9.07 3.47 14.1 2.21 7.46-1.28 12.59-5.5 18.8-9.3ZM347.06 547.76c2.26-.5 3.85 1.46 5.53 2.62 9.4 7.75 21.34 11.38 33.42 11.45 5.83.1 10.84-2.25 16.7-1.34-.5 2.38-.06 4.38-2.93 5.06-18.1 4.87-38.96.17-52.89-12.5-1.77-1.37-2.24-4.32.17-5.29Z" fill="#000"/>`,
    "variant08": (components, colors)=>`<path d="M558.2 453.21c11.47-1.62 23.68.14 34 5.5 7.61 3.93 14.3 10.28 18.11 18 3.35 6.67 3.82 14.64 2.11 21.82-2.1 8.03-7.22 15.16-13.75 20.2-14.96 11.75-36.54 14.35-54.2 7.75-8.43-3.17-16.54-8.89-21.4-16.55-2.8-4.73-5.22-10.36-5.36-15.93-.7-9.54 3.61-19.3 10.27-26.02 8.05-8.38 18.87-12.97 30.22-14.77Z" fill="#000"/><path d="M559.17 459.11c13.97-2.02 29.72 1.64 39.88 11.85 6.6 6.52 10.35 16.95 7.62 26.05-2.06 8.19-7.68 14.5-14.53 19.15-12.44 8.2-28.98 10.02-43.11 5.63-8.63-2.7-17.05-8.19-21.69-16.1-3.02-5-4.14-10.91-3.6-16.7.77-6.83 4.54-13.12 9.39-17.85 7.05-6.72 16.44-10.78 26.04-12.03Z" fill="#fff"/><path d="M369.48 468.71c17.62-2.69 37.91 3.42 47.71 19.13a30.7 30.7 0 0 1 1.93 29.15c-2.9 6.32-7.9 11.64-13.7 15.43-7.34 4.75-15.75 7.1-24.42 7.8-14.63.56-29.8-4.3-39.4-15.8-5.22-6.27-8.18-14.2-7.54-22.4.56-8.28 4.61-15.75 10.51-21.45 6.92-6.46 15.65-10.23 24.91-11.86Z" fill="#000"/><path d="M376.55 474.11c9.64-.35 19.56 2.27 27.37 8.02 5.14 3.82 9.44 9.18 11.19 15.41 1.61 6.2 1.04 12.92-2.15 18.54-4.72 8.62-13.66 14.22-22.97 16.7-13.7 3.72-30.16.72-40.8-8.98-6.28-5.66-10-13.74-9.23-22.26a27.3 27.3 0 0 1 6.85-14.72c7.34-8.2 18.86-12.64 29.74-12.7Z" fill="#fff"/><path d="M551.46 477.61c3.7-.8 7.51-.7 10.96.96 6.42 3.03 10.48 10.43 8.9 17.48-1.3 7.25-7.9 12.9-15.3 12.85-8.43.47-15.97-6.52-16.35-14.89a15.94 15.94 0 0 1 11.8-16.4Z" fill="#000"/><path d="M553.62 483.21c4-.67 7.83.6 10.2 3.96 3.05 4.06 2.27 9.86-1.37 13.27-4.4 3.95-11.88 3.34-15.16-1.77-4.01-5.83-.63-14.19 6.32-15.46Z" fill="#fff"/><path d="M618.7 484.19c1.7.32 3.64-.24 4.63 1.46 1.61 2.47 2.37 5.58 2.85 8.46 1.44 10.52-2.22 21.8-9.83 29.25-3.27 3.02-7.82 5.97-12.38 6.11-2.73.04-4.27-2.62-2.33-4.8 3.27-1.61 6.54-2.11 9.44-4.56 6.3-5.26 9.64-14.02 9.57-22.11 0-4.02-1.58-7.21-2.66-10.96l.71-2.84ZM380.44 488.46c4.44-.82 9.2.5 12.68 3.35 5.75 4.58 7.69 13.08 4.69 19.76-2.56 5.93-8.24 10.22-14.82 10.23-8.45.57-15.94-6.42-16.44-14.79a17.14 17.14 0 0 1 13.89-18.54Z" fill="#000"/><path d="M379.53 494.79c5.08-1.91 10.94.6 12.92 5.67 2.83 6.48-1.52 14.7-8.68 15.43-4.25.47-7.6-1.26-9.9-4.82-3.45-5.89-.8-13.89 5.66-16.28Z" fill="#fff"/><path d="M330.44 503.6c.44 4.06-1.4 7.43-1.67 11.39a19.33 19.33 0 0 0 7.3 15.89c2.43 1.9 5.11 2.82 7.77 4.29 1.95.85 1.84 2.03 1.58 3.92-1.5 1.78-3.3 1.46-5.3.8-7.29-2.71-13.56-8.6-15.96-16.08-2.04-6.12-1.77-13.6 1.36-19.29 1.26-1.87 3.04-.88 4.92-.92Z" fill="#000"/>`,
    "variant07": (components, colors)=>`<path d="M540.5 447.73c18.9-2.42 39.63-.58 56.95 7.8 8.55 4.17 16.74 10.3 21.22 18.9 3.9 7.33 3.91 16.75-.16 24.02-4.22 8.05-12 14.1-19.93 18.24-13.55 7.02-29.4 9.83-44.57 9.65-12.04.02-23.93-1.81-35.2-6.11-8.98-3.47-17.66-8.68-23.75-16.26-4.84-6.12-7.63-14.13-5.89-21.93 1.84-8.56 7.5-15.36 14.4-20.47 10.64-7.84 23.95-11.98 36.92-13.84Z" fill="#000"/><path d="M546.98 452.71c8.4-.27 17.24-.58 25.5 1.08 10.6 1.7 21.45 5.3 30.3 11.45 5.5 3.95 10.43 9.09 12.35 15.73 2.02 6.8-.27 14.13-4.75 19.45-6.1 7.46-15.56 12.38-24.55 15.43-9.89 3.26-20.41 5.08-30.83 4.84a92.86 92.86 0 0 1-30.23-4.45c-9.19-3.05-18.45-7.69-24.78-15.23-4.3-5.04-6.9-12.45-4.86-18.97 1.5-6.55 6.69-12.06 11.94-15.96 11.4-8.26 26.07-12.06 39.91-13.37Z" fill="#fff"/><path d="M373.48 460.76c16.32-2.29 34.23-.9 49.1 6.64 7.74 4 15.42 10.43 17.96 19.07 2.33 7.1-.17 14.74-4.65 20.42-6.29 7.75-15.28 12.42-24.65 15.4a89.74 89.74 0 0 1-45.3 1.76c-9.87-2.25-20-6.47-27.15-13.89-4.71-4.75-7.92-11.31-7.35-18.12.54-7.22 4.98-13.65 10.43-18.18 8.81-7.42 20.37-11.3 31.6-13.11Z" fill="#000"/><path d="M371.5 466.92c15.62-3 32.92-1.77 47.43 5.05 6.36 3.02 13.43 8.26 15.74 15.2 2.08 5.63.36 11.7-3.32 16.23-4.64 5.76-11.76 9.8-18.6 12.35a80.56 80.56 0 0 1-39 3.9c-9.28-1.29-18.97-4.28-26.66-9.78-5.23-3.9-9.63-9.03-9.9-15.85-.2-6.85 4.16-12.52 9.28-16.58 7.13-5.5 16.25-8.8 25.03-10.52Z" fill="#fff"/><path d="M592.23 469.2c2.12-1.59 4.65-.32 5.95 1.66 2.4 4 2.38 9.6 2.8 14.14.2 4.39.48 9.64-1.23 13.75-1.98 4.07-7.4 1.34-8.7-1.8-2.28-6.35-2.19-13.75-1.68-20.4.42-2.36.64-5.94 2.86-7.35ZM416.85 476.07c2.18.53 2.81 3.77 3.31 5.63.82 5.03 1.38 10.25 1.06 15.34-.33 2.54-.69 5.69-3.12 7.13-2.07 1.29-4.27-.03-5.35-1.93-2.07-3.84-2.16-8.98-2.29-13.24.06-4.36-.1-8.73 2.24-12.56 1.44-.39 2.65-.96 4.15-.37Z" fill="#000"/>`,
    "variant06": (components, colors)=>`<path d="M561.86 423.28c1.8.47 1.92 1.91 1.98 3.5.02 6.73-.89 13.42-.75 20.17 8.34.57 16.1 2 24.1 4.41 3.08-7.1 5.82-14.35 8.72-21.52.94-1.82 1.46-4.16 4.03-3.81 2.35.23 2.58 3 1.77 4.75-2.95 7.55-6.03 15.07-9.09 22.57a69.85 69.85 0 0 1 18.22 10.84c4.88-4.58 9.61-9.35 14.61-13.8 1.61-1.56 3.31-1.05 5.34-1.14-.18 1.98.26 3.67-1.37 5.17-4.75 4.73-9.7 9.27-14.6 13.87 3.57 5.14 6.56 10.24 6.7 16.7.65 9.88-4.85 18.26-12.06 24.45-11.14 9.42-26.17 14.24-40.45 16.09-16.6 1.82-33.82.84-49.57-5.05-9.18-3.45-18.18-8.76-24.39-16.5-5.05-6.41-7.79-14.68-5.7-22.8 2.47-9.88 9.93-17.24 18.37-22.43 14.8-8.93 32.37-12.08 49.46-12.05.24-6.57.54-13.17 1.11-19.72.06-1.98 1.23-4.28 3.56-3.7ZM371.98 441.39c1.93-.19 2.6 2.2 3.14 3.63 1.19 4.97 1.3 10.2 2.17 15.24a98.97 98.97 0 0 1 25.73.76c10.86 2.02 22.05 6.02 30.13 13.83 4.96 4.66 8.49 11.22 8.27 18.15-.46 7.42-4.43 13.69-9.92 18.48-8.9 7.86-21.44 11.98-33.01 13.71-15.71 2.23-32.97.68-47.4-6.25-8.5-4.18-17-11.26-19.21-20.87-1.3-5.19-.04-9.95 1.97-14.74-3.86-3.53-7.7-7.1-11.45-10.73-.82-1.01-2.4-2.18-2-3.61.02-2.54 3.45-3.08 4.99-1.37 4 3.5 7.7 7.34 11.68 10.88a55.27 55.27 0 0 1 11.15-9.24c-2.74-6.13-5.52-12.24-8.25-18.36-1.11-2.2-.85-4.39-.7-6.76 1.25.21 2.63.25 3.79.76 1.17 1.19 1.84 2.96 2.56 4.46 2.5 5.77 5.18 11.45 7.58 17.25 5.99-2.57 11.89-4.32 18.29-5.56-.4-5.41-1.7-10.7-2.04-16.11 0-1.53.39-4.08 2.49-3.55Z" fill="#000"/><path d="M539.5 453.67c14.63-2.22 30-1.53 44.23 2.67 9.5 2.94 19.21 7.45 25.93 15.02 4.3 4.85 7.04 11.05 6 17.64-1.06 7.24-5.77 12.91-11.36 17.3-8.8 6.84-20.25 10.76-31.1 12.82-15.74 2.8-32.36 2.12-47.65-2.63-9.43-3.02-19.09-7.77-25.56-15.48-4.32-5.09-6.88-12.4-4.86-19 1.56-6.56 6.67-12 11.93-15.92 9.35-6.79 21.12-10.62 32.44-12.42ZM371.53 466.92c15.61-3 32.9-1.76 47.4 5.05 6.37 3.03 13.4 8.25 15.73 15.18 2.07 5.65.38 11.7-3.31 16.24-4.63 5.75-11.74 9.78-18.58 12.34a80.48 80.48 0 0 1-39.78 3.8c-9.02-1.35-18.44-4.3-25.91-9.67-5.22-3.87-9.62-9.04-9.9-15.83-.19-6.6 3.87-12.1 8.74-16.14 7.19-5.81 16.63-9.2 25.6-10.97Z" fill="#fff"/><path d="M592.24 469.18c2.15-1.56 4.62-.31 5.94 1.67 1.83 3.14 2.15 6.6 2.5 10.16.42 5.18.87 10.72-.26 15.84a6.16 6.16 0 0 1-2.03 3.53c-2.92 1.46-6.85-1.24-7.61-4.16-1.98-6.22-1.92-13.23-1.4-19.7.4-2.36.64-5.9 2.86-7.34ZM413.31 476.33a4.04 4.04 0 0 1 5.96 2.42c1.8 5.09 1.92 10.91 2.05 16.26-.15 3.13-.37 8.05-3.81 9.46-2.59.94-4.59-1.38-5.4-3.58-1.88-5.26-1.76-11.4-1.5-16.9.24-2.36.44-6.28 2.7-7.67Z" fill="#000"/>`,
    "variant05": (components, colors)=>`<path d="M574.47 426.48c13.52 3.69 25.28 11.87 34.03 22.75 7.5-5.17 14.74-10.73 22.37-15.71l3.07 1.28c-.34 2.1-.24 3.64-2.24 4.9-6.6 4.8-13.31 9.45-19.92 14.23 3.77 6.35 7.07 12.73 8.56 20.03 1.59 7.69 2.58 16.11 1.14 23.88-.44 2.76-3.06 3.5-5.47 3.7-19.7 1.03-39.42 3.02-59 5.35-11.08 1.45-22.17 1.92-33.23 3.57-4.5.68-9.03 1.18-13.54 1.79-5 .7-9.54 1.77-14.54.33-4.84-13.86-5.54-28.92-1.07-42.97a65.16 65.16 0 0 1 28.7-36.27c15.07-9.25 34.17-11.67 51.14-6.87Z" fill="#000"/><path d="M565.47 430.38a59.78 59.78 0 0 1 42.62 28.54c6.6 11.12 9.16 23.82 8.14 36.67-4.76.39-9.48.96-14.25 1.17-18 1.19-35.9 3.32-53.81 5.48 1.05-2.96 2.25-6.07 2.52-9.2.8-9.38-4.1-18.83-12.31-23.45-5.3-3.21-11.43-3.75-17.45-2.72-11.6 2.17-20.3 13.34-19.52 25.13.01 6.06 2.65 11.12 6.33 15.74l-7.3.74a59.26 59.26 0 0 1 1.6-42.39 59.24 59.24 0 0 1 33.74-32.46c9.48-3.74 19.65-4.48 29.7-3.26Z" fill="#fff"/><path d="M416.52 455.44a55 55 0 0 1 24.5 36.47 57.74 57.74 0 0 1-1.23 25.16c-5.34 1.1-10.4.57-15.8.57-24.03-.24-48-.16-72 1.46-5.86-.14-12.62 1.57-17.83-1.24-.94-4.53-2.07-9.19-2.27-13.82-.34-10.1 2.17-19.99 6.82-28.94-6-3.98-12.33-7.55-18.2-11.72-1.9-1.41-1.7-2.69-.83-4.69 2.76-1.07 4.5.5 6.78 1.81 5.07 3.31 10.17 6.56 15.27 9.82a55.77 55.77 0 0 1 31.73-21.84 55.28 55.28 0 0 1 43.05 6.97Z" fill="#000"/><path d="M400.8 454.53a49.36 49.36 0 0 1 29.24 23.44 48.95 48.95 0 0 1 5.07 34.42l-5.61.12c2.13-4.63 3.58-9.36 2.88-14.52-.9-8.64-7.3-16.11-15.55-18.64a23.51 23.51 0 0 0-11.81-.2c-9.02 2.14-16.25 10.53-16.65 19.85-.47 4.7.89 8.93 2.74 13.17-13.38.11-26.76.61-40.1 1.61-3.69.2-7.9.7-11.5-.24-1.65-3.05-1.64-7.15-1.79-10.54-.55-13.95 5.57-28 15.83-37.42 12.47-11.6 30.9-16 47.25-11.05Z" fill="#fff"/>`,
    "variant04": (components, colors)=>`<path fill-rule="evenodd" clip-rule="evenodd" d="M612.99 456.04a65.1 65.1 0 0 0-38.46-29.54 66.07 66.07 0 0 0-39.02 1.1 65.93 65.93 0 0 0-36.82 32.08c-3.28 6.32-5.17 13.09-6.5 20.06-4.4.35-8.76.83-13.04 1.93.19.5.3 1.03.4 1.54.27 1.36.52 2.6 2.24 2.92 2.35.22 4.76 0 7.15-.22.92-.08 1.84-.16 2.75-.22-.56 12.87 2.24 25.63 8.92 36.7a65.2 65.2 0 0 0 40.45 30.25 65.99 65.99 0 0 0 37-1.54 65.75 65.75 0 0 0 34.03-27A65.76 65.76 0 0 0 622.15 490c.06-3.79-.4-7.45-.86-11.15l-.35-2.92c.94-.1 1.9-.19 2.86-.27 2.31-.2 4.64-.4 6.85-.98 1.2-.46 1.44-1.64 1.68-2.8.1-.48.2-.95.36-1.37-4.4-1.13-8.7-.78-13.15-.28-.5-1.18-1-2.35-1.47-3.53-1.5-3.64-2.98-7.25-5.08-10.67Zm.6 14.63c-4.83-13.64-13.96-25.42-26.55-32.68-13.32-7.97-29.57-10.1-44.6-6.46a59.5 59.5 0 0 0-35.54 25.37c-4.25 6.8-7.73 14.51-8.83 22.5a439.7 439.7 0 0 1 17.89-1.48c4.84-.34 9.69-.67 14.53-1.14 3.63-.32 7.27-.51 10.91-.7 4.86-.25 9.72-.5 14.54-1.08 16.39-1.12 32.79-2.4 49.17-3.67l8.47-.66Zm-200.21-17.1c11.97 6.5 20.98 17.4 25.57 30.16 2.69.16 5.36.38 8.03.75l-.1.7c-.16 1.02-.31 2.03-.6 3.05-1.04.76-2.47 1.03-3.83 1.29-.57.1-1.13.21-1.65.35 1.33 8.86 1.68 17.54-.78 26.25a54.8 54.8 0 0 1-59.8 40.22 54.77 54.77 0 0 1-39.64-24.94c-6.25-9.68-8.98-21.04-8.76-32.5-2.42-.02-4.82-.1-7.23-.28.08-.37.11-.82.15-1.3.1-1.25.2-2.69 1.15-3.27 1.54-.49 3.19-.68 4.81-.88a72.5 72.5 0 0 0 1.82-.23c1.4-6.54 3.35-12.87 6.78-18.66a55.05 55.05 0 0 1 74.08-20.7Zm19.77 30.84c-7.08-18.8-25.97-32.07-46.15-31.85-18.18-.19-35.6 10.43-43.83 26.64-2.2 4.2-3.57 8.69-4.72 13.28 7-.47 14-1.08 20.99-1.7 6.19-.54 12.38-1.08 18.58-1.52 3.77-.09 7.52-.47 11.26-.85 3.9-.4 7.78-.8 11.7-.86l6.3-.46c8.65-.6 17.33-1.22 25.87-2.67Z" fill="#000"/><path d="M615.13 476.4c1.79 9.43 1.83 19.44-.85 28.71a59.84 59.84 0 0 1-26.86 35.35c-11.86 6.95-25.9 9.98-39.53 7.74a59.74 59.74 0 0 1-40.06-25.03c-7.65-11.07-11.16-24.46-10.6-37.86 2.78-.26 5.55-.53 8.32-.81.58 6.88 2.87 13.16 8.1 17.84 9.27 8.8 25.13 8.57 33.96-.73 5.71-5.52 7.56-12.65 7.15-20.42 4.5-.5 8.95-1.1 13.47-1.39 15.64-.93 31.25-2.54 46.9-3.4ZM430.93 490.81c1.23-.4 2.51-.66 3.76-.97 3.28 11.9 1.31 24.64-4.45 35.44a49.5 49.5 0 0 1-33.98 24.89c-17.42 3.66-36.18-3.36-47.37-17.1-8.08-9.7-11.83-22.11-11.18-34.67 16.43-1.6 32.94-2.6 49.35-4.39.17 5.54 1.15 10.77 4.71 15.18a22.27 22.27 0 0 0 23.42 7.93c7.1-2.26 13-7.85 15.04-15.1 1.18-3.81.53-7.35.7-11.2Z" fill="#fff"/>`,
    "variant03": (components, colors)=>`<path d="M587.37 431.61a65.1 65.1 0 0 1 27.94 28.7c5.58-3.44 11.26-6.7 16.83-10.18 1.56-.93 3.14-1.94 4.89-2.46 1.93.56 2.77 1.31 2.72 3.44-.47 1.3-1.75 2-2.83 2.76-6.46 3.95-13.07 7.67-19.41 11.81 6.07 14.16 5.97 31.18.8 45.61a65.5 65.5 0 0 1-29.9 35.15 65.13 65.13 0 0 1-43.58 7 65.15 65.15 0 0 1-43.5-29.87 63.26 63.26 0 0 1-9.64-33.57 64.44 64.44 0 0 1 16.82-44.5c9.47-10.43 22.53-17.96 36.46-20.3a65.09 65.09 0 0 1 42.4 6.41Z" fill="#000"/><path d="M549.2 430.27c14.66-1.79 29.3 1.6 41.46 10.02a59.1 59.1 0 0 1 23.46 32.72 59.16 59.16 0 0 1-3.06 40.93c-6.2 13.86-18.05 25.26-32.25 30.69a57.97 57.97 0 0 1-31.8 3.4 59.6 59.6 0 0 1-40.36-26.66 61.47 61.47 0 0 1-9.37-29.35 60.43 60.43 0 0 1 13.41-40.34 59.53 59.53 0 0 1 38.51-21.41Z" fill="#fff"/><path d="M414.7 454.33a54.92 54.92 0 0 1 24.53 30.46c2.68 8.02 3.17 16.86 2.07 25.2a54.85 54.85 0 0 1-61.29 46.3c-15.79-1.8-30.36-10.98-39.03-24.27-5.54-8.33-8.47-18.05-9.1-28-.32-7.07 1.17-13.62 2.92-20.39a238.5 238.5 0 0 1-12.8-8.6c-1.7-1.23-1.84-2.14-1.54-4.17 1.3-1.26 2.74-1.6 4.35-.65 4.2 2.57 8.15 5.53 12.25 8.24 6.7-14.02 19.04-24.86 33.97-29.29a55.12 55.12 0 0 1 43.66 5.17Z" fill="#000"/><path d="M378.2 453.3c18.68-3.52 38.38 4.7 49.14 20.33 7.5 10.77 10.85 24.96 7.88 37.84a48.94 48.94 0 0 1-14.57 26.2A49.55 49.55 0 0 1 391 550.94c-20.13 1.85-40.14-9.82-48.62-28.14a49.3 49.3 0 0 1 35.82-69.5Z" fill="#fff"/><path d="M526.47 467.49c12-2.85 24.87 4.22 29.35 15.63a26.1 26.1 0 0 1-.08 18.72 25.64 25.64 0 0 1-41.14 9.56 25.7 25.7 0 0 1-6.76-27.6 25.54 25.54 0 0 1 18.63-16.31ZM398.22 478.36a23.17 23.17 0 0 1 24.44 11c3.46 5.59 3.67 12.26 2.25 18.53a23.78 23.78 0 0 1-15.87 15.27c-7.51 2.4-16.26.06-21.98-5.24-7.35-6.8-9.5-18-5.05-27a23 23 0 0 1 16.21-12.56Z" fill="#000"/>`,
    "variant02": (components, colors)=>`<path d="M559.01 424.1a65.32 65.32 0 0 1 43.93 18.98c5.76 5.61 9.95 12.31 13.6 19.43 7.87-5.09 15.8-10.08 23.76-15.03a50.52 50.52 0 0 1 3.56 3.46c-3.17 3.52-7.07 5.39-10.96 7.93-4.77 3.03-9.55 6.03-14.3 9.08 3.17 10 4.53 20.39 2.8 30.81a64.8 64.8 0 0 1-20.75 38.93A64.57 64.57 0 0 1 558 554.53a64.54 64.54 0 0 1-36.9-10.63 65.67 65.67 0 0 1-26.4-34.58c-4.57-14.5-4.06-30.74 1.8-44.81a65.1 65.1 0 0 1 28.11-31.9c10.31-6.05 22.51-8.86 34.4-8.5Z" fill="#000"/><path d="M549.27 430.26c14.65-1.77 29.27 1.62 41.4 10.04a59.45 59.45 0 0 1 20.39 73.64c-6.12 13.64-17.67 24.9-31.58 30.43a58.17 58.17 0 0 1-32.48 3.67 59.6 59.6 0 0 1-40.35-26.68 61.43 61.43 0 0 1-9.37-29.31 60.38 60.38 0 0 1 13.41-40.36 59.47 59.47 0 0 1 38.58-21.43Z" fill="#fff"/><path d="M414.05 453.95a55.06 55.06 0 0 1 23.87 27.2c3.5 8.51 4.54 17.78 3.61 26.9a54.83 54.83 0 0 1-27.1 41.38c-16.49 9.64-37.66 9.77-54.3.41a55 55 0 0 1-27.4-38.84c-1.8-8.9-.64-17.67 1.9-26.3-5.83-3.62-12.14-6.61-17.75-10.54-1.95-1.1-1.44-4.12.68-4.64 1.65-.48 3.18.6 4.6 1.28 4.83 2.83 9.64 5.66 14.48 8.47 6.58-14.13 18.65-25.2 33.6-29.87a55.21 55.21 0 0 1 43.81 4.55Z" fill="#000"/><path d="M378.27 453.29a49.32 49.32 0 0 1 42.11 12.35 50.02 50.02 0 0 1 15.93 36.37 51.36 51.36 0 0 1-6.07 23.26 49.5 49.5 0 0 1-33.98 24.9c-8.07 1.72-16.23 1.1-24.08-1.36-19.1-5.88-33.31-23.78-34.38-43.79-.98-12.79 3.48-25.72 11.85-35.4a49.5 49.5 0 0 1 28.62-16.33Z" fill="#fff"/><path d="M527.27 466.19c7.37-.9 15.21 1.78 20.25 7.3a24.2 24.2 0 0 1 6.4 15.46 23.88 23.88 0 0 1-8.72 19.24c-6.96 5.83-17.24 6.92-25.36 2.96-8.64-4.1-14.23-13.6-13.38-23.18.7-11.14 9.74-20.51 20.81-21.78ZM358.54 480.84c11.4-3.87 24.34 3 27.54 14.6 3.77 11.68-4.02 24.85-16.03 27.31-10.63 2.65-22.19-3.54-25.66-13.94-3.92-11.13 2.75-24.59 14.15-27.97Z" fill="#000"/>`,
    "variant01": (components, colors)=>`<path d="M589.95 433.05c11.85 6.92 21.04 17.5 26.7 29.97 5.94-3.13 11.68-6.68 17.7-9.63 1.78-.95 4.39.55 3.97 2.62.2 1.48-2.02 2.5-3.06 3.23-5.45 3-10.88 6.04-16.34 9.03 1.7 6.87 3.23 13.6 3.24 20.73-.06 12.85-3.69 25.61-10.87 36.3a65.88 65.88 0 0 1-31.79 25.28 65.87 65.87 0 0 1-38.5 2.03 65.1 65.1 0 0 1-40-29.6 63.2 63.2 0 0 1-9.31-33 64.44 64.44 0 0 1 15.41-42.92c9.58-11.27 23.24-19.42 37.87-21.9a65.18 65.18 0 0 1 44.98 7.86Z" fill="#000"/><path d="M549.2 430.27a59.7 59.7 0 0 1 44.36 12.14c14.46 11.19 23.27 29.3 22.81 47.6.02 22.44-13.8 43.89-34.2 53.21-10.96 5.08-23.24 7-35.17 4.83a59.56 59.56 0 0 1-40.74-27.3 61.53 61.53 0 0 1-8.98-28.72 60.36 60.36 0 0 1 13.88-40.9 59.51 59.51 0 0 1 38.04-20.85Z" fill="#fff"/><path d="M390.01 446.91a55.03 55.03 0 0 1 34.43 14.65c10.09 9.4 16.54 22.67 17.3 36.47a54.58 54.58 0 0 1-8.02 32.68 54.92 54.92 0 0 1-36.73 25.15 54.94 54.94 0 0 1-63.71-42.04c-2.36-9.4-1.56-18.93 1.03-28.19a605.7 605.7 0 0 0-11.32-4.5c-1.9-.78-4-1.44-5.35-3.08-.4-2.4.76-3.92 3.2-3.62 5.21 1.25 10 4.2 15.18 5.57 1.39-1.65 2.24-3.81 3.31-5.68 10.02-17.81 30.31-28.73 50.69-27.4Z" fill="#000"/><path d="M376.5 453.66c18.63-4.25 38.76 3.44 50 18.81a50.84 50.84 0 0 1 9.74 26.52c.67 13.61-4.44 27.48-14.06 37.18A49.44 49.44 0 0 1 392 550.83c-19.94 2.3-40.08-8.85-49.01-26.78a49.3 49.3 0 0 1 2.37-48.68 49.32 49.32 0 0 1 31.15-21.7Z" fill="#fff"/><path d="M578.28 465.43c6.24-.76 12.7.82 17.74 4.57 6.29 4.65 10.27 12.14 10.18 20a27.74 27.74 0 0 1-4.57 13.63c-4.1 6.13-11.27 10.06-18.6 10.54-8.2.5-16.42-3.28-21.25-9.97-6.02-7.97-6.24-19.8-.63-28.03a24.74 24.74 0 0 1 17.13-10.74ZM408.45 478.49c7.22-.86 14.8 2 19.61 7.47A21.98 21.98 0 0 1 433.8 502c.04 12-10.69 22.79-22.8 22.28-12.1.1-22.88-10.05-22.87-22.26-.7-11.81 8.67-22.32 20.32-23.53Z" fill="#000"/>`
};


/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ const $045609d5db6f2745$export$aebaafc0a0095705 = {
    "variant10": (components, colors)=>`<path d="M545.03 378.5c24.7.94 48.04 8.97 69.45 21 2.26 1.31 4.92 2.48 6.79 4.32 1.3 2.39-.38 5.13-3.2 4.19-16.58-6.2-33.56-9.63-51.06-12.02-20.3-2.34-39.92-3.68-60.2-.13-3.2.44-6.87 2.16-10.08 1.59-2.66-1.69-1.2-6.1 1.29-7.37 13.63-9.33 30.79-12.1 47-11.58ZM407.99 396.92c3.5.64 6.6 1.92 9.63 3.78-.15 1.2-.26 2.4-.33 3.62-2.7.74-5.46 1.12-8.24 1.34-13.17 1.15-26.45 5.1-38.81 9.69-12.23 4.75-24.78 10.64-35.19 18.7-2.82 2.04-4.13 4.83-8.08 4.48-.5-.9-1-1.79-1.51-2.67.9-1.6 1.68-3.17 2.76-4.64 9.55-13.17 23.64-23.22 38.6-29.35 12.7-5.15 27.62-8.05 41.17-4.95Z" fill="#000"/>`,
    "variant09": (components, colors)=>`<path d="M397.06 373.14c6.81.19 14.18 2.86 17.93 8.88 1.05 1.45.63 3.68.72 5.4-6.29.15-12.49.33-18.64 1.83-15.06 3.48-29.35 10.86-41.64 20.15-8.37 6.38-16.34 14.1-21.95 23.07-1.43 2.22-2.41 5.03-4.3 6.89-1.23.26-2.56.28-3.82.35-.05-1.77-.23-3.46.2-5.19 5.73-20.86 19.84-39.34 38.13-50.81 9.83-5.84 21.73-11.05 33.37-10.57ZM578.52 411.66c10.4 1.67 21.2 3.85 30 9.97l-.2 4.78c-4.07 1.6-7.3-.14-11.31-.77-6.82-1.2-13.9-1.25-20.83-1.11-29.25 1.32-58.23 9.9-83.97 23.74-1.44.63-2.9 1.06-4.4 1.54-2.6-5.36-3.62-10.91-.14-16.17 5.13-7.67 15.2-12.39 23.63-15.44 21.34-7.36 44.88-9 67.23-6.53Z" fill="#000"/>`,
    "variant08": (components, colors)=>`<path d="M530.96 352.34c21.47-3.31 42.8 3.14 60.6 15.1 12.06 8.18 22.9 19.67 28.97 33.02 1.1 2.96-.3 3.73-2.5 5.27-3.96-2.26-6.88-5.58-10.48-8.3-13-9.77-28.03-16.37-43.78-20.24-14.93-3.5-30.56-5.05-45.8-2.8-4.78.41-9.28 1.92-13.97 2.67-2.41.2-5.1-1.2-4.2-4.04 1.89-4.15 4.22-8.5 7.59-11.65 6.04-5.62 15.64-7.85 23.57-9.03ZM383 428.83c13.38-.82 26.33-.6 39.03 4.23 5.85 2.37 11.52 5.91 13.93 12.05 1.38 4.31.91 8.87-1.73 12.61-4.9-.76-9.4-2.6-14.18-3.82-23.13-6.33-47.19-8-71.04-5.96-4.88.33-9.86 2.03-14.72 1.78-1.78-.48-1.17-2.2-.97-3.54.88-2.5 3.58-3.86 5.76-5.1 13.75-7.24 28.55-10.64 43.92-12.25Z" fill="#000"/>`,
    "variant07": (components, colors)=>`<path d="M452.03 395.85c.66 4.64-1.5 9.35-4.2 13-3.6 4.46-7.82 8.36-12.86 11.13-7.66 4.35-15.96 7.7-24.2 10.81-23.78 8.79-48.55 15.1-73.5 19.48-3.36.54-6.98 1.5-10.37 1.11-1.92-.92-2-2.82-1.1-4.52 2.33-1.8 5.48-2.72 8.18-3.89 35.94-14.72 71.88-29.45 107.8-44.2 3.36-1.25 6.6-3.38 10.25-2.92ZM478.97 396c49.32 7.61 98.68 15.15 148.01 22.75 2.58.42 5.33.58 7.8 1.41 2.45 1.14 1.71 5.04-.95 5.26-9.6.95-19.18 1.82-28.83 1.95-15.39.1-30.64.32-45.98-1.18-20.9-1.64-42.24-4.59-62.25-11.06-6.97-2.4-14.88-5.46-20.27-10.64-1.8-1.9-4.09-4.28-3.17-7.13 1.22-2.13 3.6-1.6 5.64-1.36Z" fill="#000"/>`,
    "variant06": (components, colors)=>`<path d="M501.99 384.96c9.9.12 19.87 3.23 28.83 7.31 3.36 1.88 7.05 4 7.3 8.3-5.13-.87-10.13-2.07-15.37-2.3-11.6-.67-23.13 1.37-33.25 7.24-2.54 1.41-4.95 3.26-7.64 4.35-1.8.27-3.92-2-3.94-3.73-.18-5.81 1.95-11.92 6.53-15.7 5.03-4.23 11.15-5.3 17.54-5.47ZM414.03 402.61c5.81.15 10.93 5.3 12.51 10.64.8 2.63-.46 5.72-3.53 5.61-8.82.2-18.2.03-26.81 2.26-7.52 2-14.74 6.7-21.36 10.74-1.22.81-2.57.96-3.98 1.22.33-1.93.64-3.66 1.94-5.2a97.47 97.47 0 0 1 10.74-12.31c5.88-5.17 13-8.96 20.32-11.66a25.26 25.26 0 0 1 10.17-1.29Z" fill="#000"/>`,
    "variant05": (components, colors)=>`<path d="M523.24 384.36c6.17-.42 13.1-.61 18.45 2.95 3.68 2.44 5.4 6.35 4.48 10.74-1.55 6.16-6.62 10.92-11.61 14.5a67.57 67.57 0 0 1-30.57 11.53c-5.61.53-12.5.43-17.47-2.55-3.63-2.13-5.9-6.12-5.2-10.36 1.02-5.75 5.5-10.5 9.94-13.96 9.19-7.03 20.55-11.34 31.98-12.85ZM392.22 401.23c9.1-.36 18.3.5 26.3 5.24 3.86 2.26 7.35 5.89 7.9 10.49.34 4.21-1.96 7.8-5.19 10.27-4.52 3.55-9.87 5-15.43 6-9.95 1-20.55.31-29.48-4.6-3.87-2.28-7.88-5.84-8.47-10.56-.73-4.27 2.02-8.47 5.39-10.84 5.4-3.87 12.43-5.69 18.98-6Z" fill="#000"/>`,
    "variant04": (components, colors)=>`<path d="M582.3 370.69c14.06 7.04 27.75 17.35 36.57 30.53a2.98 2.98 0 0 1-4.23 4.15 100.16 100.16 0 0 0-34.46-13.42c-35.66-6.86-74.47 5.14-98.23 33.03-1.67 2.05-4.03 3.59-6.28 1.25-1.68-2.6-2.27-6.05-3.3-8.95-1.92 4.71-3.86 9.5-6.2 14.02-1.56 3.23-6 1.12-7.04-1.42-3.06-6.88-6.2-13.74-9.02-20.73 0 5.63 0 11.25.04 16.88-.19 2.06.27 4.35-2.1 5.22a5.55 5.55 0 0 1-5.31-2.91c-3.26-5.88-6.24-11.93-9.5-17.82.97 5.5 2.61 11 3.11 16.55.12 1.94-2.28 3.44-4.02 2.36-18.54-7.4-38.31-11.5-58.33-10.1-12.5.93-26.14 4.64-36 12.69-3.09 2.34-5.2 5.5-7.97 8.15-1.65.72-3.27-.24-4.88-.65.08-1.9.11-3.75.73-5.58 6.86-20.67 20.43-39.8 39.98-50.1 13.56-7.32 30.17-9.03 44.62-3.35 11.89 4.55 20.95 13.32 27.67 23.95 2.31-2.84 4.25-6.03 6.75-8.7 1.62-1.57 4.62-1.56 5.63.7 2.52 5.16 4.68 10.52 6.98 15.8 1.5-7.43 3.06-14.82 4.43-22.25.33-1.5.6-3.23 1.58-4.45 1.65-1.25 2.9-.28 4.65.1l.8 2.56c2.08-4.75 4.75-9.11 8.44-12.78 9.1-9.43 21.82-14.25 34.5-16.48 23.85-3.69 48.86 1.12 70.39 11.75Z" fill="#000"/>`,
    "variant03": (components, colors)=>`<path d="M456.01 380.37c2.26-.07 2.85 1.7 2.65 3.64-.5 4.68-.77 9.78-2.32 14.23-1.33.39-2.66.58-4.03.82-1.12-4.8 0-10.22.7-15.09.37-1.71.78-3.82 3-3.6ZM476.79 386.65c.03 3.21-.36 6.36-.67 9.55 41.69.52 83.32.38 125 .75 2.14.04 3.97.86 5.9 1.64-.6 1.48-.22 3.83-2.24 4.1-8.05 1.3-16.58.5-24.74.87-17.35.62-34.7 1-52.06 1.53-17.03.2-34 1.25-51.05 1.42-3.3.39-6.05-2.72-7.2-5.47.02-4.5 1.02-9.15 2.06-13.5 1.28-2.48 2.83-1.67 5-.9ZM439.84 392.18c-.1 4.87-.05 10.81-2.28 15.24-3.22 1.5-7.12 1.79-10.59 2.47-25.65 4.69-51.32 9.34-76.96 14.08-4.24.69-8.7 2.15-13 2.04-2.62-.48-3.32-3.75-.86-5 3.2-1.42 6.95-1.75 10.33-2.59 29.1-6.7 58.15-13.6 87.24-20.32.4-1.91.8-3.81 1.27-5.7 1.61-.21 3.23-.24 4.85-.23Z" fill="#000"/>`,
    "variant02": (components, colors)=>`<path d="M606.99 397.59c1.52-.4 3.26.6 4.74.97-.11 1.2-.17 2.45-.47 3.61-1.58 1.5-3.57 2.6-5.39 3.78-22.77 14.6-46.18 28.4-70.32 40.63-11.53 5.73-23.34 11.3-35.55 15.44-6.86 2.19-13.72 4.28-21 3.44-3.32-.31-6.17-3.02-6.24-6.43-.04-4.22 3-8.6 5.08-12.15 1.28-2.68 4.5-3.04 7-4.12 37.23-13.75 74.43-27.65 111.66-41.45 3.48-1.23 6.9-2.81 10.5-3.72ZM338.99 432.64c29.88 5.94 60.13 12.03 90.02 18.02 2.27.32 4.6.07 6.85.45 2.45 2.3 3.64 6.2 4.54 9.37 1.17 4.09-.15 8.77-3.9 11-4 2.63-9.92 2.17-14.5 1.9-8.75-1-17.42-3.8-25.69-6.74-19.61-7.16-38.69-16.93-56.97-26.97-1.67-.96-3.68-1.94-4.79-3.55-.38-2.88 1.85-4.16 4.44-3.48Z" fill="#000"/>`,
    "variant01": (components, colors)=>`<path d="M613.54 401.51c1.6 1 1.08 2.86 1.24 4.48-.06 11.34-.05 22.7-.12 34.04.32 2.75-2.42 4.22-4.62 5-40 13.74-80.12 27.25-120.05 41.12-2.53.2-2.84-1.75-3.5-3.66-1.64-6-3.31-11.98-5.02-17.95.97 5.75.98 11.66 1.36 17.47-.02 1.44.45 3.94-1 4.85-1.94 1.4-4.06.13-4.59-2.03-3.64-12.73-7.02-25.58-10.66-38.32-.39-1.83-.65-3.9 1.36-4.88 2.11-.5 3.41.47 4 2.44 1.27 4.55 2.55 9.11 3.68 13.7-.73-5.24-.94-10.5-1.18-15.77 0-1.27-.14-3.73 1.66-3.8 1.47-.25 2.98-.37 4.43-.7 41.23-11.75 82.37-23.45 123.6-35.23 3.27-.87 6.02-2.08 9.4-.76ZM324 433.87c13.64 1.39 27.36 1.44 41 2.58 21.04 1.05 42.11 2.67 63.14 3.42 7.8.78 15.61 1.12 23.44 1.68 2.77 2.19 1.08 8.08 1.91 11.33.56-2.97.18-6.9 1.92-9.46a2.85 2.85 0 0 1 4.76 2.56c-2.36 14.03-4.77 28.14-7.02 42.18-.8 2.93-4.48 2.56-5.29-.15-.27-4.92-.21-9.89-.28-14.83-1.03 4.3-1.47 8.69-2.47 12.98-.42 1.64-1.16 2.84-3.1 2.4-39.47-6.89-79.39-14.23-118.86-21.3-1.88-.19-2.83-1.45-3.09-3.25-1.45-7.98-2.5-16.04-4.12-24-.23-1.7-.74-3.13.56-4.57 2.12-2.3 4.72-1.68 7.5-1.57Z" fill="#000"/>`,
    "variant15": (components, colors)=>`<path d="M568.44 405.96c-.6-2.92-2.48-4.87-4.6-6.82-11.98-10.95-29.88-15.87-45.64-11.58-9.72 2.4-18.51 8.36-23.63 17.06-2.83 5.03-4.78 10.54-3.98 16.4.08.42.13.83.18 1.23.2 1.63.37 3 2.44 3.54 2.17.12 4.4-.29 6.54-.68l.31-.06 6.22-1.2c5.24-1 10.48-2 15.68-3.19a640.08 640.08 0 0 0 44.88-11.08c1.77-.25 1.7-1.62 1.63-3.02l-.03-.6ZM430.1 431.05c-.81-9.8-8.9-17.41-17.88-20.31a39.68 39.68 0 0 0-38.34 9.13c-4.45 4.18-8.39 9.97-9.12 16.14-.08 2.74 2.36 2.78 4.44 2.82.26 0 .52 0 .77.02 3.02-.08 6.05-.14 9.07-.2 9.34-.17 18.7-.35 27.98-1.3 2.4-.21 4.83-.38 7.24-.54 4.26-.3 8.52-.58 12.74-1.14 2.42.03 3.28-2.6 3.1-4.62Z" fill="#000"/>`,
    "variant14": (components, colors)=>`<g fill="#000"><path d="M517.07 379.66c.86-.91 2.17-2.3 1.77-3.56-.35-2.45-3.58-3.11-5.22-1.46a221.7 221.7 0 0 0-8.34 7.33c-2.16 1.96-4.3 3.92-6.5 5.8a117.9 117.9 0 0 1-3.06 2.73c-2.64 2.3-5.21 4.56-7.32 7.5.33.33.6.68.88 1.02.72.9 1.4 1.74 2.73 1.81 1.5-.08 2.71-1.13 3.82-2.1l.41-.35c4.3-4 8.7-7.9 13.1-11.8 2.52-2.24 5.05-4.47 7.55-6.73l.06-.07.12-.12ZM539.69 378.66c.54-1.8-.18-2.95-1.6-4-2-.34-3.84.74-5.58 1.76-.44.26-.87.51-1.3.74-4.43 2.64-8.92 5.2-13.4 7.77-4.83 2.76-9.66 5.51-14.4 8.37-1.63.86-1.65 2.04-1.68 3.44 0 .45-.02.93-.08 1.42.46.1.9.24 1.31.38 1.2.4 2.27.75 3.58-.05 5.06-2.8 10.07-5.7 15.09-8.62a959.63 959.63 0 0 1 14.42-8.28c1.36-.8 2.87-1.67 3.65-2.94ZM566.39 378.4c2.1-.74 4.24.22 4.44 2.6-.08 2.3-1.76 2.9-3.53 3.51l-.77.28c-12.18 3.72-24.35 7.5-36.5 11.31-.37.09-.73.2-1.08.3-1.34.4-2.64.78-4 .08-1.82-1.26-1.8-4.32.36-5.22 1.8-.82 3.73-1.38 5.65-1.93a4048.39 4048.39 0 0 0 14.1-4.35c7.1-2.22 14.2-4.44 21.33-6.58ZM589.38 390.36c1.02-1.63.62-2.97-.45-4.43-2.25-.73-4.9-.11-7.4.47-.87.2-1.72.4-2.52.53-2.84.58-5.7 1.14-8.54 1.7h-.02c-4.14.81-8.27 1.62-12.4 2.5-1.87.47-3.69 1.64-3.1 3.87.65 2.02 2.02 2.45 4.03 2.12 4.01-.7 8-1.52 12-2.35 3.85-.8 7.7-1.6 11.56-2.27l1.3-.26c1.93-.36 4.05-.75 5.54-1.88ZM405.8 394.7c1.93 1.26 3.85 2.5 5.81 3.7.74.48 1.5.94 2.25 1.4 1.73 1.05 3.47 2.11 5 3.4 1.7 1.35 1.2 4.27-.83 5-1.8.35-3.06-.44-4.43-1.29l-.94-.56c-4.3-2.78-8.62-5.51-12.95-8.25l-4.17-2.64c-.1-.08-.22-.17-.35-.25l-.37-.27c-1.1-.75-2.42-1.66-2.4-2.93-.35-2.43 2.22-4.08 4.37-2.87 3.08 1.7 6.05 3.64 9.01 5.57Z"/><path d="M383.94 395.53a45.88 45.88 0 0 0-5.95-1.72c-2.5-.5-4.12 2.02-3.31 4.28 1.14 1.27 2.56 1.75 4.08 2.26l.4.14.32.1c4.02 1.26 8.03 2.55 12.03 3.85h.03c4.14 1.34 8.27 2.68 12.42 3.96 2.46.78 4.88.57 5.36-2.42-.17-2.11-2-2.8-3.72-3.44l-.15-.05-.23-.09-.5-.2c-6.06-1.95-12.14-3.89-18.22-5.83-.85-.26-1.7-.55-2.56-.84ZM587.13 395.34c3.45-.22 6.9-.28 10.37-.34 2.5-.05 5-.1 7.5-.2.4.03.84.03 1.3.03 1.67 0 3.6 0 4.35 1.53 1.26 1.74-.2 3.78-2.02 4.19-2.91.62-6.04.6-9.1.58-1.19 0-2.37-.01-3.53.02-1 0-2 .04-3 .07-1.68.05-3.36.1-5.04.04-1.22 0-3.12-.35-3.5-1.7a3 3 0 0 1 2.67-4.22ZM360.28 402.87c-2.04-.1-4.17-.2-6.08.32-1.5 1.2-1.47 3.44-.15 4.8 1.66.7 3.64.86 5.45 1l.16.01.32.03c3.43.16 6.85.37 10.27.58 3.92.25 7.83.49 11.74.66.85.02 1.72.1 2.6.18 1.84.18 3.72.35 5.44-.06a2.78 2.78 0 0 0 1.12-4.59c-.84-.99-1.87-1.05-2.98-1.12-.38-.03-.77-.05-1.16-.11l-12.51-.81-12.5-.81c-.57-.01-1.14-.04-1.73-.07ZM348.97 411.64l4.48-.33c4.19-.34 8.4-.68 12.56-.42 2.93.26 3.13 4.75.25 5.42-2.9.73-5.97.84-9.03.96-1.76.06-3.52.13-5.23.31-1.17.04-2.36.15-3.55.25-2.47.22-4.96.44-7.36.12-2.45-.43-2.74-4.43-.52-5.35 1.77-.65 3.79-.73 5.76-.8.9-.04 1.79-.07 2.64-.16ZM345.51 425.36c2.91-.95 2.78-5.26-.48-5.63-2.85.03-5.72.55-8.57 1.06-1.35.24-2.69.48-4.02.67-.74.18-1.6.3-2.52.4-2.27.28-4.78.6-6.04 2.18-1.16 2.39.53 4.6 3.07 4.38 6.17-.74 12.5-1.76 18.56-3.06Z"/></g>`,
    "variant13": (components, colors)=>`<path d="M614 406.99c-24.74-23-58.3-35.43-92-35.08-8.9.26-17.67 1.52-26.42 3.12-1.5 3.24-2.51 6.6-3.52 9.98-.37 1.22-.73 2.44-1.12 3.66l-.13-1.4a170 170 0 0 0-1.31-11.32l-3.23-1.56c-.21.37-.5.74-.8 1.12-.6.76-1.23 1.55-1.26 2.44-.1 3.74.3 7.48.71 11.22.3 2.78.6 5.57.7 8.37.08.67.12 1.4.16 2.16.13 2.41.28 5.08 1.65 6.85 2.83.76 6.04-.34 9.02-1.36 1.06-.36 2.08-.7 3.05-.96 18.93-5.52 39.16-6.87 58.7-4.41 20 2.31 40.08 8.25 57.45 18.55 1.95 1.1 4 1.81 6.12 2.5l1.77-3.35c-2.7-3.96-6.05-7.28-9.54-10.53ZM422.26 399.6c.13-4.24.27-8.47.03-12.67-.25-2.54-1.86-2.58-3.72-2.62-.33 0-.66 0-1-.03-.92 3.61-1.06 7.52-1.21 11.37-.06 1.66-.13 3.3-.25 4.91a198.7 198.7 0 0 1-4.5-11.36c-.14-.25-.25-.54-.37-.83-.43-1.08-.9-2.26-2.24-2.23-2.5-.06-5.02.4-7.53.84-1.15.2-2.3.42-3.44.57-18.15 3.2-37.02 9.52-52.08 20.37-6.61 4.82-13.05 11.1-16.67 18.52-1.44 3.11-2.83 6.47-1.59 9.9l.41.12c1.08.33 2.6.8 3.42.06.93-.7 1.82-1.43 2.72-2.15 2.06-1.68 4.1-3.34 6.5-4.6 7.97-4.3 16.79-7.19 25.5-9.59 13.84-3.56 28.46-6.2 42.8-5.7 1.83.01 3.63.27 5.43.53 1.88.26 3.77.53 5.67.53 1.8-1.27 1.85-3.62 1.89-5.77 0-.62.02-1.2.07-1.76-.02-2.8.07-5.6.16-8.42Z" fill="#000"/>`,
    "variant12": (components, colors)=>`<path d="M414.18 389.84c-5.5-7.26-14.52-9.33-23.2-8.38-13.12 1.9-24.56 8.53-34.46 17.08-10.76 9.47-19.88 21.7-24.72 35.27-.66 1.92-1.27 4.69 1.03 5.74 2.1.24 2.83.08 4.11-1.6 11.58-14.9 26.26-27.61 43.54-35.44 8.2-3.6 17.55-6.09 26.55-5.69 1.03.04 2.1.21 3.15.39 1.67.27 3.35.55 4.96.3 2.9-2.23.74-5.27-.86-7.53l-.1-.14ZM592.9 408.15c-18.2-10.23-38.04-17.1-58.92-18.97-10.05-.75-21.44-.2-30.72 4.09-6.76 3.16-12.37 8.56-13.57 16.22l-.12.95c-.38 2.89-.88 6.8 1.32 8.78 1.99.78 3.6-.34 5.23-1.46.74-.51 1.49-1.03 2.27-1.36 13.86-6.86 30.29-9.28 45.61-9.7 15.48.06 31.36 2.13 46.03 7.2l.48.13c1.46.4 2.74.74 3.89-.62 1.8-1.88.48-4.24-1.5-5.25Z" fill="#000"/>`,
    "variant11": (components, colors)=>`<path d="M530.99 353.9c17.06 1.95 34 7.42 48.62 16.5 6.84 4.33 13.98 9.93 18.27 16.9.9 1.17 1.25 3.53-.22 4.34-1.19 1.18-2.85.5-4.15-.1-16.36-8.83-35.52-13.28-53.92-15.02-13.52-.79-28.3-.86-41.16 3.86-2.92 1.03-5.5 2.98-8.47 3.85-1.37.25-2.43-1.11-2.88-2.26-1.81-4.7-2.23-10.24.18-14.8 2.6-5.35 7.91-8.65 13.31-10.66 9.68-3.6 20.27-3.32 30.42-2.61ZM414.04 408.09c8.18 2.36 14.6 10.77 13.54 19.42-1.87.56-3.6 1-5.58.73-14.22-1.45-29.3 1.52-42.82 5.85-14.05 4.67-28.5 11.6-39.42 21.77-1.34 1.3-4.25 2.95-5.5.75-1.73-2.36.02-4.07 1.38-5.97 12.84-16.22 29.69-30.97 48.9-39.03 8.9-3.65 20.04-6.5 29.5-3.53Z" fill="#000"/>`
};


/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ const $58a6e2cfc8556f88$export$4ec1914b3efc3f9a = {
    "variant30": (components, colors)=>`<path d="M517.87 557.3c2.33.2 3.18 2.72 2.32 4.67-1.4 3.57-3.16 7-4.64 10.53-8.44 19.32-19.56 37.08-31.84 54.17-1.4 1.83-2.87 3.96-4.81 5.27-2.97.78-6.1.75-8.65-1.18a129.37 129.37 0 0 1-24.3-22.74c-7.03-7.83-13.5-16.1-18.86-25.17-1.05-2.12-2.54-4.48-1.19-6.81 1-1.56 3.22-2 4.86-2.55 11.13-3.1 22.19-6.48 33.39-9.29a235.06 235.06 0 0 1 35.86-5.71c5.9-.54 11.94-1.42 17.86-1.2Z" fill="#000"/><path d="M513.81 563.01c-8.96 21.23-21 40.76-34.34 59.5-.92 1.13-2.13 2.82-3.66 3.08-2.18.55-3.7-.86-5.38-2-8.5-6.52-15.77-14.18-22.74-22.27a137.4 137.4 0 0 1-16.59-22.31c14.95-4 29.9-8.63 45.12-11.4 12.45-2.5 25-3.27 37.59-4.6Z" fill="#8F2E45"/>`,
    "variant29": (components, colors)=>`<path d="M517.9 557.82c1.53.3 2.76 1.6 2.73 3.2-7.1 16.81-15.06 33.2-25.17 48.42-4.62 6.97-9.13 14.14-14.43 20.6-2.18 3.28-7.96 2.93-10.79.73a126.22 126.22 0 0 1-19.13-16.87c-9.22-10.37-17.94-20.12-24.71-32.38-.81-1.89-2.3-3.93-.75-5.87.54-1.24 2.97-.86 3.53.16a140.4 140.4 0 0 0 18.52 25.5c6.97 8.1 14.24 15.75 22.74 22.28 1.12.8 2.37 1.74 3.7 2.1 2.62.27 3.9-1.32 5.33-3.2 13.52-19.02 25.72-38.75 34.68-60.37.81-2 1.46-3.68 3.75-4.3Z" fill="#000"/>`,
    "variant28": (components, colors)=>`<path d="M524.2 555.79c.5 6.88-.8 13.42-1.56 20.21a245.12 245.12 0 0 1-19.15 70.23c-3.65 7.33-6.74 15.74-13.95 20.34-4.25 3.06-10.3 1.77-14.6-.52-9.5-4.69-15.15-12.28-21.77-20.2-10.97-13.4-18.85-28.33-26.05-44-3.56-8.2-6.83-16.5-10.25-24.75-.87-2.13-1.17-4.1 1.07-5.43 4.72 0 9.31 1.5 14.06 1.5 9.3.25 18.74.41 27.98-.8 19.98-2.3 39.64-8.31 58-16.45 2.12-1.07 4.02-.6 6.22-.13Z" fill="#000"/><path d="M518.93 561.99c-1.93 15.16-3.98 30.2-8 44.98-4.7 16.77-10.28 33.84-19.06 48.96-2.17 3.44-5.3 7.34-9.89 6.51-7.43-1.55-14.07-8-18.68-13.73-9.88-10.97-17.89-23.26-24.61-36.38-6.13-11.12-10.64-22.89-15.69-34.52 4.8.44 9.6.8 14.4 1.2 1.13 5.94 4.6 11.5 8.45 16.07 5.08 5.94 12.23 9.8 20.13 9.97a27.87 27.87 0 0 0 16.68-7.36c8.02-7.35 11.96-17.07 14.48-27.43a265.03 265.03 0 0 0 21.79-8.27Z" fill="#8F2E45"/><path d="M490.65 572.12c-2.55 8.79-7.09 18.39-14.95 23.6-5.47 3.76-12.7 4.38-18.57 1.11-7-3.86-10.9-10.5-13.93-17.65 16.1-.33 32-2.32 47.45-7.06Z" fill="#fff"/>`,
    "variant27": (components, colors)=>`<path d="M524.16 555.86c.61 6.97-.8 13.29-1.53 20.14a244.24 244.24 0 0 1-19.15 70.23c-3.65 7.33-6.72 15.74-13.94 20.34-3.86 2.79-9.11 1.94-13.2.16-4.48-2.23-8.94-4.98-12.4-8.63a171.31 171.31 0 0 1-29.95-42.13c-6.76-12.54-11.65-25.76-17.12-38.87-.92-2.1-1.13-4.11 1.07-5.43 4.38-.1 8.65 1.41 13.06 1.45 9.89.33 20 .52 29.81-.88 17.69-2.04 35.09-7.15 51.54-13.9 4.22-1.53 7.13-4.31 11.8-2.48Z" fill="#000"/><path d="M518.92 562c-2.1 16.35-4.16 32.05-8.89 47.96-9.07-.71-18.45 2.59-26.46 6.61-10.54 5.48-21.2 13.48-27.26 23.89-7.57-9.81-13.74-20.42-19.35-31.44-5.4-10.14-9.36-20.75-13.97-31.24 9.45.8 18.5 2.05 28 1 23.2-.72 46.68-7.68 67.93-16.78Z" fill="#8F2E45"/><path d="M508.19 616.1c-3.83 13.3-8.82 26.4-15.55 38.52-1.62 2.89-3.68 5.84-6.7 7.39-4.1 1.71-9.13-1.19-12.46-3.5-5.34-3.38-8.58-8.29-12.86-12.75 1.94-5.34 6.2-9.98 10.4-13.7 7.82-6.68 17.1-12.04 27-14.9 3.33-1.04 6.71-1.16 10.17-1.06Z" fill="#EA869E"/>`,
    "variant26": (components, colors)=>`<path d="M517 555.43c13.39-.24 28.7 3.46 38.6 12.98 5.97 5.58 9.72 13.37 9.9 21.58.32 10.21-3.84 19.58-9.89 27.58-9.04 11.85-21.87 20.72-35.47 26.57-7.32 2.84-14.4 5.71-22.15 7.24a86.28 86.28 0 0 1-50.03-5.3c-13.98-6.02-27.24-14.25-38.31-24.72-5.42-5.3-10.58-11.7-13.28-18.84-2.03-5.48-2.34-11.97 1.22-16.9 3.69-5.38 9.98-7.75 16.17-8.85 12.6-1.77 24.45.42 36.57 3.76 7.36-6.86 15.88-12.06 25.02-16.2 13-5.75 27.38-9.3 41.64-8.9Z" fill="#000"/><path d="M542.47 566.35c-3.47 2.67-7.33 4.74-10.83 7.34-4.3 4.07-7.6 10.96-12.77 14.1-5.16.83-10.5-3.33-15.18-1.12a174.6 174.6 0 0 1-28.5 7.9c-14.13 2.57-29.47 3.77-43.63.89-4.3-1.11-7.12 1.32-11.46 1.88-4.37-4.22-7.53-9.21-12.73-12.6 12.76-5.3 28.76-1.98 41.63 1.52 3.92 1.25 6.04-2.46 8.8-4.48 13.48-10.73 30.18-17.54 47.23-19.85 12.66-1.87 25.64-.74 37.44 4.4Z" fill="#fff"/><path d="M547.96 569.91c7.13 4.3 11.65 12.83 11.82 21.1-.18 7.43-2.97 13.98-6.8 20.23-6.37-2.56-13.17-3.29-20-2.88-14.35.89-28.53 4.42-41.9 9.67-9.04 3.64-18.05 8.23-25.74 14.27a32.46 32.46 0 0 0-8.76 10.38c-7.74-2.15-14.6-5.75-21.53-9.73-9.94-5.85-19.02-12.62-26.5-21.47-3.77-4.64-7.55-10.34-7.78-16.5-.14-2.32.91-4.42 1.72-6.54 5.4 3.65 9.36 8.64 14.22 12.85 4 3.4 9.21-.66 13.75.07 5.81.96 11.66 1.4 17.53 1.74a174.18 174.18 0 0 0 59.65-11.55c4.16.86 9.89 2.73 13.97 1.05 4.92-2.83 8.62-8.57 12.18-12.9 1.47-1.75 3.81-2.92 5.71-4.17 2.9-1.75 5.48-4.02 8.46-5.62Z" fill="#8F2E45"/><path d="M536 614.18c4.54-.1 8.95.63 13.3 1.9-9.23 11.12-22.42 19.3-35.85 24.38-16.26 6.04-34.23 8.32-51.21 3.94a34.42 34.42 0 0 1 6.76-7.39c8.9-7.26 20.2-12.2 31-15.97 11.5-3.83 23.85-6.67 36-6.86Z" fill="#EA869E"/>`,
    "variant25": (components, colors)=>`<path d="M522.82 563.04c10.94 1.36 21.85 6.96 27.22 16.95 3.39 6.26 4.89 14.23 3.3 21.22-1.46 10.35-7.53 20.05-14.5 27.62a76.94 76.94 0 0 1-44.81 23.04 92.7 92.7 0 0 1-42.88-3c-8.75-2.81-16.6-7.54-23.81-13.16-8.31-6.76-15.78-15.35-19.58-25.48a33.06 33.06 0 0 1-1.77-17.28c1.2-6.9 6.43-12.62 12.81-15.26a36.97 36.97 0 0 1 21.19-1.83c9.02 1.21 16.75 5.04 24.7 9.17 14.67-15.16 36.94-24.58 58.13-22Z" fill="#000"/><path d="M518 568.55c8.8.31 17.43 3.3 23.68 9.68-3 3.63-6.83 6.32-11 8.45-1.69.91-3.64 1.7-5.06 3-2.43 2.96-3.61 8.2-6.65 10.48-3.54-1.12-6.78-3.83-9.93-5.8a175.42 175.42 0 0 1-44.04 4.58c-11.05.23-22.04-.67-32.94-2.47-1.81-.27-4.09-1-5.85-.33-2.18 1.44-3.94 3.6-5.81 5.4-1.83-2.83-3.68-5.66-5.46-8.54l-2.73-1.25c2.73-6 8.37-9.5 14.77-10.37 11.68-1.64 24.09 2.63 34 8.6 1.96 1.02 3.62 2.33 5.79.88 2.83-2.16 5.16-4.92 8-7.08 11.96-9.59 27.77-15.96 43.23-15.23Z" fill="#fff"/><path d="M545.34 583.32a29.2 29.2 0 0 1 2.14 17.66c-1.97 9.52-7.06 17.79-13.83 24.66-10.82 11.28-26.42 18.1-41.67 20.62-11.17 1.37-23.03 1.31-33.94-1.69-14.7-3.87-28.12-12.06-37.6-24.04-5.22-6.78-9.17-14.14-9.37-22.9 2.6 2.67 3.87 6.23 6.31 8.96 4.2 3.28 7.73-2.11 10.5-4.66 17.64 2.5 36.38 4.36 54.12 2.36 8.82-.4 17.5-1.87 26.14-3.56 3.7 1.43 8.33 5.92 12.7 4.94 6.03-2.25 6.05-11.84 12.25-13.61a42.73 42.73 0 0 0 10.12-6.82l2.13-1.92Z" fill="#8F2E45"/>`,
    "variant24": (components, colors)=>`<path d="M534.29 562.56c7.92 1.16 15.41 4.36 21.23 9.92 8.1 7.57 12.12 18.53 11.86 29.52.34 9.78-2.38 19.12-6.68 27.8a82.54 82.54 0 0 1-31.98 33.94c-11.83 6.96-25.1 10.44-38.72 11.36-30.63 1.61-61.2-11.84-82.09-34.04-6.37-8.12-11.85-18.46-11.45-29.06a24.8 24.8 0 0 1 10.45-20.16c6.92-4.97 14.77-6.31 23.1-6.8 14.2.16 27.8 4.33 40.17 11.13 8.52-12.59 20-22.9 34.03-28.96a56.4 56.4 0 0 1 30.09-4.64Z" fill="#000"/><path d="M533.47 568.33c9.24 1.28 17.97 6.24 22.9 14.3 5.96 9.6 6.65 21.04 3.8 31.79-4.04-.55-7.89-.69-11.96-.2-10.83.62-21.72 3.37-31.95 6.96 1.4-7.49 2.53-16.65-.57-23.85-1.7-3.84-5.4-6.2-9.58-4.33-6.58 3.12-10.3 11.89-13.02 18.22-4.75-1.63-11.32-3.78-16.06-1.23-3.89 2.19-3.78 6.53-2.42 10.26 2.56 6.21 7.7 11.08 12.64 15.44-12.05 7.9-22.81 17.29-31.17 29.09a103.78 103.78 0 0 1-40-23.82c-6.74-6.44-12-15.15-13.62-24.38-1.13-6.35.66-13.23 5.31-17.81 4.47-4.6 11-6.66 17.2-7.5 11.8-1.52 24.47 1.81 35.25 6.5 3.75 1.52 7.1 3.83 10.78 5.43 2.67.3 3.7-3.41 5.1-5.15 9.05-13.35 22.94-24.15 38.64-28.36 5.96-1.82 12.57-1.87 18.73-1.36Z" fill="#8F2E45"/><path d="M508.97 597.86c2.64 2.37 2.74 6.8 2.88 10.12-.08 10.9-3.14 21.9-7.97 31.65-4-2.1-7.93-4.17-11.35-7.18-4.32-3.77-9.1-7.97-11.95-13-.89-1.46-.92-3-1.16-4.64 5.16-.73 9.19 1.01 13.81 2.87 2.79 1 3.86-1.4 4.96-3.44 2.44-5.54 5.13-13.33 10.78-16.38Z" fill="#D32020"/><path d="M558.62 619.94a70.8 70.8 0 0 1-11 19.63c-3.78 4.78-8.56 8.9-13.02 13.05-9.94 8.14-22.52 13.35-35.12 15.57-12.5 1.97-25.18 1.2-37.5-1.56 8.1-11.13 18.64-19.92 30.29-27.15 3.76 2.33 7.58 5.16 11.76 6.65 1.4.62 2.77-.42 3.56-1.5 3.17-4.9 4.87-10.03 6.78-15.43.38-1.43 1.62-1.55 2.8-2.1 12.98-4.74 27.57-8.13 41.45-7.16Z" fill="#EA869E"/>`,
    "variant23": (components, colors)=>`<path d="M535.03 562.93c9.64 1.78 18.64 8.36 22.66 17.4 3.3 7.29 4.24 15.74 3.54 23.67-1.11 11.35-7.23 22.08-15 30.25-8.7 9.5-20.77 15.9-33.23 18.82-20.17 4.42-41.87 5.15-62.03.33-14.26-3.37-27.76-9.79-38.58-19.78-4.47-4.23-8.92-9.14-10.93-15.05-2.64-7.62-2.32-16.43 1.48-23.6a20.2 20.2 0 0 1 17.04-10.63c12.69-.78 23.87 4.19 36 4.7 7.82.14 15.89-1.05 23.18-3.9 11.37-4.8 21.29-14.52 32.86-19.16 7.35-3.04 15.07-4.58 23-3.05Z" fill="#000"/><path d="M538.01 569.9c6.94 2.53 12.73 7.89 15.12 14.96-2.94 2.53-5.85 5.05-9 7.3-3.6 2.63-7.19 4.4-9.93 8.04-3.23 3.94-5.95 9.87-10.37 12.5-3.4-.37-6.67-2.86-9.83-4.05-2.45-.6-5.4.47-7.8 1.06-12.17 3.53-24.57 5.15-37.2 5.87-3.23.07-6.43.2-9.59.95 0 1.24.06 2.45.3 3.68 1.86 1.5 5 1.35 7.3 1.46a191.17 191.17 0 0 0 45-7.29c3.68.11 9.34 5.23 13.89 3.53 5.34-2.5 8.93-9.06 12.36-13.63 1.89-2.72 4.5-4.05 7.17-5.86 3.36-2.22 6.46-4.74 9.56-7.28.65 5.61 1.08 11.34-.35 16.88-2.28 9.36-8.17 17.98-15.08 24.57-9.95 9.67-23.55 14.65-37.07 16.63-11.94 1.57-24.5 2.43-36.48.84-17.37-1.79-35.16-8.03-48.4-19.68-5.06-4.63-9.76-8.85-11.18-15.89-2.35-8.7.37-20.82 10.11-23.62 8.19-1.88 17.76.53 25.88 2.22 12.05 2.8 25.09 2.4 36.82-1.64 13.96-4.91 24.9-17.13 38.79-21.37 6.31-2.14 13.7-2.61 19.98-.17Z" fill="#fff"/>`,
    "variant22": (components, colors)=>`<path d="M514.98 571.8c9.94-.79 20.34-.67 29.5 3.7 4.76 2.28 8.77 6.1 9.74 11.45.87 5.24-1.16 9.93-4.1 14.14-5.1 7.1-13.02 12.35-20.61 16.48-16.5 8.76-34.08 12.05-52.5 13.76-20.25 3.08-41.64-1.62-59.12-12.17-6.2-3.9-12.82-9.26-16.03-16-2.56-5.26-2.25-12 1.93-16.37 4.77-5.2 12.43-7.15 19.2-7.88 15.6-1.27 30.57 2.31 44.79 8.5a117.73 117.73 0 0 1 47.2-15.61Z" fill="#000"/><path d="M540.41 580c-3.76 3.21-7.89 5.79-12.13 8.3-2.67 1.53-3.75 4.13-5.44 6.6a30.23 30.23 0 0 1-5.75 6.71c-3.02-1.1-5.96-2.85-9.11-3.5-3.03.45-5.9 1.87-8.86 2.66-10.02 2.86-20.67 5-31.12 4.92-2.95-.04-5.77.19-8.66.8.26 2.48-.5 4.68 2.82 5.02 14.67.86 29.74-2 43.63-6.66 4.74-2.07 7.69 3.08 12.84 1.72 4.35-1.27 7.37-6.6 9.92-10.06 1.78-2.8 4.43-4.12 7.14-5.82 3.66-2.24 6.97-4.85 10.35-7.47 1.44 2.56 3.17 4.68 2.42 7.82-1.4 6.39-6.6 11-11.48 14.92-12.52 9.5-28.96 14.76-44.24 17.66-14.5 1.98-28 4.19-42.61 1.47-12.77-2.46-26.17-7.5-36.14-16.1-3.77-3.4-8.37-8.52-7.81-14 .33-3.74 3.92-6.31 7.09-7.71 7.95-3.35 16.73-3.08 25.15-2.22 8.7 1.23 17.39 3.52 25.38 7.26 1.55.63 3.37 1.64 5.08 1.52 3.1-1.25 5.75-3.55 8.75-5.06a101.93 101.93 0 0 1 28.23-9.73c11.45-2.02 23.37-2.95 34.55.95Z" fill="#fff"/>`,
    "variant21": (components, colors)=>`<path d="M480.96 561.69c4.71-.58 10.26.05 13.71 3.66 3.78 3.9 4.15 9.42 3.22 14.53-2.65 11.8-12.87 21.43-24.84 23.27-7.5 1.5-15.57-.3-22.15-4.05-5.15-2.9-8.86-7.64-11.08-13.06-1.31-3.29-1.62-7.23-.43-10.59 1.3-3.11 4.12-5 7.34-5.7 5.66-1.83 11.66.27 16.63 3.05 4.58-5.09 10.57-10.17 17.59-11.1Z" fill="#000"/><path d="M480.51 567.7c3.3-1.03 7.38-.57 10 1.78 2.06 2.03 2.11 5.89 1.71 8.56-1.84 9.78-10.28 17.74-20.07 19.32-6.52 1.3-13.19-.33-18.84-3.68-4.3-2.52-7.44-6.98-8.81-11.72-.7-2.45-.36-5.07 2.04-6.38 2.59-1.08 5.76-1.02 8.48-.5 3.48.7 5.8 2.92 8.97 4.33 1.93-.09 2.62-1.39 3.81-2.64 3.32-3.94 7.69-7.62 12.7-9.07Z" fill="#8F2E45"/>`,
    "variant20": (components, colors)=>`<path d="M505.05 609.63c4.67 1.28 8.87 4.71 12.16 8.17 1.37 1.66 3.56 3.88 3.05 6.2-.46 2.46-3.75 3.02-5.05.83-2.6-3.53-5.52-6.54-9.45-8.58-2.27-1.46-6.72-.53-6.61-4.14.48-3.02 3.52-2.9 5.9-2.48ZM498 622.96a12.32 12.32 0 0 1 8.78 11.06c1.3 13.18-9.39 25.8-21.75 29.2-12.46 3.65-28.87-1.11-35.07-13.18-2.47-4.2-3.73-9.26-1.94-13.96 1.78-4.05 5.82-5.66 9.97-6.1 5.09-.6 9.55 1.11 13.9 3.54 3.82-4.04 7.74-7.6 12.91-9.8a20.02 20.02 0 0 1 13.2-.76Z" fill="#000"/><path d="M498.91 630.09c3.25 3.38 2.26 9.5.47 13.39-4.28 10.05-15.11 16.13-25.9 15-7.3-1.2-14.31-4.12-18.2-10.77-1.43-2.56-3.43-6.58-2-9.44 2.27-3.76 8.76-3.17 12.27-1.8 2.75.76 5.53 4.08 8.39 3.58 3.67-3.56 6.48-7.47 11.18-9.88 4.32-2.4 9.63-3.3 13.8-.08Z" fill="#8F2E45"/>`,
    "variant19": (components, colors)=>`<path d="M516.47 555.6c6.02 4.43 11.7 10 15.3 16.62 2.64 4.83 3.27 11.66-.42 16.13-4.14 5.37-11.5 7.58-17.88 8.76-15.67 2.47-31.9.95-47.46-1.6-5.74-1.11-10.18 1.63-16 2.55-8.7 1.6-18.36 2.92-27.06 1-5.13-1.02-10.28-3.2-13.34-7.65-2.78-3.87-2.64-9.34-1.12-13.67a37.3 37.3 0 0 1 7.04-11.24c1.33-1.74 3.08-1 4.97-1.12.3 1.84 1.06 3.23-.36 4.82-2.61 3.34-5.24 6.37-6.44 10.55-1.12 3.27-.33 6.93 2.4 9.14 3.03 2.37 7.16 3.47 10.93 3.87 7.78.5 15.57.14 23.16-1.73 5.6-1.06 9.96-3.57 15.81-2.5 12.03 1.92 23.78 3.44 36 2.8 6.92-.23 13.96-1.07 20.27-4.11 3.23-1.78 6.04-4.15 5.68-8.22-.27-6.05-6.07-11.79-10.25-15.7-2.5-2.65-6.66-4.09-6.02-8.36 1.8-.9 2.95-1.8 4.8-.34Z" fill="#000"/>`,
    "variant18": (components, colors)=>`<path d="M453.25 567.36c4.1-.57 8.25-.35 12.08 1.33 7.6 3.15 12.7 10.48 14.48 18.34 3.17 12.11-1.32 25.91-11.67 33.21-3.02 2.43-6.72 3.47-10.48 2.14-3.55-1.73-5.24-5.25-6.16-8.9-1.46-5.32 1.2-10.53.14-16.17-1-4.18-4.74-7.42-6.58-11.4-1.24-2.68-2.42-5.94-2.07-8.92.75-5.02 5.39-8.88 10.26-9.63Z" fill="#000"/>`,
    "variant17": (components, colors)=>`<path d="M462.23 552.76c5.89 1.34 11.98 4.52 15.69 9.38 1.25 2.25.03 5-2.77 4.63-2.26-1.24-3.96-3.38-6.13-4.8-4.31-2.87-9.86-4.48-15.03-3.68-2.57.45-5.36 1.6-6.83 3.86-1.53 2.1-1.3 4.76-.4 7.05 1.72 4.45 6 7.88 10.25 9.74 2.3 1.06 5.25 1.28 7.3 2.75 1.68 1.8.57 4.36-1.74 4.78-4.61 1.03-8.66 2.66-11.62 6.5-5.5 6.69-4.73 16.7 1.35 22.75 6.13 6.67 17.2 7.5 24.26 1.85 2.43-1.87 3.59-4.35 5.54-6.58 2.97-1.44 5.07 1.04 3.97 3.9-4.62 9.78-16.97 14.5-27.13 11.4a23.97 23.97 0 0 1-17.26-19.26c-1.55-9.44 3.19-18.64 11.31-23.48-5.73-2.95-10.81-7.86-12.37-14.28-1.54-5.3.8-11.27 5.45-14.2 4.69-3.25 10.76-3.16 16.16-2.31Z" fill="#000"/>`,
    "variant16": (components, colors)=>`<path d="M521.18 567.25c1.55-.38 3.33-1 4.93-.74 2 .78 2.04 3 1.05 4.64-4.12 2.62-10 2.81-14.26 4.89 3.42 13.46 3.76 27.5 0 40.93-3.26 12.19-10.2 24.02-20.7 31.3a35.76 35.76 0 0 1-24.22 6.54c-11.52-1.1-21.7-8.19-28.53-17.28-9.5-12.6-13.35-27.92-13.48-43.53.34-5.62.98-11.21 2.11-16.73-2.4-.78-5.59-1.13-7.5-2.84-.56-1.23-.2-2.85-.25-4.18 4.52-.02 8.3 1.66 12.66 2.56 29.55 5.95 59.5 3.04 88.2-5.56Z" fill="#000"/><path d="M506.94 577.11c5.23 17.71 3.27 38.43-6.69 54.17-4.13 6.48-9.68 11.96-16.73 15.17a29.31 29.31 0 0 1-25.4-.56c-8.06-4.02-14.57-11.42-18.7-19.32-7.58-14.67-9.44-32-5.52-48.03 10.46 2.5 21.07 3.05 31.77 3.27-1 6.74-.96 13.39-1.18 20.18 0 1.9-.16 4.1.5 5.92 1.09 1.71 4.65 1.2 4.75-1.06.58-8.4-.13-16.75 1.5-25.13 12-.25 24-2.21 35.7-4.62Z" fill="#EA869E"/>`,
    "variant15": (components, colors)=>`<path d="M469.99 539.64c9.45-.62 18.37 5.2 25.18 11.18 9.6 8.8 17.31 20.09 23.54 31.49a209.12 209.12 0 0 1 23.56 76.68c.5 4.4 1.53 8.68-2.43 11.86-7.32 3.5-15.84 4.95-23.84 6-15.97 1.39-32.52-.84-48-4.84-2.35-.75-4.52-.89-5.43-3.57a210.22 210.22 0 0 1-17.97-65.91c-1.01-12.34-1.07-24.9 1.8-37.02 1.62-6.56 4.25-13.27 8.72-18.42 3.72-4.3 9.1-7.4 14.87-7.45Z" fill="#000"/><path d="M474.49 545.63c9.4 2.08 17.07 9.35 23.35 16.25-13.95 5.98-30.9 9.6-45.86 5.81 1.27-6.17 3.77-12.91 8.25-17.5 3.6-3.78 9.07-5.9 14.26-4.56Z" fill="#fff"/><path d="M501.86 566.88c12.64 16.83 21.52 36.66 27.44 56.79-6.29 1.3-11.94 3.96-17.5 7.1-11.57 6.75-22.43 15.88-30.04 26.97-2.28 3.53-4.69 6.5-4.54 10.94a170.9 170.9 0 0 0-8.96-2.06c-8.42-17.85-13.97-37.13-16.92-56.63-1.6-12.46-2.48-24.55-.38-37.02 5.4 1.04 10.5 2.3 16.05 1.94 5-.39 10.05-.95 15-1.89 6.89-1.27 13.25-3.89 19.85-6.14Z" fill="#8F2E45"/><path d="M527.55 629.64c1.5-.65 2.4.12 3.76.63 2.74 11.73 5.07 23.5 5.63 35.56-7.95 3.25-16.2 4.63-24.68 5.56-10.48.94-20.25-.66-30.6-1.8a74.98 74.98 0 0 1 17.9-23c8.13-7.1 17.68-13.57 27.99-16.95Z" fill="#EA869E"/>`,
    "variant14": (components, colors)=>`<path d="M495.22 560.98c15.47 1.86 31.27 5.52 44.44 14.2 7.06 4.63 13.5 11.35 15.37 19.82 2.36 8.6-3.62 18.23-11.69 21.37-7.22 3.03-14.02 1.8-21.35.17a152.7 152.7 0 0 0-18-1.84c-22.55-.95-45.13.85-67.18 5.75-5.75 1-11.12 3.3-16.8 3.7a20.3 20.3 0 0 1-16.8-8.4c-3.08-4.2-4.42-9.63-4.29-14.77.6-7.76 5.39-14.89 11.17-19.87 9.77-8.61 22.9-13.67 35.4-16.81a157.08 157.08 0 0 1 49.72-3.32Z" fill="#000"/><path d="M505.97 568.6c-10.26 7.5-23.3 11.5-35.8 12.93-14.13 1.18-28.18.17-41.5-5 8.87-4.75 19.45-6.96 29.28-8.74 16.06-2.16 32.07-2.4 48.02.81Z" fill="#fff"/><path d="M513.77 570.3c11.07 3.23 22.56 7.72 30.43 16.52 4.18 4.76 6.93 11.23 4 17.39-3 6.16-9.66 8.56-16.2 7.98-22.43-4.47-46.27-4.38-68.96-2.05-12.25 1.6-24.14 3.39-36.04 6.83-5.67 1.38-11.31 2.18-16.17-1.8-6.59-5.25-7.4-14.6-3.5-21.74 3.43-5.84 8.9-10.26 14.65-13.66 4.08 2.55 8.45 3.7 13.04 4.97 21.88 5.68 46.86 3.96 67-6.71 4.27-2.11 7.81-5.14 11.75-7.73Z" fill="#8F2E45"/>`,
    "variant13": (components, colors)=>`<path d="M519 572.72c12.29.18 24.45 2.02 35.94 6.5a92.61 92.61 0 0 1 43.87 34.94c1.14 1.53.8 3.58.95 5.41-7.22.57-14.43-.04-21.67.76.12 7.4 0 14.39-3.75 21.02-2.2 3.77-5.7 7.2-10.34 7.12-4.5-.03-8.23-3.43-10.38-7.1-3.71-6.4-4.2-13.83-4.46-21.04-25.38.12-50.77.29-76.16.43-7.35-.26-14.65.67-22 .42-7.53-.2-14.18.78-21.52-.74.07-1.62-.5-4.04.59-5.37 22.4-25.3 54.86-41.81 88.93-42.35Z" fill="#000"/><path d="M508.98 579.48a152.3 152.3 0 0 1 21.04-.02 88.9 88.9 0 0 1 48.66 20.86c-11.23.4-22.44.62-33.68.58-30.98 1.14-62 .83-92.97 1.81 6.13-4.2 12.16-8.37 18.84-11.68a112.4 112.4 0 0 1 38.1-11.54Z" fill="#8F2E45"/><path d="M569 606.4c5.17 0 10.56-.64 15.68.04 2.37 2.05 4.27 4.7 6.31 7.09-5.88.61-11.88.05-17.7.77-1.23 7.11-.33 16.61-3.6 23.41-1.15 2.7-3.33 4.05-5.67 5.57-2.32-1.57-4.53-2.89-5.74-5.56-3.42-6.8-3.33-15.68-4.08-23.16-5.72-.52-11.4-.06-17.2-.19-32.79.26-65.57.28-98.36.54 2.11-2.04 4.57-5.6 7.5-6.24 17.96-.7 35.91-.24 53.86-1.1 11-.5 22-.08 33-.59 12-.24 24-.08 36-.57Z" fill="#6FA942"/>`,
    "variant12": (components, colors)=>`<path d="M550 573.51c1.46 0 3.54-.33 4.63.86 1.79 1.55.73 4.5-1.6 4.72-5.3.8-10.73.62-16.06 1.3-4.86.63-9.72 1.27-14.57 1.92a72.83 72.83 0 0 1 6.07 20.52c1.1 9.46.5 18.83-4.44 27.2a27.94 27.94 0 0 1-18.97 13.18c-9.3 1.52-18.57-.3-27.06-4.22-13.14-6.16-23.89-15.8-32.58-27.32-6.65 4.89-13 10.1-18.5 16.27-1.57 1.58-3.5 3.91-5.73 1.87-1.86-1.74-.28-4.03 1.06-5.54 9.67-10.78 21.93-19.53 34.63-26.4 28.47-15.26 61.04-22.5 93.12-24.35Z" fill="#000"/><path d="M516.86 583.39c1.15 3.94 2.8 7.7 3.96 11.64 2.13 6.95 2.55 14.24 1.79 21.44-1.11 7.19-4.63 14.3-11.1 18.07-7.43 4.5-16.62 4-24.65 1.5-15.04-4.85-26.95-15.23-36.46-27.58a164.36 164.36 0 0 1 29.3-14.53c1.71 2.36 3.26 5.1 5.41 7.07 1.42 1.48 4.45.11 4.09-2-.39-2.39-2.78-4.37-3.81-6.57-.12-.47.13-.76.75-.88 9.98-3.5 20.34-6.12 30.72-8.16Z" fill="#EA869E"/>`,
    "variant11": (components, colors)=>`<path d="M397.16 574.5c18.25-.16 37.53-.27 55.83-.38 15.65-.52 31.34-.22 47-.46 3.82-.04 7.34-.2 10.9 1.4 4.25 1.92 7.85 6.05 7.62 10.93.36 6.4-5.56 10.94-11.5 11.3-33 .13-66 .4-99 .56-4.38-.1-8.12 1-12.36-.48l-.82-2.29c1.66-5.65 2.44-11.14-.14-16.68-1.03-2.03.23-3.9 2.47-3.9Z" fill="#000"/><path d="M510.49 581.58c2.16 1.83 3.27 4.85 1.35 7.29-2.42 3.37-7.56 2.6-11.15 2.54-.04-4-.07-8-.08-12.02 3.35.28 7.2-.21 9.88 2.2ZM401.71 580.18l5.03-.02c.16 4.03.22 8.05.15 12.1h-5.12c.41-4.08.45-8-.06-12.08ZM412.52 580.16c4.52-.07 9.04-.06 13.57-.04.12 4 .23 8 .27 12-4.4.07-8.8.08-13.2.08-.22-4.02-.4-8.03-.64-12.04ZM432.14 579.88c6.32-.04 12.64-.05 18.96-.1.07 4 .1 8.02.1 12.03-6.34-.07-12.65.3-18.97.24-.13-4.06-.17-8.1-.09-12.17ZM456.8 579.78c6.23-.08 12.46-.06 18.7-.14.12 4 .24 8.03.3 12.04-6.2.13-12.4.03-18.6.18-.3-4.03-.4-8.05-.4-12.08ZM481.4 579.5c4.47.17 8.95.07 13.43.03.03 4 .06 8.03.01 12.05-4.43 0-8.85.13-13.28 0-.05-4.04-.29-8.05-.17-12.08Z" fill="#fff"/>`,
    "variant10": (components, colors)=>`<path d="M503.97 568.71c3.76-1.34 5.59 4 2.2 5.46-5.64 2.88-10.75 6.61-12.88 12.86-2.34 6.4.4 13.12 4.73 17.96 2.91 3.37 6.6 5.42 10.34 7.69 1.96 1.1 1.31 2.77 1.18 4.6-.86.35-1.71.71-2.57 1.08a36.97 36.97 0 0 1-15.83-12.5c-2.32-3.15-3.35-6.66-4.68-10.27-25.08 2.03-50.35 2.82-75.44 4.7-1.85-.3-2.44-2-3.5-3.32 1.11-1.2 1.69-2.66 3.52-2.77 17.31-.91 34.6-2.03 51.97-2.98 7.82-.76 15.69-.5 23.45-1.56 1.56-9.83 8.58-17.16 17.51-20.96Z" fill="#000"/>`,
    "variant09": (components, colors)=>`<path d="M496 576.26c3.08-.1 6.12-.07 9.17.33l1.28 2.39-1.25 2.47c-7.68.86-15.48.06-23.2.66-28.03.19-55.98.3-84.04.55-1.67.13-4.56-.53-4.37-2.68-.53-1.67 1.85-3.31 3.35-3.17 33.02-.15 66.04-.35 99.06-.55Z" fill="#000"/>`,
    "variant08": (components, colors)=>`<path d="M505.02 633.16c9.06.53 16.84 6.73 24.11 11.4-13.1-.12-26.35 2.18-38.98 5.54-9.44 2.61-18.6 6-27.08 10.96 3.26-8.09 7.87-18.07 16.6-21.4 4-1.93 7.7-1.13 11.94-.82 3.92-3.32 8-6.13 13.4-5.68Z" fill="#D31E1E"/><path d="M529.13 644.56c2.47.2 4.68 1.43 3.9 4.25-1.38 2.08-4.46 1.3-6.64 1.51-14.9.63-29.68 3.43-43.79 8.28-4.83 1.7-9.55 3.58-13.94 6.24-2 .93-3.37 2.59-5.67 1.42-2.15-1.55-1.16-3.48.08-5.2 8.48-4.96 17.64-8.35 27.08-10.96 12.63-3.36 25.89-5.66 38.98-5.54Z" fill="#000"/><path d="M526.39 650.32a39.78 39.78 0 0 1-24.48 18.5c-11 3.05-23.16 1.14-33.24-3.98 4.39-2.66 9.1-4.54 13.94-6.24a154.94 154.94 0 0 1 43.79-8.28Z" fill="#D31E1E"/>`,
    "variant07": (components, colors)=>`<path d="M484.8 621.32c16.47 4.7 28.68 20.38 30.53 37.23-2.5-6.68-5.83-12.9-10.9-18-7.02-7.19-17.25-12.19-27.45-11.67-8 .26-15.78 4.06-20.78 10.34-5.5 6.8-7.7 16.06-6.72 24.66-.69-4.65-1.85-9.1-1.76-13.88.06-8.73 3.26-17.5 9.96-23.32 7.32-6.42 17.9-8.12 27.12-5.36Z" fill="#D31E1E"/><path d="M476.98 628.88c10.2-.52 20.43 4.48 27.46 11.67 5.06 5.1 8.39 11.32 10.89 18 .52 3.48 2.26 6.4-1.37 8.77-8.33.15-16.63.8-24.96 1-12.3.95-24.72.47-36.92 1.94-1.96-1.87-2.34-3.75-2.6-6.38-.98-8.6 1.23-17.86 6.72-24.66a27.94 27.94 0 0 1 20.78-10.34Z" fill="#000"/><path d="M484.48 635.49c12.63 3.1 22.12 13.94 25.5 26.24-18.27.4-36.53 1.67-54.77 2.21-.7-8.6 1.23-17 7.57-23.16 5.82-5.68 13.94-7.02 21.7-5.29Z" fill="#fff"/><path d="M513.96 667.32c-9.3 7.26-23.55 8.73-34.96 9.09-8.63-.08-19.86-.57-26.92-6.15 12.2-1.47 24.63-1 36.92-1.94 8.33-.2 16.63-.85 24.96-1Z" fill="#D31E1E"/>`,
    "variant06": (components, colors)=>`<path d="M473 557.77c14.54-.55 30.84 1.36 43.71 8.62-20.68 8.7-43.2 14.72-65.7 15.48-7.24 0-14.34.28-21.54-.61.7-5.83 3.1-9.58 7.73-13.05 9.92-7.31 23.76-9.76 35.8-10.44Z" fill="#D31E1E"/><path d="M525.03 563.67c.41.78.8 1.57 1.14 2.37.47 2.66-1.95 3.31-3.8 4.34-4 1.77-8.06 3.4-12.13 4.98-17.66 6.32-35.39 11.11-54.24 11.94-6.5.5-12.94.62-19.44.04-4.9-.57-10.15-.63-14.87-2.03-2.35-.88-2.73-3.93-.4-5.07 2.68-.12 5.48.83 8.18 1.02 7.2.89 14.3.61 21.54.61 22.5-.76 45.02-6.79 65.7-15.48 2.76-1.19 5.22-2.6 8.32-2.72Z" fill="#000"/><path d="M510.24 575.36c-1.96 10.16-10.37 17.27-19.22 21.68a56.41 56.41 0 0 1-34 4.71c-8.7-1.77-16.5-6.13-20.46-14.4 6.5.57 12.94.45 19.44-.05 18.85-.83 36.58-5.62 54.24-11.94Z" fill="#D31E1E"/>`,
    "variant05": (components, colors)=>`<path d="M526 559.6c18 0 37.23 2.15 54 9.1-52.21 7.16-107.16 15.06-158.99 22.19 8.03-7 17.68-12.33 27.44-16.48 12.23-5.1 26.26-9.18 39.6-7.43.97.15 1.85.04 2.62-.34 10.24-5.9 23.77-6.7 35.33-7.05Z" fill="#D31E1E"/><path d="M579.99 568.69c2.42 1 1.92 3.4 1.38 5.45-6.78 13.35-16.08 25.18-28.35 33.9-17.2 12.5-38.88 18.4-60.02 17.58-26.81-.96-53.07-12.04-73.44-29.31-.4-2.42-.5-3.7 1.45-5.42 51.83-7.13 106.78-15.03 158.98-22.2Z" fill="#000"/><path d="M581.37 574.14c-1.1 4.61-1.85 9.2-3.65 13.62-5.36 13.94-16.05 25.4-28.38 33.56-13.59 8.87-29.26 14.15-45.36 15.89-19.66 2.09-40.79-1.1-58-11.18-11.77-6.82-21.38-17-26.42-29.72 20.37 17.27 46.63 28.35 73.44 29.31 21.14.82 42.83-5.1 60.02-17.58 12.27-8.72 21.57-20.55 28.35-33.9Z" fill="#D31E1E"/><path d="M573.86 575.51a83.4 83.4 0 0 1-36.37 35 89.24 89.24 0 0 1-40.5 9.18c-24.7.18-49-9.01-68.57-23.87 47.93-6.6 97.73-13.8 145.44-20.31Z" fill="#fff"/>`,
    "variant04": (components, colors)=>`<path d="M529.13 644.56c2.47.2 4.68 1.43 3.9 4.25-1.38 2.08-4.46 1.3-6.64 1.51-14.9.63-29.68 3.43-43.79 8.28-4.83 1.7-9.55 3.58-13.94 6.24-2 .93-3.37 2.59-5.67 1.42-2.15-1.55-1.16-3.48.08-5.2 8.48-4.96 17.64-8.35 27.08-10.96 12.63-3.36 25.89-5.66 38.98-5.54Z" fill="#000"/>`,
    "variant03": (components, colors)=>`<path d="M476.98 628.88c10.2-.52 20.43 4.48 27.46 11.67 5.06 5.1 8.39 11.32 10.89 18 .52 3.48 2.26 6.4-1.37 8.77-8.33.15-16.63.8-24.96 1-12.3.95-24.72.47-36.92 1.94-1.96-1.87-2.34-3.75-2.6-6.38-.98-8.6 1.23-17.86 6.72-24.66a27.94 27.94 0 0 1 20.78-10.34Z" fill="#000"/><path d="M484.48 635.49c12.63 3.1 22.12 13.94 25.5 26.24-18.27.4-36.53 1.67-54.77 2.21-.7-8.6 1.23-17 7.57-23.16 5.82-5.68 13.94-7.02 21.7-5.29Z" fill="#8F2E45"/>`,
    "variant02": (components, colors)=>`<path d="M525.03 563.67c.41.78.8 1.57 1.14 2.37.47 2.66-1.95 3.31-3.8 4.34-4 1.77-8.06 3.4-12.13 4.98-17.66 6.32-35.39 11.11-54.24 11.94-6.5.5-12.94.62-19.44.04-4.9-.57-10.15-.63-14.87-2.03-2.35-.88-2.73-3.93-.4-5.07 2.68-.12 5.48.83 8.18 1.02 7.2.89 14.3.61 21.54.61 22.5-.76 45.02-6.79 65.7-15.48 2.76-1.19 5.22-2.6 8.32-2.72Z" fill="#000"/>`,
    "variant01": (components, colors)=>`<path d="M579.99 568.69c2.42 1 1.92 3.4 1.38 5.45-6.78 13.35-16.08 25.18-28.35 33.9-17.2 12.5-38.88 18.4-60.02 17.58-26.81-.96-53.07-12.04-73.44-29.31-.4-2.42-.5-3.7 1.45-5.42 51.83-7.13 106.78-15.03 158.98-22.2Z" fill="#000"/><path d="M573.86 575.51a83.4 83.4 0 0 1-36.37 35 89.24 89.24 0 0 1-40.5 9.18c-24.7.18-49-9.01-68.57-23.87 47.93-6.6 97.73-13.8 145.44-20.31Z" fill="#8F2E45"/>`
};


/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ const $5abf718d8cdcb6ec$export$98222f1ebbc36891 = {
    "variant01": (components, colors)=>`<path d="M569 416.32c10.67-.28 21.35-.06 32.02-.26 13.97-.61 27.98-.37 41.98-.52 3.87.15 9-.18 12.21 2.31 2.36 1.63 2.22 5.59 2.35 8.14-.1 4.33-.28 9.38-2.3 13.3-5.08 1.98-11.45 1.25-16.85 1.9.43 12.27 1.67 24.57 1.31 36.84-.71 13.91-3.67 28-10.34 40.32-8.1 13.04-19.9 24.39-33.54 31.5-10.42 5.39-21.75 7.4-33.39 7.79-6.22.2-12.08.5-18.21-.84-9.48-2.04-18.88-4.45-26.96-10.06-11.14-7.58-19.27-18.77-25.4-30.6-6.6-13.57-10.15-29.24-13.27-43.94-.53-2.3-2.38-3.48-4.35-4.45-6.63-2.95-14.93-.5-18.8 5.6-.8 2.4-.9 5.14-1.16 7.65-.62 7.61-2.25 15.33-3.88 22.8-3.12 13.57-9 26.31-16.8 37.82-4.35 5.79-9.75 11.42-16.22 14.8-10.53 5.75-22.3 10.1-34.4 10.3-7.25-.2-14.16-.4-21.13-2.5-5.48-1.34-10.5-4.81-15.16-7.95-6.4-4.39-11.06-10.29-15.28-16.72a111.1 111.1 0 0 1-12.24-26.73c-2.84-9.45-5.24-18.8-5.19-28.73-4.55.66-9.39 2.23-14 1.95-4.35-.81-5.3-7.5-5.5-11.08.14-2.4-.15-6.76 2.7-7.68 21.6-9.82 44.44-17.06 67.54-22.42 17.03-3.7 34.73-8.24 52.27-6.65 11.18.94 22.83 3.92 31.72 11.06 3.2 2.41 5.43 6.83 9.38 7.6 7.08 1.82 14.45-1.24 20.89-3.97 3.63-9.99 10.02-17.33 19.06-22.81 6.3-3.84 13.67-6.15 20.7-8.28 16.76-4.03 33.14-4.65 50.24-5.5Z" fill="#000"/><path d="M307.1 478.16c1.2-1.2 3.4-.01 2.44 1.64-1.21 1.2-3.4 0-2.44-1.64Z" fill="#000"/><ellipse cx="605" cy="457.5" rx="14" ry="10.5" fill="#fff"/><ellipse cx="411" cy="476.11" rx="11" ry="8.11" fill="#fff"/>`,
    "variant02": (components, colors)=>`<path fill-rule="evenodd" clip-rule="evenodd" d="M608 415.8c6.19-.15 12.37-.17 18.55-.18 4.48-.01 8.97-.03 13.45-.1.56.02 1.13.02 1.7.02 3.1 0 6.25.02 9.3.5 2.58.53 5.61 1.94 6.1 4.83a38.9 38.9 0 0 1-1.15 17c-.46 1.76-1.74 2.09-3.35 2.33-3.46.36-6.95.57-10.42.78l-3.76.23c.12 4.28.38 8.64.64 13.02.7 11.72 1.4 23.63-.44 34.8a87.76 87.76 0 0 1-5.73 21.83c-3.11 8.55-9.1 16.19-15.42 22.62-9.83 10.36-22.25 18.39-36.2 21.8a115.5 115.5 0 0 1-33.23 2.17c-9.22-1.58-18.8-3.87-27.06-8.4-10.5-6.05-18.47-15.05-24.78-25.29-8.17-12.62-11.9-27.18-15.47-41.59-.52-2.19-.84-4.45-1.17-6.71-.42-2.83-.83-5.67-1.61-8.37-.48-1.78-2.64-3.07-4.17-3.9-6.7-3.36-16.4-.94-18.99 6.6-.5 2.84-.55 5.75-.6 8.66-.06 2.86-.11 5.73-.59 8.55-2 13.03-4.77 26.14-10.56 38.06-5.55 11.58-11.7 22.03-22.47 29.5-12.88 7.76-28.34 13.44-43.57 11.92-6.86-.15-14.05-1.4-20.36-4.13-6.87-3.71-13.8-8.11-18.84-14.16-10.32-12.28-16.95-27.7-20.8-43.17-1.86-6.83-3.03-13.81-2.96-20.9-1.64.23-3.27.55-4.9.87-2.4.46-4.79.93-7.2 1.16a5.27 5.27 0 0 1-5.36-2.69c-1.96-3.76-2.46-8.38-1.77-12.53l.12-.54c.23-1.1.47-2.3 1.61-2.79 27.43-12.56 55.94-20.6 85.48-26.45 11.24-2.31 22.47-3.81 33.98-3.07a61.95 61.95 0 0 1 28.86 7.05c10.79 4.81 24.5 5.41 35.15-.12 3.04-1.48 4.93-3.68 6.93-5.99a39.5 39.5 0 0 1 3.95-4.14c9.81-9.08 23.1-13.26 36.12-14.8 13.1-2.37 26.26-3 39.52-3.65l2.5-.12c5.54-.15 11.1-.15 16.65-.15 7.44 0 14.89 0 22.32-.36Zm-23 6.26c8.34-.34 16.32-.45 24.15 2.9.65.3 1.37.6 2.11.9 3.17 1.31 6.86 2.83 7.89 5.97 5.81 12.4 8.22 26.56 8.39 40.17.56 12.44-.87 25.5-5.2 37.22-3.72 9.79-10.5 17.11-18.26 23.88-5.21 4.32-11.62 7.5-17.78 10.22-9.15 3.83-19.3 6.8-29.3 6.15-5.8-.34-11.57-1.78-17.2-3.18l-.87-.23c-5.96-1.47-10.69-4.56-15.7-7.85l-.86-.56c-6.8-4.54-12.23-10.46-17.08-16.98-2.77-3.93-4.56-8.67-6.3-13.25l-1.22-3.16c-4.64-11.94-5.98-24.55-5.87-37.28.1-7.74 1.2-16.94 5.51-23.55 5.14-6.46 12.01-12.24 19.83-15.08 9.27-2.8 19.13-4.25 28.78-4.96 11.57-1.28 23.17-1.3 34.65-1.33H585Zm-172.35 22.06c-.9-.02-1.78-.04-2.66-.08-8.61-.87-17.85.94-26.5 2.63l-3.48.68c-2.29.52-4.57 1-6.84 1.5-9.4 2.01-18.63 4-27.68 7.65-.9.36-1.84.71-2.78 1.07-5.77 2.17-12.01 4.53-14.95 10.19-4.84 9.87-3.73 19.61-2.56 29.93l.37 3.3c1.93 11.76 6.83 23.24 13.14 33.32 5.06 8.01 10.9 15.08 19.42 19.57 12.78 7.1 27.95 6.15 41.4 1.57 11.36-4.43 21.76-9.82 28.56-20.38 8.84-14.04 13.92-30.65 15.47-47.12.91-9.38-.1-18.83-2.68-27.88-.46-1.39-.98-2.92-1.89-4.09-5.19-5.6-11.6-9.87-19.19-11.35-2.33-.4-4.76-.46-7.15-.51Z" fill="#000"/>`,
    "variant03": (components, colors)=>`<path fill-rule="evenodd" clip-rule="evenodd" d="M531.31 506.71c7.34 4.5 12.1 12.74 12.8 21.28.97 9.95-4.2 20.21-12.55 25.62-6.5 4.08-14.6 5.58-22.07 3.66-11.77-2.85-20.88-13.75-20.98-25.94-8.63-10.18-25.54-13.93-36.48-5.26-3.23 2.99-6.6 7.32-6.74 11.9-1.66 12.19-12 22.16-24.27 23.28-12.14 1.5-24.5-6.08-28.61-17.62-4.63-11.86-.12-25.8 10.5-32.77a27.95 27.95 0 0 1 25.69-2.42c7.77 3.11 13.23 9.62 16.01 17.4 5.32-6.87 13.8-10.32 22.4-10.1 8.25-.07 15.45 3.28 21.98 8.05 1.86-6.67 5.57-12.57 11.32-16.53a28.01 28.01 0 0 1 31-.55Zm-22.64 2.4a22.79 22.79 0 0 1 19.3 1.94 22.35 22.35 0 0 1 10.6 20.98c-.62 9.97-8.38 18.29-18.07 20.26-11.33 2.28-23.02-5.13-25.9-16.28a22.5 22.5 0 0 1 14.07-26.89Zm-70.58 15.78c-3.85-8.69-13.5-14.16-22.92-12.75A22.13 22.13 0 0 0 398.04 525a22.04 22.04 0 0 0 4.56 24.43 22.12 22.12 0 0 0 23.59 4.82c6.8-2.63 12.26-9 13.4-16.26.51-4.56.7-8.92-1.5-13.11Z" fill="#000"/>`,
    "variant04": (components, colors)=>`<path fill-rule="evenodd" clip-rule="evenodd" d="M577.04 416.1c16.03 2.47 31.24 9.63 42.99 20.86a80.3 80.3 0 0 1 24.24 45.54c1.78 12.34 1.1 25.15-2.8 37.04a79.23 79.23 0 0 1-25.44 37.5A79.64 79.64 0 0 1 564 575.23c-14.18-.1-28.4-4.38-40.5-11.72-23.74-14.43-38.9-41.4-38.21-69.26-4.95-5.36-10.7-9.6-18.3-9.71-7.78.07-14.32 5.68-17.23 12.6.78 6.7 1.53 13.27.63 20.02-1.7 15.12-8 29.64-18.58 40.66A70.05 70.05 0 0 1 382 579.83a69.6 69.6 0 0 1-35.05-8.76 69.78 69.78 0 0 1-32.3-38.71c-3.43-10.4-4.98-22.02-2.92-32.86a69.67 69.67 0 0 1 23.86-42.88c12.8-11.05 29.55-16.8 46.4-16.77 12.06.48 23.94 3.63 34.33 9.83a69.78 69.78 0 0 1 30.66 37.6c4.88-5.7 11.3-9.9 19.02-9.94 7.36-.37 14.18 2.55 19.7 7.27 1.7-8.66 3.83-17.07 7.9-24.97 8.88-18.08 24.8-32.3 43.62-39.33 12.7-4.85 26.4-5.96 39.82-4.2Zm-25.54 7.81c19.43-3.94 40.2.78 56.21 12.38 21.3 15.03 33 41.83 29.67 67.68a72.72 72.72 0 0 1-23.86 45.57 72.4 72.4 0 0 1-38.56 17.7 72.55 72.55 0 0 1-71.1-33.11c-9.1-14.4-13.1-32.28-10.5-49.16a72.47 72.47 0 0 1 18.06-38.53 72.54 72.54 0 0 1 40.08-22.53Zm-147.37 27.97c-11.18-4.55-23.8-5.55-35.62-3.26a62.64 62.64 0 0 0-36.57 22.34c-8.74 10.92-13.81 25.01-13.56 39.04-.22 16.16 6.52 32.29 17.9 43.73a62.42 62.42 0 0 0 30 17c15.46 3.52 32.04 1.39 45.78-6.67 15.41-8.7 26.57-24.55 30.12-41.82 2.14-12.06 1.31-24.55-3.44-35.92a62.7 62.7 0 0 0-34.61-34.44Z" fill="#000"/>`,
    "variant05": (components, colors)=>`<path fill-rule="evenodd" clip-rule="evenodd" d="M589 446.02c12.76.73 25.74 1.84 37.38 7.57 1.16.52 2.25 1.22 3.34 1.9 1.38.9 2.77 1.77 4.29 2.3 2.3.37 4.64.44 7 .52 2.67.09 5.35.18 7.95.7 2.16.77 2.3 2.83 2.42 4.8v1c-.02 2.19-.04 4.24-2.33 5.37-2.21.25-4.46.24-6.7.23h-3.17c1.26 18.16-2.42 36.45-11.5 52.28-9.66 17.1-25.26 30.69-43.86 37.2a78.74 78.74 0 0 1-34.82 4 81.36 81.36 0 0 1-42.57-18.29 88.7 88.7 0 0 1-28.74-44.53c-.9-2.9-1.46-5.9-2.02-8.9-.6-3.25-1.2-6.5-2.24-9.6-1.98-5.44-10.5-8.81-14.51-3.67-3.27 3.72-3.25 8.08-3.22 12.6.01 1.16.02 2.33-.03 3.5-.81 27.02-17.12 53.14-41.27 65.38-14.13 7.32-30.77 9.4-46.2 5.33a62.04 62.04 0 0 1-30.72-19.2c-10.8-12.26-16.55-28.93-16.8-45.17-.5-.12-1-.18-1.48-.24-1.41-.17-2.72-.33-3.35-1.96l-.07-.46c-.32-2.13-.83-5.46 1.42-6.47 1-.5 2.03-.92 3.05-1.33 2.19-.89 4.33-1.76 6.2-3.46 10.62-9.27 24.1-13.95 37.58-17.36a151.97 151.97 0 0 1 68.93-.89c5.82 1.39 12.08 1.59 17.77-.43 7.08-2.38 14.84-3.5 22.28-2.54 5.8.56 11.89.35 17.36-1.87 12.15-4.65 23.96-9.15 36.6-12.3a201.86 201.86 0 0 1 62.03-6Zm-25 12.94c17.65-.96 36.07-.78 53.28 3.73 7.14 1.68 13.37 8.09 14.26 15.47 1.3 7.9.28 15.57-1.36 23.32a80.57 80.57 0 0 1-24.67 39.05c-10.5 9.05-23.72 15.36-37.5 17.2-14.95 2.3-30.74-.6-44.13-7.61-14-7.22-25.74-19.05-33.2-32.89-5.27-10.71-8.3-23.62-6.34-35.5a98.03 98.03 0 0 1 20.17-10.3c18.9-7.2 39.37-10.89 59.48-12.47Zm-134.78 19.81a139.53 139.53 0 0 0-34.7-1.92c-15.93 1.2-31.36 3.69-46.39 9.31-5.22 2.04-10.6 4.52-15.04 7.97-4.12 2.85-5.47 9.18-5.69 13.85.33 8.92 3.64 17.87 8.04 25.57 7.92 13.73 21.5 23.9 37.06 27.1 9.84 2.21 19.97 1.39 29.56-1.56 26.32-8.35 46.38-34.3 46.64-62.1a46.96 46.96 0 0 0-1.45-10c-.29-1.64-1.75-2.49-3.1-3.26l-.58-.34c-4.48-2.24-9.46-3.65-14.35-4.63Z" fill="#000"/>`
};




function $7c99e9dbc740dad5$export$5bc6178a9a86ed74({ prng: prng, group: group, values: values = [] }) {
    const componentCollection = $dfcc38a2d5892cab$exports;
    const key = prng.pick(values);
    if (key && componentCollection[group][key]) return {
        name: key,
        value: componentCollection[group][key]
    };
    else return undefined;
}


function $87010df083fbc074$export$4e811121b221213b({ prng: prng, options: options }) {
    const eyesComponent = (0, $7c99e9dbc740dad5$export$5bc6178a9a86ed74)({
        prng: prng,
        group: "eyes",
        values: options.eyes
    });
    const eyebrowsComponent = (0, $7c99e9dbc740dad5$export$5bc6178a9a86ed74)({
        prng: prng,
        group: "eyebrows",
        values: options.eyebrows
    });
    const mouthComponent = (0, $7c99e9dbc740dad5$export$5bc6178a9a86ed74)({
        prng: prng,
        group: "mouth",
        values: options.mouth
    });
    const glassesComponent = (0, $7c99e9dbc740dad5$export$5bc6178a9a86ed74)({
        prng: prng,
        group: "glasses",
        values: options.glasses
    });
    return {
        "eyes": eyesComponent,
        "eyebrows": eyebrowsComponent,
        "mouth": mouthComponent,
        "glasses": prng.bool(options.glassesProbability) ? glassesComponent : undefined
    };
}


/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ function $44520426095d5e9a$export$6cee60e8aa85e528({ prng: prng, options: options }) {
    return {};
}


/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 * File: https://www.figma.com/file/XXfL2r5Wylk623KpxDt7gO
 */ const $b02ee546ce7bb6c8$export$4902baddc787debb = {
    "$schema": "http://json-schema.org/draft-07/schema#",
    "properties": {
        "backgroundColor": {
            "type": "array",
            "items": {
                "type": "string",
                "pattern": "^(transparent|[a-fA-F0-9]{6})$"
            },
            "default": [
                "f2d3b1",
                "ecad80",
                "9e5622",
                "763900"
            ]
        },
        "eyebrows": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "variant10",
                    "variant09",
                    "variant08",
                    "variant07",
                    "variant06",
                    "variant05",
                    "variant04",
                    "variant03",
                    "variant02",
                    "variant01",
                    "variant15",
                    "variant14",
                    "variant13",
                    "variant12",
                    "variant11"
                ]
            },
            "default": [
                "variant10",
                "variant09",
                "variant08",
                "variant07",
                "variant06",
                "variant05",
                "variant04",
                "variant03",
                "variant02",
                "variant01",
                "variant15",
                "variant14",
                "variant13",
                "variant12",
                "variant11"
            ]
        },
        "eyes": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "variant26",
                    "variant25",
                    "variant24",
                    "variant23",
                    "variant22",
                    "variant21",
                    "variant20",
                    "variant19",
                    "variant18",
                    "variant17",
                    "variant16",
                    "variant15",
                    "variant14",
                    "variant13",
                    "variant12",
                    "variant11",
                    "variant10",
                    "variant09",
                    "variant08",
                    "variant07",
                    "variant06",
                    "variant05",
                    "variant04",
                    "variant03",
                    "variant02",
                    "variant01"
                ]
            },
            "default": [
                "variant26",
                "variant25",
                "variant24",
                "variant23",
                "variant22",
                "variant21",
                "variant20",
                "variant19",
                "variant18",
                "variant17",
                "variant16",
                "variant15",
                "variant14",
                "variant13",
                "variant12",
                "variant11",
                "variant10",
                "variant09",
                "variant08",
                "variant07",
                "variant06",
                "variant05",
                "variant04",
                "variant03",
                "variant02",
                "variant01"
            ]
        },
        "glasses": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "variant01",
                    "variant02",
                    "variant03",
                    "variant04",
                    "variant05"
                ]
            },
            "default": [
                "variant01",
                "variant02",
                "variant03",
                "variant04",
                "variant05"
            ]
        },
        "glassesProbability": {
            "type": "integer",
            "minimum": 0,
            "maximum": 100,
            "default": 10
        },
        "mouth": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "variant30",
                    "variant29",
                    "variant28",
                    "variant27",
                    "variant26",
                    "variant25",
                    "variant24",
                    "variant23",
                    "variant22",
                    "variant21",
                    "variant20",
                    "variant19",
                    "variant18",
                    "variant17",
                    "variant16",
                    "variant15",
                    "variant14",
                    "variant13",
                    "variant12",
                    "variant11",
                    "variant10",
                    "variant09",
                    "variant08",
                    "variant07",
                    "variant06",
                    "variant05",
                    "variant04",
                    "variant03",
                    "variant02",
                    "variant01"
                ]
            },
            "default": [
                "variant30",
                "variant29",
                "variant28",
                "variant27",
                "variant26",
                "variant25",
                "variant24",
                "variant23",
                "variant22",
                "variant21",
                "variant20",
                "variant19",
                "variant18",
                "variant17",
                "variant16",
                "variant15",
                "variant14",
                "variant13",
                "variant12",
                "variant11",
                "variant10",
                "variant09",
                "variant08",
                "variant07",
                "variant06",
                "variant05",
                "variant04",
                "variant03",
                "variant02",
                "variant01"
            ]
        }
    }
};


const $4e56733ca8b21c4f$export$6990040ee07315 = {
    title: "Adventurer Neutral",
    creator: "Lisa Wischofsky",
    source: "https://www.figma.com/community/file/1184595184137881796",
    homepage: "https://www.instagram.com/lischi_art/",
    license: {
        name: "CC BY 4.0",
        url: "https://creativecommons.org/licenses/by/4.0/"
    }
};
const $4e56733ca8b21c4f$export$185802fd694ee1f5 = ({ prng: prng, options: options })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const components = (0, $87010df083fbc074$export$4e811121b221213b)({
        prng: prng,
        options: options
    });
    const colors = (0, $44520426095d5e9a$export$6cee60e8aa85e528)({
        prng: prng,
        options: options
    });
    return {
        attributes: {
            viewBox: "0 0 400 400",
            fill: "none",
            "shape-rendering": "auto"
        },
        body: `<g transform="translate(-279 -322)">${(_b = (_a = components.eyes) === null || _a === void 0 ? void 0 : _a.value(components, colors)) !== null && _b !== void 0 ? _b : ""}</g><g transform="translate(-279 -322)">${(_d = (_c = components.eyebrows) === null || _c === void 0 ? void 0 : _c.value(components, colors)) !== null && _d !== void 0 ? _d : ""}</g><g transform="translate(-279 -322)">${(_f = (_e = components.mouth) === null || _e === void 0 ? void 0 : _e.value(components, colors)) !== null && _f !== void 0 ? _f : ""}</g><g transform="translate(-279 -322)">${(_h = (_g = components.glasses) === null || _g === void 0 ? void 0 : _g.value(components, colors)) !== null && _h !== void 0 ? _h : ""}</g>`,
        extra: ()=>({
                ...Object.entries(components).reduce((acc, [key, value])=>{
                    acc[key] = value === null || value === void 0 ? void 0 : value.name;
                    return acc;
                }, {}),
                ...Object.entries(colors).reduce((acc, [key, value])=>{
                    acc[`${key}Color`] = value;
                    return acc;
                }, {})
            })
    };
};


const $bb232b36f1fe2e2b$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $bb232b36f1fe2e2b$export$2e2bcd8739ae039 = {
    randomUUID: $bb232b36f1fe2e2b$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $7493f90224f50eb4$var$getRandomValues;
const $7493f90224f50eb4$var$rnds8 = new Uint8Array(16);
function $7493f90224f50eb4$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$7493f90224f50eb4$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $7493f90224f50eb4$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$7493f90224f50eb4$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $7493f90224f50eb4$var$getRandomValues($7493f90224f50eb4$var$rnds8);
}


var $dd1e5b67f12bfe08$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $668d3d1516a55697$var$validate(uuid) {
    return typeof uuid === "string" && (0, $dd1e5b67f12bfe08$export$2e2bcd8739ae039).test(uuid);
}
var $668d3d1516a55697$export$2e2bcd8739ae039 = $668d3d1516a55697$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $63efddf3822947e6$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$63efddf3822947e6$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $63efddf3822947e6$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $63efddf3822947e6$var$byteToHex[arr[offset + 0]] + $63efddf3822947e6$var$byteToHex[arr[offset + 1]] + $63efddf3822947e6$var$byteToHex[arr[offset + 2]] + $63efddf3822947e6$var$byteToHex[arr[offset + 3]] + "-" + $63efddf3822947e6$var$byteToHex[arr[offset + 4]] + $63efddf3822947e6$var$byteToHex[arr[offset + 5]] + "-" + $63efddf3822947e6$var$byteToHex[arr[offset + 6]] + $63efddf3822947e6$var$byteToHex[arr[offset + 7]] + "-" + $63efddf3822947e6$var$byteToHex[arr[offset + 8]] + $63efddf3822947e6$var$byteToHex[arr[offset + 9]] + "-" + $63efddf3822947e6$var$byteToHex[arr[offset + 10]] + $63efddf3822947e6$var$byteToHex[arr[offset + 11]] + $63efddf3822947e6$var$byteToHex[arr[offset + 12]] + $63efddf3822947e6$var$byteToHex[arr[offset + 13]] + $63efddf3822947e6$var$byteToHex[arr[offset + 14]] + $63efddf3822947e6$var$byteToHex[arr[offset + 15]];
}
function $63efddf3822947e6$var$stringify(arr, offset = 0) {
    const uuid = $63efddf3822947e6$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $668d3d1516a55697$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $63efddf3822947e6$export$2e2bcd8739ae039 = $63efddf3822947e6$var$stringify;


function $aabe8926c96e6ccd$var$v4(options, buf, offset) {
    if ((0, $bb232b36f1fe2e2b$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $bb232b36f1fe2e2b$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $7493f90224f50eb4$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $63efddf3822947e6$export$8fb373d660548968)(rnds);
}
var $aabe8926c96e6ccd$export$2e2bcd8739ae039 = $aabe8926c96e6ccd$var$v4;



function $4867aed2c24f70f7$var$isPointInsidePolygon(point, polygon) {
    var x = point[0], y = point[1];
    var inside = false;
    for(var i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        var xi = polygon[i][0], yi = polygon[i][1];
        var xj = polygon[j][0], yj = polygon[j][1];
        var intersect = yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
var $4867aed2c24f70f7$var$polygons = [
    [
        [
            113.52657,
            22.21813
        ],
        [
            113.59708,
            22.21813
        ],
        [
            113.59708,
            22.20235
        ],
        [
            113.52657,
            22.20235
        ]
    ],
    [
        [
            113.52657,
            22.20235
        ],
        [
            113.59708,
            22.20235
        ],
        [
            113.59708,
            22.18844
        ],
        [
            113.52657,
            22.18844
        ]
    ],
    [
        [
            113.52657,
            22.18844
        ],
        [
            113.59708,
            22.18844
        ],
        [
            113.59708,
            22.17219
        ],
        [
            113.52657,
            22.17219
        ]
    ],
    [
        [
            113.52657,
            22.17219
        ],
        [
            113.59708,
            22.17219
        ],
        [
            113.59708,
            22.15202
        ],
        [
            113.52657,
            22.15202
        ]
    ],
    [
        [
            113.52657,
            22.15202
        ],
        [
            113.59708,
            22.15202
        ],
        [
            113.59708,
            22.13151
        ],
        [
            113.52657,
            22.13151
        ]
    ],
    [
        [
            113.52657,
            22.13151
        ],
        [
            113.59708,
            22.13151
        ],
        [
            113.59708,
            22.10932
        ],
        [
            113.52657,
            22.10932
        ]
    ]
];
const $4867aed2c24f70f7$var$placesArray = [
    "\u6FB3\u9580\u5317\u5340",
    "\u6FB3\u9580\u4E2D\u5340",
    "\u6FB3\u9580\u5357\u5340",
    "\u6C39\u4ED4",
    "\u8DEF\u6C39",
    "\u8DEF\u74B0",
    "unknown"
];
function $4867aed2c24f70f7$var$getUserWindow(users, userId) {
    // 找到當前用戶在數組中的索引
    let currentIndex = users.findIndex((user)=>user.id === userId);
    // 如果用戶不在數組中，則返回 1-5 筆記錄
    if (currentIndex === -1) currentIndex = 0;
    // 根據當前用戶的位置決定 slice 的起始和結束位置
    let start = Math.max(0, currentIndex - 2);
    let end = Math.min(users.length, currentIndex + 3);
    // 如果當前用戶是前兩名，則返回前五筆記錄
    if (currentIndex === 0 || currentIndex === 1) {
        start = 0;
        end = 5;
    } else if (currentIndex === users.length - 1 || currentIndex === users.length - 2) {
        start = Math.max(0, users.length - 5);
        end = users.length;
    }
    for(let i = start; i < end; i++)if (users[i]) users[i].rank = i + 1;
    // 返回用戶數組的一個子集
    return users.slice(start, end);
}
function $4867aed2c24f70f7$export$de27182ff8187d6c() {
    window.isModalOpen = false;
    $("#rank-close-btn").click(function() {
        $("#rank-modal").hide();
        if (window.targetFound && window.firstClicked) $("#score-wrapper").show();
        window.isModalOpen = false;
    });
    $("#rank-btn").click(async function() {
        window.isModalOpen = true;
        $("#rank-loader").show();
        $("#rank-list").empty();
        $("#rank-list").show();
        $("#rank-modal").show();
        if (window.targetFound) $("#score-wrapper").hide();
        await (0, $d25d7ab7a7801bef$export$482310739c8f9d71)();
        // loading
        fetch("/api/users", {
            method: "POST"
        }).then((response)=>response.json()).then((result)=>{
            const users = result?.data?.users;
            console.log(users);
            $("#rank-loader").hide();
            $("#rank-list").show();
            $4867aed2c24f70f7$var$getUserWindow(users, window.userId).forEach((user, index)=>{
                const avatar = (0, $544551a0c4b27db7$export$b595133eef38c254)((0, $4e56733ca8b21c4f$exports), {
                    seed: user.name
                });
                $("#rank-list").append(`
            <li class="flex justify-between gap-x-6 py-5 px-6 ${window.userId === user.id ? "bg-green-200" : ""}">
              <div class="flex min-w-0 gap-x-4">
                <img
                  class="h-12 w-12 flex-none rounded-full bg-gray-50"
                  src="${avatar.toDataUriSync()}"
                  alt=""
                />
                </div>
                <div class="min-w-0 flex items-center">
                  <p
                    class="text-3xl font-semibold leading-6 text-gray-900"
                  >
                    #${user.rank}
                  </p>
                </div>
                <div class="min-w-0 flex-auto flex items-center">
                  ${window.userId === user.id ? `
                        <p
                          class="rounded-md whitespace-nowrap mt-0.5 px-3 py-1 text-base font-medium ring-1 ring-inset text-green-600 bg-green-50 ring-green-500/10"
                        >
                          \u{60A8}!
                        </p>
                      ` : ""}
                </div>
              </div>
              <div class="shrink-0 flex items-center">
                <p id="${user.id}-score" class="count italic text-xl leading-6 text-gray-900" data-value="${user.score}">
                  ${user.score}
                </p>
              </div>
            </li>
          `);
            });
            $(".count").each(function() {
                $(this).prop("Counter", 0).animate({
                    Counter: $(this).data("value")
                }, {
                    duration: 500,
                    easing: "swing",
                    step: function(now) {
                        $(this).text(this.Counter.toFixed(0));
                    }
                });
            });
        });
    });
    $("#place-close-btn").click(function() {
        $("#place-modal").hide();
        if (window.targetFound && window.firstClicked) $("#score-wrapper").show();
        window.isModalOpen = false;
    });
    $("#place-btn").click(function() {
        window.isModalOpen = true;
        $("#place-loader").show();
        $("#place-list").hide();
        $("#place1").text("");
        $("#place2").text("");
        $("#place3").text("");
        $("#place4").text("");
        $("#place5").text("");
        $("#place6").text("");
        $("#place7").text("");
        $("#score1").text("");
        $("#score2").text("");
        $("#score3").text("");
        $("#score4").text("");
        $("#score5").text("");
        $("#score6").text("");
        $("#score7").text("");
        $("#place-modal").show();
        if (window.targetFound) $("#score-wrapper").hide();
        // 需要獲取用戶位置
        if (window.place === "unknown") {
            if ("geolocation" in navigator) {
                const timer = setTimeout(()=>{
                    $4867aed2c24f70f7$var$loadPlaceData();
                }, 5000);
                // geolocation 可用
                navigator.geolocation.getCurrentPosition(function(position) {
                    // 用戶授予權限
                    var latitude = position.coords.latitude;
                    var longitude = position.coords.longitude;
                    console.log("\u7DEF\u5EA6: " + latitude + ", \u7D93\u5EA6: " + longitude);
                    var geoCoordinate = [
                        longitude,
                        latitude
                    ];
                    let place = "unknown";
                    for(var i = 0; i < $4867aed2c24f70f7$var$polygons.length; i++)if ($4867aed2c24f70f7$var$isPointInsidePolygon(geoCoordinate, $4867aed2c24f70f7$var$polygons[i])) {
                        place = $4867aed2c24f70f7$var$placesArray[i];
                        break;
                    }
                    console.log(place);
                    if (window.initialized) fetch(`/api/place?userId=${window.userId}&place=${place}`, {
                        method: "POST"
                    }).then(()=>{
                        clearTimeout(timer);
                        window.place = place;
                        $4867aed2c24f70f7$var$loadPlaceData();
                    });
                    else {
                        clearTimeout(timer);
                        $4867aed2c24f70f7$var$loadPlaceData();
                    }
                }, function(error) {
                    clearTimeout(timer);
                    // 用戶拒絕權限或者其他錯誤
                    console.log("\u7121\u6CD5\u7372\u53D6\u4F4D\u7F6E: " + error.message);
                    $4867aed2c24f70f7$var$loadPlaceData();
                }, {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                });
            } else {
                // geolocation 不可用
                console.log("\u60A8\u7684\u700F\u89BD\u5668\u4E0D\u652F\u6301\u5730\u7406\u4F4D\u7F6E\u529F\u80FD\u3002");
                $4867aed2c24f70f7$var$loadPlaceData();
            }
        } else $4867aed2c24f70f7$var$loadPlaceData();
    });
    $("#photo-close-btn").click(function() {
        $("#photo-modal").hide();
        if (window.targetFound && window.firstClicked) $("#score-wrapper").show();
        window.isModalOpen = false;
    });
    window.photoBtnClicked = false;
    $("#photo-btn").click(function() {
        if (window.photoBtnClicked) return;
        window.photoBtnClicked = true;
        setTimeout(()=>{
            window.photoBtnClicked = false;
            window.isModalOpen = true;
            $("#photo-modal").show();
            $("#photo-loader").show();
            $("#photo-wrapper").hide();
            if (window.targetFound) $("#score-wrapper").hide();
            try {
                var video = document.querySelector("video");
                var videoStyle = window.getComputedStyle(video);
                // 创建新的 canvas 元素
                var newCanvas = document.createElement("canvas");
                // document.body.appendChild(newCanvas);
                // 将视频的 CSS 宽度和高度设置为新 canvas 的宽度和高度
                const scaledX = parseFloat(videoStyle.left) * -1;
                const scaledY = parseFloat(videoStyle.top) * -1;
                const scaleX = video.videoWidth / parseFloat(videoStyle.width);
                const scaleY = video.videoHeight / parseFloat(videoStyle.height);
                const oriX = scaledX * scaleX;
                const oriY = scaledY * scaleY;
                const oriWidth = video.videoWidth - oriX * 2;
                const oriHeight = video.videoHeight - oriY * 2;
                const scaledWidth = parseFloat(videoStyle.width) - scaledX * 2;
                const scaledHeight = parseFloat(videoStyle.height) - scaledY * 2;
                const height = 2048;
                const width = parseInt(height * scaledWidth / scaledHeight);
                newCanvas.width = width;
                newCanvas.height = height;
                var newContext = newCanvas.getContext("2d");
                // 确保视频已经加载了足够的数据
                if (video.readyState >= 2) {
                    // 从视频的可见部分截取图像，并绘制到新的 canvas 上
                    newContext.drawImage(video, oriX, oriY, oriWidth, oriHeight, 0, 0, width, height);
                    document.querySelector("a-scene").setAttribute("screenshot", {
                        width: width,
                        height: height
                    });
                    const canvas = document.querySelector("a-scene").components.screenshot.getCanvas("perspective");
                    newContext.drawImage(canvas, 0, 0);
                    newCanvas.toBlob((file)=>{
                        $4867aed2c24f70f7$var$save(file);
                    }, "image/jpeg", 0.9);
                } else console.error("Video is not ready.");
            } catch (error) {
                console.log(error);
            }
        }, 300);
    });
}
async function $4867aed2c24f70f7$var$save(file) {
    // save to s3
    const res = await fetch(`/api/upload-url?t=${Date.now()}&key=apps/redpacket/photos/${(0, $aabe8926c96e6ccd$export$2e2bcd8739ae039)() + ".png"}`, {
        method: "POST"
    });
    const result = await res.json();
    const { url: url, fields: fields } = result.data.post;
    console.log(result);
    const formData = new FormData();
    Object.entries({
        ...fields,
        file: file
    }).forEach(([key, value])=>{
        formData.append(key, value);
    });
    const upload = await fetch(url, {
        method: "POST",
        body: formData
    });
    if (upload.ok) {
        $("#photo-loader").hide();
        $("#photo-wrapper").show();
        const photoUrl = url + "/" + fields.key;
        $("#photo-wrapper > img").attr("src", photoUrl);
    } else console.error("Upload failed.");
}
function $4867aed2c24f70f7$var$loadPlaceData() {
    $("#your-place").text(window.place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : window.place);
    // loading
    fetch("/api/places", {
        method: "POST"
    }).then((response)=>response.json()).then((result)=>{
        const places = result?.data?.places;
        console.log(places);
        $("#place-loader").hide();
        $("#place-list").show();
        const arr = [
            ...$4867aed2c24f70f7$var$placesArray
        ];
        places.forEach((obj)=>{
            const place = obj.place;
            const index = arr.indexOf(place);
            if (index > -1) // 如果存在，使用 splice 移除它
            arr.splice(index, 1);
        });
        arr.forEach((item)=>{
            places.push({
                _sum: {
                    score: 0
                },
                place: item
            });
        });
        console.log(places);
        $("#place1").text(places[0].place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : places[0].place);
        $("#place2").text(places[1].place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : places[1].place);
        $("#place3").text(places[2].place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : places[2].place);
        $("#place4").text(places[3].place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : places[3].place);
        $("#place5").text(places[4].place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : places[4].place);
        $("#place6").text(places[5].place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : places[5].place);
        $("#place7").text(places[6].place === "unknown" ? "\u5176\u4ED6\u5730\u5340" : places[6].place);
        $("#score1").text(places[0]._sum.score);
        $("#score2").text(places[1]._sum.score);
        $("#score3").text(places[2]._sum.score);
        $("#score4").text(places[3]._sum.score);
        $("#score5").text(places[4]._sum.score);
        $("#score6").text(places[5]._sum.score);
        $("#score7").text(places[6]._sum.score);
        $("#score1").data("value", places[0]._sum.score);
        $("#score2").data("value", places[1]._sum.score);
        $("#score3").data("value", places[2]._sum.score);
        $("#score4").data("value", places[3]._sum.score);
        $("#score5").data("value", places[4]._sum.score);
        $("#score6").data("value", places[5]._sum.score);
        $("#score7").data("value", places[6]._sum.score);
        if (places[0].place === window.place) $("#place-item1").addClass("bg-green-200");
        else $("#place-item1").removeClass("bg-green-200");
        if (places[1].place === window.place) $("#place-item2").addClass("bg-green-200");
        else $("#place-item2").removeClass("bg-green-200");
        if (places[2].place === window.place) $("#place-item3").addClass("bg-green-200");
        else $("#place-item3").removeClass("bg-green-200");
        if (places[3].place === window.place) $("#place-item4").addClass("bg-green-200");
        else $("#place-item4").removeClass("bg-green-200");
        if (places[4].place === window.place) $("#place-item5").addClass("bg-green-200");
        else $("#place-item5").removeClass("bg-green-200");
        if (places[5].place === window.place) $("#place-item6").addClass("bg-green-200");
        else $("#place-item6").removeClass("bg-green-200");
        if (places[6].place === window.place) $("#place-item7").addClass("bg-green-200");
        else $("#place-item7").removeClass("bg-green-200");
        // https://stackoverflow.com/questions/23006516/jquery-animated-number-counter-from-zero-to-value
        $(".count").each(function() {
            $(this).prop("Counter", 0).animate({
                Counter: $(this).data("value")
            }, {
                duration: 500,
                easing: "swing",
                step: function(now) {
                    $(this).text(this.Counter.toFixed(0));
                }
            });
        });
    });
}


function $6f40c3a58f594b58$var$start() {
    // 開始頁面效果實現
    // 處理開始按鈕的事件
    (0, $a7693d6ebc438a4c$export$de27182ff8187d6c)();
    // AR 場景點擊事件
    // targetFound and lost 事件, 處理背景音樂
    (0, $d25d7ab7a7801bef$export$de27182ff8187d6c)();
    // disable mobile browser 的 pinch zoom 和 double tap zoom
    // warning 檢查
    (0, $92dc8dbec6af1b1e$export$de27182ff8187d6c)();
    // 背景音樂
    (0, $c80f86bf07cd69c6$export$de27182ff8187d6c)();
    // ui
    (0, $4867aed2c24f70f7$export$de27182ff8187d6c)();
}
$6f40c3a58f594b58$var$start();


//# sourceMappingURL=index.fc604afd.js.map
